/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		15: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"2b53691a","1":"ab2ee14d","2":"17c393a6","3":"8735d182","4":"2db0064e","5":"34ff48e9","6":"4aabb362","7":"1e9d2ab6","8":"4f416e99","9":"e7c8d9c9","10":"dd09ccd2","11":"1f611a3c","12":"32b9cb1a","13":"2dd819a0","14":"cbfeb872"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://static.persona.ly/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 55);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(62);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Trans__ = __webpack_require__(72);
/* unused harmony reexport Trans */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useTranslation__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__useTranslation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withTranslation__ = __webpack_require__(85);
/* unused harmony reexport withTranslation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translation__ = __webpack_require__(86);
/* unused harmony reexport Translation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(87);
/* unused harmony reexport I18nextProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withSSR__ = __webpack_require__(88);
/* unused harmony reexport withSSR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useSSR__ = __webpack_require__(38);
/* unused harmony reexport useSSR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context__ = __webpack_require__(10);
/* unused harmony reexport I18nContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["g"]; });
/* unused harmony reexport setDefaults */
/* unused harmony reexport getDefaults */
/* unused harmony reexport setI18n */
/* unused harmony reexport getI18n */
/* unused harmony reexport composeInitialProps */
/* unused harmony reexport getInitialProps */









/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isAuthenticated */
/* harmony export (immutable) */ __webpack_exports__["o"] = isEnter;
/* harmony export (immutable) */ __webpack_exports__["p"] = isSimplePage;
/* unused harmony export spanReplacer */
/* unused harmony export linkReplacer */
/* harmony export (immutable) */ __webpack_exports__["t"] = tagger;
/* harmony export (immutable) */ __webpack_exports__["s"] = spanirizerByString;
/* unused harmony export SITE_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UNKNOWN_SERVER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCENT_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCENT_TEXT_FW500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACCENT_TEXT_FW700; });
/* unused harmony export ACCENT_TEXT_FW700_M500 */
/* unused harmony export ACCENT_TEXT_FW700_T500 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AQUA_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AQUA_TEXT_FW500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOPBAR_COLOR_RED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOPBAR_COLOR_ACCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOPBAR_COLOR_AQUA; });
/* harmony export (immutable) */ __webpack_exports__["j"] = errorSwitcher;
/* harmony export (immutable) */ __webpack_exports__["m"] = goToElementId;
/* harmony export (immutable) */ __webpack_exports__["n"] = goToHash;
/* harmony export (immutable) */ __webpack_exports__["l"] = getSignUpPath;
/* harmony export (immutable) */ __webpack_exports__["k"] = getFont;
/* unused harmony export setFont */
/* harmony export (immutable) */ __webpack_exports__["u"] = updateMuliFont;
/* harmony export (immutable) */ __webpack_exports__["r"] = setTitleFont;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return localeToInternalLang; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locales__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__storage__ = __webpack_require__(40);



function isAuthenticated() {
    if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__storage__["a" /* StorageKey */].Authenticated) === 'true') {
        return true;
    }
    return false;
}
function isEnter(e) {
    if (e.key == 'Enter') {
        return true;
    }
    return false;
}
var menuDisabledPageList = [
    '/white_papers/ghost_completes_mr_05_2020/'
];
function isSimplePage(path) {
    return path != '/' && menuDisabledPageList.some(function (url) { return url.includes(path); });
}
function spanReplacer(text, html) {
    if (text) {
        /* alternate \/[*].*\*[\/] */
        var result = text.replace(/\/\*[^*]*\*\//g, html);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: { __html: result } });
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null);
    }
}
function linkReplacer(text, html) {
    if (text) {
        var result = text.replace(/\/#[^#]*#\//g, html);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: { __html: result } });
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null);
    }
}
function tagger(text, className, defaultLink, newTab) {
    var resultText = text;
    var textHtml = function (s) { return '<span class=\"' + className + '\">' + s.substring(2, s.length - 2) + '</span>'; };
    resultText = resultText.replace(/\/\*[^*]*\*\//g, textHtml);
    var linkHtml = function (s) {
        var _a;
        // link format can be text#=url
        var innerText = s.substring(2, s.length - 2);
        var link = defaultLink;
        if (innerText.split('#=').length == 2 && !defaultLink) {
            _a = innerText.split('#='), innerText = _a[0], link = _a[1];
        }
        return '<a href=\"' + (link ? link : innerText) + '\" class=\"' + className + '\"' + (newTab ? 'target=\"_blank\" rel=\"noopener noreferrer\"' : '') + '>' + innerText + '</a>';
    };
    resultText = resultText.replace(/\/#.*?#\//g, linkHtml);
    return resultText ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: { __html: resultText } }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null);
}
function spanirizerByString(text, searchString, className) {
    var html = function (s) { return '<span class=\"' + className + '\">' + s + '</span>'; };
    var result = text.replace(new RegExp(searchString, 'g'), html);
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: { __html: result } });
}
var SITE_NAME = 'persona';
var UNKNOWN_SERVER_ERROR = [{ 'unknown': 'server error' }];
var ACCENT_TEXT = 'accent-text';
var ACCENT_TEXT_FW500 = 'accent-text fw500';
var ACCENT_TEXT_FW700 = 'accent-text fw700';
var ACCENT_TEXT_FW700_M500 = 'accent-text fw700m500';
var ACCENT_TEXT_FW700_T500 = 'accent-text fw700t500';
var AQUA_TEXT = 'aqua-text';
var AQUA_TEXT_FW500 = 'aqua-text fw500';
var TOPBAR_COLOR_RED = { buttonColor: 'button-outline animated red', hoverColor: 'red-c', linkColor: 'red-l' };
var TOPBAR_COLOR_ACCENT = { buttonColor: 'button-outline animated accent', hoverColor: 'accent-c', linkColor: 'accent-l' };
var TOPBAR_COLOR_AQUA = { buttonColor: 'button-outline animated aqua', hoverColor: 'aqua-c', linkColor: 'aqua-l' };
function errorSwitcher(errors) {
    var name = [];
    var skype = [];
    var company = [];
    var email = [];
    var pass = [];
    var other = [];
    var appSearchQuery = [];
    errors.forEach(function (err) {
        var key = Object.keys(err)[0];
        switch (key) {
            case 'email':
                email.push(err[key]);
                break;
            case 'password':
                pass.push(err[key]);
                break;
            case 'companyName':
                company.push(err[key]);
                break;
            case 'name':
                name.push(err[key]);
                break;
            case 'skype':
                skype.push(err[key]);
                break;
            case 'appSearchQuery':
                appSearchQuery.push(err[key]);
                break;
            default:
                other.push(err[key]);
        }
    });
    return { name: name, skype: skype, company: company, email: email, pass: pass, other: other, appSearchQuery: appSearchQuery };
}
function goToElementId(elementId, smooth) {
    var targetElement = document.getElementById(elementId);
    if (targetElement) {
        targetElement.scrollIntoView(smooth ? { behavior: 'smooth' } : undefined);
    }
}
function goToHash(props) {
    var hash = props.location.hash.substring(1);
    if (hash) {
        goToElementId(hash, false);
    }
}
function getSignUpPath(pathname) {
    switch (pathname) {
        case '/rtb':
            return 'contact';
        case '/market-research':
            return 'mrcontact';
        default:
            return 'sign_up';
    }
}
function getFont(i18n) {
    switch (i18n.language) {
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].ru:
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].ruRU:
            return { fontFamily: 'Ubuntu, sans-serif' };
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].ja:
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].jaJP:
            return { fontFamily: 'Noto Sans JP, sans-serif' };
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].ko:
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].koKR:
            return { fontFamily: 'Noto Sans KR, sans-serif' };
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].zh:
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].zhCN:
            return { fontFamily: 'Noto Sans SC, sans-serif' };
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].id:
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].idID:
            return { fontFamily: 'Maven Pro, sans-serif' };
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].en:
        case __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].enUS:
        default:
            return { fontFamily: 'Maven Pro, sans-serif' };
    }
}
function setFont(font) {
    var tElements = document.getElementsByClassName('muli');
    var titles = Array.from(tElements);
    titles.forEach(function (t) { return t.style.fontFamily = font; });
}
function updateMuliFont(lang) {
    setFont(lang.includes(__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].en) ? 'Muli, sans-serif' : '');
}
function setTitleFont(lang) {
    if (lang.includes(__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].en)) {
        setFont('Muli, sans-serif');
    }
}
var en = { flag: 'https://static.persona.ly/images/usa.svg', apiLang: 'en' };
var cn = { flag: 'https://static.persona.ly/images/china.svg', apiLang: 'cn' };
var jp = { flag: 'https://static.persona.ly/images/japan.svg', apiLang: 'jp' };
var kr = { flag: 'https://static.persona.ly/images/korea.svg', apiLang: 'kr' };
var ru = { flag: 'https://static.persona.ly/images/russia.svg', apiLang: 'ru' };
var id = { flag: 'https://static.persona.ly/images/indonesia.svg', apiLang: 'id' };
var localeToInternalLang = new Map([
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].en, en],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].enUS, en],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].zh, cn],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].zhCN, cn],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].ja, jp],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].jaJP, jp],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].ko, kr],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].koKR, kr],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].ru, ru],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].ruRU, ru],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].id, id],
    [__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* locales */].idID, id]
]);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_baseApi__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(42);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var Api = /** @class */ (function (_super) {
    __extends(Api, _super);
    function Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Api.prototype.hiring = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest('https://sdk.persona.ly/cms/api/career?page=1&perPage=20')];
            });
        });
    };
    Api.prototype.reviews = function (language) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest('https://sdk.persona.ly/cms/api/testimonial?page=1&perPage=100&language=' + language)];
            });
        });
    };
    Api.prototype.blog = function (numberOnPage) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest('https://persona.ly/blog/wp-json/api/v1/list-posts?records=' + numberOnPage)];
            });
        });
    };
    Api.prototype.events = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest('https://sdk.persona.ly/cms/api/event?page=1&perPage=4')];
            });
        });
    };
    Api.prototype.postApplicantCvData = function (payload) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest('https://sdk.persona.ly/cms/api/jobApplicant', {
                        method: 'POST',
                        body: payload,
                    }, true)];
            });
        });
    };
    Api.prototype.postContactFormData = function (payload) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest('https://sdk.persona.ly/cms/api/user/contact', {
                        method: 'POST',
                        body: payload
                    })];
            });
        });
    };
    Api.prototype.postGhostCompletionsFormData = function (payload) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest(__WEBPACK_IMPORTED_MODULE_0__base_baseApi__["b" /* configuration */].basePath + '/createsend', {
                        method: 'POST',
                        body: payload
                    })];
            });
        });
    };
    Api.prototype.resetPass = function (email) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest('https://sdk.persona.ly/cms/api/user/forgotPassword', {
                        method: 'POST',
                        body: JSON.stringify({ email: email })
                    })];
            });
        });
    };
    Api.prototype.login = function (email, password) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest('https://sdk.persona.ly/cms/api/user/signin', {
                        method: 'POST',
                        body: JSON.stringify({ email: email, password: password })
                    })];
            });
        });
    };
    Api.prototype.register = function (data) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest('https://sdk.persona.ly/cms/api/user/signup', {
                        method: 'POST',
                        body: JSON.stringify(data)
                    })];
            });
        });
    };
    Api.prototype.appStoreApp = function (bundleId, searchParams) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest(__WEBPACK_IMPORTED_MODULE_0__base_baseApi__["b" /* configuration */].basePath + '/get-bundle-info', {
                        method: 'POST',
                        body: JSON.stringify(__assign({ bundleId: bundleId }, searchParams))
                    })];
            });
        });
    };
    Api.prototype.runCalculating = function (bundleId, searchParams) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sendRequest(__WEBPACK_IMPORTED_MODULE_0__base_baseApi__["b" /* configuration */].basePath + '/get-bundle-vectors', {
                        method: 'POST',
                        body: JSON.stringify(__assign({ bundleId: bundleId }, searchParams))
                    })];
            });
        });
    };
    Api.prototype.sendRequest = function (url, options, multipart) {
        if (options === void 0) { options = { method: 'GET' }; }
        return __awaiter(this, void 0, Promise, function () {
            var response, json, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.fetch(url, options, multipart)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, Promise.resolve(json)];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_1__fetch__["b" /* processError */])(error_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Api;
}(__WEBPACK_IMPORTED_MODULE_0__base_baseApi__["a" /* BaseApi */]));
var api = new Api();


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserRouter */
/* unused harmony export HashRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(17);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(25);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, {}, activeStyle) : styleProp;

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(67)();
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return locales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return availableLocales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentLocale; });
var locales = Object.freeze({
    en: 'en',
    enUS: 'en-US',
    zh: 'zh',
    zhCN: 'zh-CN',
    ja: 'ja',
    jaJP: 'ja-JP',
    ko: 'ko',
    koKR: 'ko-KR',
    ru: 'ru',
    ruRU: 'ru-RU',
    id: 'id',
    idID: 'id-ID',
});
var availableLocales = [locales.en, locales.ru, locales.ja, locales.ko, locales.zh, locales.id];
var getCurrentLocale = function (dontPassDefaultEn) {
    var possibleLocale = window.location.pathname.slice(1, 3);
    return availableLocales.includes(possibleLocale)
        ? possibleLocale
        : (dontPassDefaultEn ? '' : locales.en);
};


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_infoBlock__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_topbar__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_common_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pageContent__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_util__ = __webpack_require__(2);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};








var AppContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({
    topbarColor: undefined,
    utmParameters: undefined,
    setAboutIsMounted: function () { return null; },
    setTopbarColor: function () { return null; }
});
var App = function (props) {
    var parseCookies = function () {
        var cookieStr = document.cookie;
        var cookieObj = {};
        if (cookieStr) {
            cookieObj = cookieStr.split(/; */).reduce(function (obj, str) {
                if (str === '')
                    return obj;
                var eq = str.indexOf('=');
                var key = eq > 0 ? str.slice(0, eq) : str;
                var val = eq > 0 ? str.slice(eq + 1) : null;
                if (val != null) {
                    try {
                        val = decodeURIComponent(val);
                    }
                    catch (ex) {
                        /* pass */
                    }
                }
                obj[key] = val;
                return obj;
            }, {});
        }
        return cookieObj;
    };
    var parseUtmParameters = function () {
        var locationStr = props.location.search.substring(1);
        var locationObj = {};
        if (locationStr) {
            var str = '{"' + decodeURI(locationStr).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}';
            locationObj = JSON.parse(str);
        }
        var isUtm = function (obj) { return obj.utm_source || obj.utm_content || obj.utm_campaign || obj.gclid || obj.utm_medium || obj.utm_term || obj.url; };
        if (isUtm(locationObj)) {
            localStorage.setItem('utm', JSON.stringify(locationObj));
        }
        else {
            var storageObj = JSON.parse(localStorage.getItem('utm') || '{}');
            if (isUtm(storageObj)) {
                locationObj = storageObj;
            }
            else {
                var cookieObj = parseCookies();
                if (isUtm(cookieObj)) {
                    /* eslint-disable */
                    var utm_source = cookieObj.utm_source;
                    var utm_content = cookieObj.utm_content;
                    var utm_campaign = cookieObj.utm_campaign;
                    var gclid = cookieObj.gclid;
                    var utm_medium = cookieObj.utm_medium;
                    var utm_term = cookieObj.utm_term;
                    var url = cookieObj.url;
                    var utm = { utm_source: utm_source, utm_campaign: utm_campaign, utm_content: utm_content, utm_medium: utm_medium, utm_term: utm_term, gclid: gclid, url: url };
                    /* eslint-enable */
                    localStorage.setItem('utm', JSON.stringify(utm));
                    locationObj = utm;
                }
            }
        }
        return locationObj;
    };
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), about = _a[0], setAbout = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_6__util_util__["f" /* TOPBAR_COLOR_ACCENT */]), topbarColor = _b[0], setTopbarColor = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}), utmParameters = _c[0], setUtmParameters = _c[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        props.history.listen(function (location) {
            if (!location.hash) {
                window.scrollTo(0, 0);
            }
        });
        setUtmParameters(parseUtmParameters());
    }, []);
    var path = props.location.pathname;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setAbout(path.includes('/about'));
    }, [path]);
    // const WaitingComponent = (Component) => {
    //     // eslint-disable-next-line react/display-name
    //     return props => (
    //         <Suspense fallback={<div>Loading...</div>}>
    //             <Component {...props} />
    //         </Suspense>
    //     )
    // }
    var simple = Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["p" /* isSimplePage */])(path);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AppContext.Provider, { value: {
            topbarColor: topbarColor,
            utmParameters: utmParameters,
            setAboutIsMounted: function (isMounted) { return setAbout(isMounted); },
            setTopbarColor: function (topbarColor) { return setTopbarColor(topbarColor); }
        } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_helmet__["a" /* Helmet */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Persona.ly - Machine Learning Driven Mobile User Acquisition"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "title", content: "Persona.ly - Machine Learning Driven Mobile User Acquisition" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Persona.ly is a tech product company driving mobile user acquisition for brands and app developers, operating world-wide. Using our proprietary bidder and machine-learning algorithms Persona.ly offers transparent, performance-based, highly-targeted app install and retargeting solutions" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "keywords", content: "User Acquisition, Programmatic User Acquisition, Mobile UA, Mobile Monetization, Market Research" })),
        !simple && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_topbar__["a" /* default */], __assign({}, props))),
        about && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "about-video-top" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("video", { src: "https://static.persona.ly/images/about/video_about.mp4", autoPlay: true, loop: true, playsInline: true, muted: true })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { height: '100vh' } }) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__pageContent__["a" /* default */], __assign({}, props))),
        !simple && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_infoBlock__["a" /* default */], null))));
};
/* harmony default export */ __webpack_exports__["b"] = (App);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _animation = __webpack_require__(126);

Object.keys(_animation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _animation[key];
    }
  });
});

var _common = __webpack_require__(127);

Object.keys(_common).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _common[key];
    }
  });
});

var _debug = __webpack_require__(128);

Object.keys(_debug).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _debug[key];
    }
  });
});

var _elements = __webpack_require__(129);

Object.keys(_elements).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _elements[key];
    }
  });
});

var _swipe = __webpack_require__(130);

Object.keys(_swipe).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _swipe[key];
    }
  });
});

var _timers = __webpack_require__(131);

Object.keys(_timers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _timers[key];
    }
  });
});

var _math = __webpack_require__(132);

Object.keys(_math).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _math[key];
    }
  });
});

var _style = __webpack_require__(133);

Object.keys(_style).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _style[key];
    }
  });
});

var _classnames = __webpack_require__(134);

Object.keys(_classnames).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _classnames[key];
    }
  });
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelmetExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_side_effect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_assign__);






var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};

var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = __WEBPACK_IMPORTED_MODULE_4_object_assign___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _babelHelpers$extends4;

                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = convertReactPropstoHtmlAttributes(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set$$1(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);
        return HelmetWrapper;
    }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
        base: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        bodyAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
        defaultTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        defer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        encodeSpecialCharacters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        htmlAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        meta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        noscript: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        onChangeClientState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        script: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        titleAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        titleTemplate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20)))

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return I18nContext; });
/* harmony export (immutable) */ __webpack_exports__["h"] = usedI18nextProvider;
/* harmony export (immutable) */ __webpack_exports__["e"] = getHasUsedI18nextProvider;
/* unused harmony export setDefaults */
/* harmony export (immutable) */ __webpack_exports__["d"] = getDefaults;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReportNamespaces; });
/* unused harmony export setI18n */
/* harmony export (immutable) */ __webpack_exports__["f"] = getI18n;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return initReactI18next; });
/* harmony export (immutable) */ __webpack_exports__["c"] = composeInitialProps;
/* unused harmony export getInitialProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  // nsMode: 'fallback' // loop through all namespaces given to hook, HOC, render prop for key lookup
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  // hashTransKey: key => key // calculate a key for Trans component based on defaultValue
  useSuspense: true
};
var i18nInstance;
var hasUsedI18nextProvider;
var I18nContext = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createContext();
function usedI18nextProvider(used) {
  hasUsedI18nextProvider = used;
}
function getHasUsedI18nextProvider() {
  return hasUsedI18nextProvider;
}
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread({}, defaultOptions, {}, options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces =
/*#__PURE__*/
function () {
  function ReportNamespaces() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread({}, componentsInitialProps, {}, i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  }; // Avoid async for now - so we do not need to pull in regenerator
  // return async ctx => {
  //   const componentsInitialProps = ForComponent.getInitialProps
  //     ? await ForComponent.getInitialProps(ctx)
  //     : {};
  //   const i18nInitialProps = getInitialProps();
  //   return {
  //     ...componentsInitialProps,
  //     ...i18nInitialProps,
  //   };
  // };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _vanillaSwipe = __webpack_require__(117);

var _vanillaSwipe2 = _interopRequireDefault(_vanillaSwipe);

var _utils = __webpack_require__(8);

var Utils = _interopRequireWildcard(_utils);

var _views = __webpack_require__(135);

var Views = _interopRequireWildcard(_views);

var _propTypes = __webpack_require__(141);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AliceCarousel = function (_React$PureComponent) {
  _inherits(AliceCarousel, _React$PureComponent);

  function AliceCarousel(props) {
    _classCallCheck(this, AliceCarousel);

    var _this = _possibleConstructorReturn(this, (AliceCarousel.__proto__ || Object.getPrototypeOf(AliceCarousel)).call(this, props));

    _this._handleOnWindowResize = function (e) {
      var shouldHandleResizeEvent = _this.props.shouldHandleResizeEvent;

      var currentDimensions = Utils.getElementDimensions(_this.rootComponent);
      var shouldProcessEvent = shouldHandleResizeEvent || Utils.shouldHandleResizeEvent;

      if (shouldProcessEvent(e, _this.rootComponentDimensions, currentDimensions)) {
        _this.rootComponentDimensions = currentDimensions;
        _this._disableAnimation();
        _this._handleOnMouseEnter();

        var isAnimationCanceled = _this._isSwipeAnimationProcessing();
        var currState = Utils.calculateInitialProps(_this.props, _this.stageComponent);
        var translate3d = Utils.getTranslate3dPosition(currState.currentIndex, currState);
        var nextState = _extends({}, currState, { translate3d: translate3d, isAnimationCanceled: isAnimationCanceled, initialStageHeight: 0 });

        if (isAnimationCanceled) Utils.animate(_this.stageComponent, translate3d);

        _this.setState(nextState, function () {
          _this._resetAllIntermediateProps();
          _this._handleOnMouseLeave();
          _this._onResized();
        });
      }
    };

    _this._handleOnAnimationCanceled = function () {
      _this._resetAllIntermediateProps();
      _this.setState({ isAnimationCanceled: false });
    };

    _this._handleOnKeyUp = function (e) {
      switch (e.code) {
        case 'Space':
          return _this._handleOnSpaceBarClick();
        case 'ArrowLeft':
          return _this.slidePrev();
        case 'ArrowRight':
          return _this.slideNext();
      }
    };

    _this._handleOnSpaceBarClick = function () {
      _this.props.autoPlay && _this._playPauseToggle();
    };

    _this._handleOnMouseEnter = function () {
      if (_this.props.stopAutoPlayOnHover) {
        _this.isHovered = true;
      }
    };

    _this._handleOnMouseLeave = function () {
      _this.isHovered = false;
    };

    _this._onSlideToIndexChange = function (currentIndex, slideToIndex) {
      if (slideToIndex === currentIndex + 1) {
        _this.slideNext();
      } else if (slideToIndex === currentIndex - 1) {
        _this.slidePrev();
      } else {
        _this.slideTo(slideToIndex);
      }
    };

    _this._onInactiveItem = function () {
      _this._onSlideChange();
      _this._onSlideChanged();
      _this._allowAnimation();
      _this._pause();
    };

    _this._getFadeOutAnimationState = function (shouldRecalculate) {
      if (shouldRecalculate || _this._isFadeOutAnimationAllowed()) {
        return { fadeoutAnimationProcessing: false };
      }
      return {};
    };

    _this._setRootComponentRef = function (node) {
      return _this.rootComponent = node;
    };

    _this._setStageComponentRef = function (node) {
      return _this.stageComponent = node;
    };

    _this._allowAnimation = function () {
      return _this.allowAnimation = true;
    };

    _this._disableAnimation = function () {
      return _this.allowAnimation = false;
    };

    _this._skipSlidePositionRecalculation = function () {
      if (_this._isFadeOutAnimationAllowed()) {
        return _this._resetFadeOutAnimationState();
      }

      _this._onSlideChanged();
      _this.props.disableAutoPlayOnAction && _this._pause();
      _this.isHovered = false;
    };

    _this._updateSlidePosition = function () {
      _this._updateSlidePositionIntervalId = setTimeout(function () {
        if (_this._shouldRecalculatePosition()) {
          _this._recalculateSlidePosition();
        } else if (_this._isFadeOutAnimationAllowed()) {
          _this._resetFadeOutAnimationState();
        } else {
          _this._onSlideChanged();
        }
      }, _this.state.duration);
    };

    _this._resetFadeOutAnimationState = function () {
      _this.setState({ fadeoutAnimationProcessing: false }, _this._onSlideChanged);
    };

    _this._resetAllIntermediateProps = function () {
      _this.swipingStarted = false;
      _this.verticalSwipingDetected = false;

      _this._stopSwipeAnimation();
      _this._resetAnimationProps();
      _this._resetSwipePositionProps();
      _this._clearUpdateSlidePositionIntervalId();
      _this._resetTranslateAnimationProcessingFlag();
      _this._allowAnimation();
    };

    _this._recalculateSlidePosition = function () {
      var style = Utils.getDefaultStyles();
      var currentIndex = Utils.recalculateCurrentSlideIndex(_this.state);
      var translate3d = Utils.recalculateTranslatePosition(_this.state);

      _this.setState(_extends({
        currentIndex: currentIndex,
        translate3d: translate3d,
        style: style
      }, _this._getFadeOutAnimationState()), function () {
        return _this._onSlideChanged();
      });
    };

    _this._getEventObject = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state;
      var itemsInSlide = state.items,
          item = state.currentIndex;

      var _Utils$itemInfo = Utils.itemInfo(state),
          isNextSlideDisabled = _Utils$itemInfo.isNextSlideDisabled;

      var slide = Utils.getActiveSlideIndex(isNextSlideDisabled, state);

      return { item: item, slide: slide, itemsInSlide: itemsInSlide };
    };

    _this.setAnimationPropsOnDotClick = function (itemIndex) {
      var _this$state = _this.state,
          currentIndex = _this$state.currentIndex,
          itemWidth = _this$state.itemWidth;

      var fadeOutIndex = currentIndex + 1;
      var fadeOutOffset = Utils.getFadeOutOffsetOnDotClick(itemIndex, currentIndex, itemWidth);

      _this._setAnimationProps({ fadeOutIndex: fadeOutIndex, fadeOutOffset: fadeOutOffset, allowFadeOutAnimation: true });
    };

    _this._pause = function () {
      if (_this._autoPlayIntervalId) {
        _this._clearAutoPlayInterval();
        _this.setState({ isPlaying: false });
      }
    };

    _this._playPauseToggle = function () {
      if (!_this.allowAnimation) return;
      _this.state.isPlaying ? _this._pause() : _this._play();
    };

    _this._getIntermediateStateProps = function (duration, shouldSkipRecalculation) {
      var condition = !shouldSkipRecalculation && _this._isFadeOutAnimationAllowed();
      return Utils.getIntermediateTransitionProps(condition, duration);
    };

    _this._addTouchEventToCallstack = function () {
      _this.touchEventsCallstack.push(1);
    };

    _this._removeTouchEventFromCallstack = function () {
      _this.touchEventsCallstack.pop();
    };

    _this._setTranslateAnimationProcessingFlag = function () {
      _this.translateAnimationProcessing = true;
    };

    _this._resetTranslateAnimationProcessingFlag = function () {
      _this.translateAnimationProcessing = false;
    };

    _this._startSwipeAnimation = function () {
      _this.swipeAnimation = true;
    };

    _this._stopSwipeAnimation = function () {
      _this.swipeAnimation = false;
    };

    _this._setAnimationProps = function (newProps) {
      var prevProps = _this.animationProps || {};
      _this.animationProps = _extends({}, prevProps, newProps);
    };

    _this._resetAnimationProps = function () {
      _this.animationProps = {};
    };

    _this._setSwipePositionProps = function (newProps) {
      var prevProps = _this.swipePosition || {};
      _this.swipePosition = _extends({}, prevProps, newProps);
    };

    _this._resetSwipePositionProps = function () {
      _this.swipePosition = {};
    };

    _this._getTranslateXPosition = function (deltaX) {
      var translate3d = _this.state.translate3d;
      var _this$swipePosition$s = _this.swipePosition.startPosition,
          startPosition = _this$swipePosition$s === undefined ? translate3d : _this$swipePosition$s;


      if (!!_this.touchEventsCallstack.length && _this.translateAnimationProcessing) {
        _this._resetTranslateAnimationProcessingFlag();
        var lastTranslateXPosition = Utils.getTranslateX(_this.stageComponent);

        if (lastTranslateXPosition) {
          return lastTranslateXPosition - deltaX;
        }
      }
      return startPosition - deltaX;
    };

    _this._onTouchEnd = function () {
      _this.swipingStarted = false;

      if (_this._isSwipeDisable()) {
        return;
      }

      _this._addTouchEventToCallstack();
      _this._setSwipePositionProps({ startPosition: _this.swipePosition.position });
      _this._beforeTouchEnd();
    };

    _this._isHovered = function () {
      return _this.isHovered;
    };

    _this._isClickDisabled = function (itemIndex) {
      var _this$state2 = _this.state,
          currentIndex = _this$state2.currentIndex,
          isAnimationCanceled = _this$state2.isAnimationCanceled;

      return currentIndex === itemIndex || isAnimationCanceled || !_this.allowAnimation || _this.swipeAnimation;
    };

    _this._isFadeOutAnimationAllowed = function () {
      var _this$state3 = _this.state,
          stagePadding = _this$state3.stagePadding,
          items = _this$state3.items;

      var hasNoStagePadding = !(stagePadding.paddingLeft || stagePadding.paddingRight);

      return _this.props.fadeOutAnimation && items === 1 && hasNoStagePadding;
    };

    _this._isSwipeDisable = function () {
      var _this$state4 = _this.state,
          isAnimationCanceled = _this$state4.isAnimationCanceled,
          fadeOutAnimation = _this$state4.fadeOutAnimation;

      return _this.props.swipeDisabled || fadeOutAnimation || isAnimationCanceled || _this.verticalSwipingDetected;
    };

    _this._isSwipeAnimationLastFrame = function () {
      return !_this.swipingStarted && _this.touchEventsCallstack.length === 0;
    };

    _this._isSwipeAnimationProcessing = function () {
      return !!_this.touchEventsCallstack.length;
    };

    _this._shouldRecalculatePosition = function () {
      var _this$state5 = _this.state,
          slides = _this$state5.slides,
          currentIndex = _this$state5.currentIndex;

      return currentIndex < 0 || currentIndex >= slides.length;
    };

    _this._setAnimationPropsOnClick = function (direction) {
      var _this$state6 = _this.state,
          currentIndex = _this$state6.currentIndex,
          itemWidth = _this$state6.itemWidth;

      var fadeOutIndex = Utils.getFadeOutIndexOnClick(currentIndex);
      var fadeOutOffset = Utils.getFadeOutOffsetOnClick(direction, itemWidth);

      _this._setAnimationProps({ fadeOutIndex: fadeOutIndex, fadeOutOffset: fadeOutOffset, allowFadeOutAnimation: true });
    };

    _this._renderSlideInfo = function () {
      var _this$state7 = _this.state,
          currentIndex = _this$state7.currentIndex,
          slides = _this$state7.slides;

      return _react2.default.createElement(Views.SlideInfo, { slidesLength: slides.length, currentIndex: currentIndex });
    };

    _this._renderStageItem = function (item, i) {
      var style = Utils.itemStyles(i, _this.state, _this.animationProps);
      var className = Utils.itemClassName(i, _this.state, _this.animationProps);
      return _react2.default.createElement(Views.StageItem, { styles: style, className: className, key: 'stage-item-' + i, item: item });
    };

    _this.state = {
      clones: [],
      stagePadding: {},
      currentIndex: 1,
      initialStageHeight: 0,
      duration: props.duration,
      slides: Utils.getSlides(props),
      style: Utils.getDefaultStyles()
    };

    _this.touchEventsCallstack = [];
    _this.slideTo = _this.slideTo.bind(_this);
    _this.slidePrev = _this.slidePrev.bind(_this);
    _this.slideNext = _this.slideNext.bind(_this);
    _this._onTouchMove = _this._onTouchMove.bind(_this);
    _this._debouncedHandleOnWindowResize = Utils.debounce(_this._handleOnWindowResize, 100);
    return _this;
  }

  _createClass(AliceCarousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setInitialState();
      this._setupSwipeHahdlers();
      this._resetAllIntermediateProps();
      this.rootComponentDimensions = Utils.getElementDimensions(this.rootComponent);

      window.addEventListener('resize', this._debouncedHandleOnWindowResize);

      if (!this.props.keysControlDisabled) {
        window.addEventListener('keyup', this._handleOnKeyUp);
      }

      this.props.autoPlay && this._play();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.autoHeight && this.stageComponent && !this.state.initialStageHeight) {
        var initialStageHeight = Utils.getGalleryItemHeight(this.stageComponent, this.props, this.state);
        this.setState({ initialStageHeight: initialStageHeight });
      }

      if (this.props.duration !== prevProps.duration) {
        this.setState({ duration: this.props.duration });
      }

      if (this.props.fadeOutAnimation !== prevProps.fadeOutAnimation) {
        this.setState({ fadeoutAnimationProcessing: false }, this._resetAnimationProps);
      }

      if (this.props.slideToIndex !== prevProps.slideToIndex) {
        this._onSlideToIndexChange(this.state.currentIndex, this.props.slideToIndex);
      }

      if (this.props.disableAutoPlayOnAction !== prevProps.disableAutoPlayOnAction || this.props.autoPlayDirection !== prevProps.autoPlayDirection || this.props.autoPlayInterval !== prevProps.autoPlayInterval || this.props.infinite !== prevProps.infinite || this.props.autoPlay !== prevProps.autoPlay) {
        this.props.autoPlay ? this._play() : this._pause();
      }

      if (this.props.stagePadding !== prevProps.stagePadding || this.props.responsive !== prevProps.responsive || this.props.infinite !== prevProps.infinite || this.props.items !== prevProps.items) {
        this._resetAllIntermediateProps();
        this.setState(Utils.calculateInitialProps(this.props, this.stageComponent));
      }

      if (this.props.keysControlDisabled !== prevProps.keysControlDisabled) {
        this.props.keysControlDisabled ? window.removeEventListener('keyup', this._handleOnKeyUp) : window.addEventListener('keyup', this._handleOnKeyUp);
      }

      this.swiper.update({
        mouseTrackingEnabled: this.props.mouseTrackingEnabled,
        touchTrackingEnabled: this.props.touchTrackingEnabled,
        preventDefaultTouchmoveEvent: this.props.preventEventOnTouchMove
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this._autoPlayIntervalId);
      window.removeEventListener('resize', this._debouncedHandleOnWindowResize);
      window.removeEventListener('keyup', this._handleOnKeyUp);
      this.swiper.destroy();
    }
  }, {
    key: 'slideTo',
    value: function slideTo() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this._isClickDisabled(index)) return;

      this._disableAnimation();
      this._isFadeOutAnimationAllowed() && this.setAnimationPropsOnDotClick(index);
      this.props.disableAutoPlayOnAction && this._pause();
      this._slideToItem(index);
    }
  }, {
    key: 'slidePrev',
    value: function slidePrev() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this._isClickDisabled()) return;

      this._disableAnimation();
      this._isFadeOutAnimationAllowed() && this._setAnimationPropsOnClick('prev');

      if (Utils.itemInfo(this.state).isPrevSlideDisabled) return this._onInactiveItem();
      if (action && this.props.disableAutoPlayOnAction) this._pause();

      this._slideToItem(this.state.currentIndex - 1);
    }
  }, {
    key: 'slideNext',
    value: function slideNext() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this._isClickDisabled()) return;

      this._disableAnimation();
      this._isFadeOutAnimationAllowed() && this._setAnimationPropsOnClick('next');

      if (Utils.itemInfo(this.state).isNextSlideDisabled) return this._onInactiveItem();
      if (action && this.props.disableAutoPlayOnAction) this._pause();

      this._slideToItem(this.state.currentIndex + 1);
    }
  }, {
    key: '_setupSwipeHahdlers',
    value: function _setupSwipeHahdlers() {
      this.swiper = new _vanillaSwipe2.default({
        element: this.swipeWrapper,
        onSwiping: this._onTouchMove,
        onSwiped: this._onTouchEnd,
        rotationAngle: 10,
        mouseTrackingEnabled: this.props.mouseTrackingEnabled,
        touchTrackingEnabled: this.props.touchTrackingEnabled,
        preventDefaultTouchmoveEvent: this.props.preventEventOnTouchMove
      });

      this.swiper.init();
    }
  }, {
    key: '_onSlideChange',
    value: function _onSlideChange() {
      if (this.props.onSlideChange) {
        this.props.onSlideChange(this._getEventObject());
      }
    }
  }, {
    key: '_onSlideChanged',
    value: function _onSlideChanged() {
      if (this.props.onSlideChanged) {
        this.props.onSlideChanged(this._getEventObject());
      }
      this._allowAnimation();
    }
  }, {
    key: '_onInitialized',
    value: function _onInitialized(initialState) {
      if (this.props.onInitialized) {
        this.props.onInitialized(this._getEventObject(initialState));
      }
    }
  }, {
    key: '_onResized',
    value: function _onResized() {
      if (this.props.onResized) {
        this.props.onResized(this._getEventObject());
      }
    }
  }, {
    key: '_setInitialState',
    value: function _setInitialState() {
      var initialState = Utils.calculateInitialProps(this.props, this.stageComponent);
      this.setState(initialState, this._onInitialized(initialState));
    }
  }, {
    key: '_checkSlidePosition',
    value: function _checkSlidePosition(shouldSkipRecalculation) {
      this._stopSwipeAnimation();
      this._resetAnimationProps();
      this._resetSwipePositionProps();

      shouldSkipRecalculation ? this._skipSlidePositionRecalculation() : this._updateSlidePosition();
    }
  }, {
    key: '_setAutoPlayInterval',
    value: function _setAutoPlayInterval() {
      var _this2 = this;

      var duration = this.state.duration;
      var _props = this.props,
          autoPlayDirection = _props.autoPlayDirection,
          autoPlayInterval = _props.autoPlayInterval;

      var playInterval = Math.max(autoPlayInterval, duration);

      this._autoPlayIntervalId = setInterval(function () {
        if (!_this2._isHovered() && _this2._autoPlayIntervalId && _this2.state.isPlaying) {
          autoPlayDirection === 'rtl' ? _this2.slidePrev(false) : _this2.slideNext(false);
        }
      }, playInterval);
    }
  }, {
    key: '_clearAutoPlayInterval',
    value: function _clearAutoPlayInterval() {
      clearInterval(this._autoPlayIntervalId);
    }
  }, {
    key: '_clearUpdateSlidePositionIntervalId',
    value: function _clearUpdateSlidePositionIntervalId() {
      clearTimeout(this._updateSlidePositionIntervalId);
    }
  }, {
    key: '_play',
    value: function _play() {
      this.setState({ isPlaying: true });

      if (!this._autoPlayIntervalId) {
        this._setAutoPlayInterval();
      }
    }
  }, {
    key: '_slideToItem',
    value: function _slideToItem(index) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._onSlideChange();
      var _options$duration = options.duration,
          duration = _options$duration === undefined ? this.state.duration : _options$duration,
          _options$shouldSkipRe = options.shouldSkipRecalculation,
          shouldSkipRecalculation = _options$shouldSkipRe === undefined ? false : _options$shouldSkipRe;

      var translate3d = Utils.getTranslate3dPosition(index, this.state);

      this.setState(_extends({
        currentIndex: index,
        translate3d: translate3d
      }, this._getIntermediateStateProps(duration, shouldSkipRecalculation)), function () {
        return _this3._checkSlidePosition(shouldSkipRecalculation);
      });
    }
  }, {
    key: '_onTouchMove',
    value: function _onTouchMove(e, deltaX, deltaY) {
      this.swipingStarted = true;
      this._handleOnMouseEnter();

      if (Utils.isVerticalTouchMoveDetected(e, deltaX, deltaY)) {
        this.verticalSwipingDetected = true;
        return;
      } else {
        this.verticalSwipingDetected = false;
      }

      if (this._isSwipeDisable()) {
        return;
      }

      this._disableAnimation();
      this._startSwipeAnimation();
      this._clearUpdateSlidePositionIntervalId();

      var _state = this.state,
          slides = _state.slides,
          items = _state.items,
          itemWidth = _state.itemWidth,
          infinite = _state.infinite,
          stagePadding = _state.stagePadding;

      var slidesLength = slides.length;
      var direction = Utils.getSwipeDirection(deltaX);
      var position = this._getTranslateXPosition(deltaX);

      if (infinite === false) {
        var _minSwipeLimit = Utils.getMinSwipeLimitIfNotInfinite(items, itemWidth);
        var _maxSwipeLimit = Utils.getMaxSwipeLimitIfNotInfinite(slidesLength, itemWidth);

        if (Utils.shouldRecalculateSwipePosition(position, _minSwipeLimit, _maxSwipeLimit)) {
          return;
        }

        Utils.animate(this.stageComponent, position);
        this._setSwipePositionProps({ position: position, direction: direction });
        return;
      }

      var maxPosition = Utils.getMaxSwipePosition(items, itemWidth, slidesLength);
      var minPosition = Utils.getMinSwipePosition(items, itemWidth);
      var maxSwipeLimit = Utils.getMaxSwipeLimit(maxPosition, stagePadding);
      var minSwipeLimit = Utils.getMinSwipeLimit(minPosition, stagePadding);

      if (Utils.shouldRecalculateSwipePosition(position, minSwipeLimit, maxSwipeLimit)) {
        try {
          recalculatePosition();
        } catch (err) {
          Utils.debug(err);
        }
      }

      Utils.animate(this.stageComponent, position);
      this._setSwipePositionProps({ position: position, direction: direction });

      function recalculatePosition() {
        direction === 'RIGHT' ? position = position + slidesLength * -itemWidth : position = position + maxPosition - items * itemWidth;

        if (Utils.shouldRecalculateSwipePosition(position, minSwipeLimit, maxSwipeLimit)) {
          recalculatePosition();
        }
      }
    }
  }, {
    key: '_beforeTouchEnd',
    value: function _beforeTouchEnd() {
      var _this4 = this;

      var _swipePosition = this.swipePosition,
          direction = _swipePosition.direction,
          position = _swipePosition.position;
      var _state2 = this.state,
          itemWidth = _state2.itemWidth,
          items = _state2.items,
          duration = _state2.duration,
          infinite = _state2.infinite;

      var swipeIndex = Utils.calculateSwipeIndex(itemWidth, position, direction);
      var currentIndex = Utils.getSwipeIndexOnBeforeTouchEnd(swipeIndex, items);
      var translateXPosition = Utils.getSwipePositionOnBeforeTouchEnd(swipeIndex, itemWidth);

      if (infinite === false) {
        this._isInfiniteModeDisabledBeforeTouchEnd(swipeIndex, currentIndex);
        return;
      }

      this._setTranslateAnimationProcessingFlag();
      Utils.animate(this.stageComponent, translateXPosition, duration);

      setTimeout(function () {
        _this4._removeTouchEventFromCallstack();
        _this4._resetTranslateAnimationProcessingFlag();

        if (_this4._isSwipeAnimationLastFrame()) {
          if (_this4.state.isAnimationCanceled) {
            return _this4._handleOnAnimationCanceled();
          }

          var nextItemIndex = Utils.getNextItemIndexBeforeTouchEnd(translateXPosition, _this4.state);
          var nextTranslateXPosition = Utils.getTranslate3dPosition(nextItemIndex, _this4.state);

          Utils.animate(_this4.stageComponent, nextTranslateXPosition, 0);
          _this4._slideToItem(nextItemIndex, { duration: 0, shouldSkipRecalculation: true });
        }
      }, duration);
    }
  }, {
    key: '_isInfiniteModeDisabledBeforeTouchEnd',
    value: function _isInfiniteModeDisabledBeforeTouchEnd(swipeIndex, currentIndex) {
      var _this5 = this;

      var _state3 = this.state,
          items = _state3.items,
          itemWidth = _state3.itemWidth,
          duration = _state3.duration,
          slides = _state3.slides;

      var position = Utils.getTranslate3dPosition(currentIndex, { itemWidth: itemWidth, items: items });

      if (swipeIndex < items) {
        currentIndex = Utils.recalculateCurrentIndexOnBeforeTouchEnd();
        position = Utils.recalculatePositionOnBeforeTouchEnd(items, itemWidth);
      }

      if (swipeIndex > slides.length) {
        currentIndex = Utils.recalculateCurrentIndexOnBeforeTouchEnd(slides.length, items);
        position = Utils.recalculatePositionOnBeforeTouchEnd(slides.length, itemWidth);
      }

      Utils.animate(this.stageComponent, position, duration);
      this._setTranslateAnimationProcessingFlag();

      setTimeout(function () {
        _this5._removeTouchEventFromCallstack();
        _this5._resetTranslateAnimationProcessingFlag();

        if (_this5._isSwipeAnimationLastFrame()) {
          if (_this5.state.isAnimationCanceled) {
            return _this5._handleOnAnimationCanceled();
          }

          Utils.animate(_this5.stageComponent, position);
          _this5._slideToItem(currentIndex, { duration: 0, shouldSkipRecalculation: true });
        }
      }, duration);
    }
  }, {
    key: '_renderPrevButton',
    value: function _renderPrevButton() {
      var _Utils$itemInfo2 = Utils.itemInfo(this.state),
          isPrevSlideDisabled = _Utils$itemInfo2.isPrevSlideDisabled;

      return _react2.default.createElement(Views.PrevNextButton, {
        name: 'prev',
        disabled: isPrevSlideDisabled,
        onClick: this.slidePrev,
        onMouseEnter: this._handleOnMouseEnter,
        onMouseLeave: this._handleOnMouseLeave
      });
    }
  }, {
    key: '_renderNextButton',
    value: function _renderNextButton() {
      var _Utils$itemInfo3 = Utils.itemInfo(this.state),
          isNextSlideDisabled = _Utils$itemInfo3.isNextSlideDisabled;

      return _react2.default.createElement(Views.PrevNextButton, {
        name: 'next',
        disabled: isNextSlideDisabled,
        onClick: this.slideNext,
        onMouseEnter: this._handleOnMouseEnter,
        onMouseLeave: this._handleOnMouseLeave
      });
    }
  }, {
    key: '_renderPlayPauseButton',
    value: function _renderPlayPauseButton() {
      return _react2.default.createElement(Views.PlayPauseButton, { isPlaying: this.state.isPlaying, onClick: this._playPauseToggle });
    }
  }, {
    key: '_renderDotsNavigation',
    value: function _renderDotsNavigation() {
      return _react2.default.createElement(Views.DotsNavigation, {
        state: this.state,
        onClick: this.slideTo,
        onMouseEnter: this._handleOnMouseEnter,
        onMouseLeave: this._handleOnMouseLeave
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _state4 = this.state,
          style = _state4.style,
          translate3d = _state4.translate3d,
          clones = _state4.clones;

      var wrapperStyles = Utils.getWrapperStyles(this.stageComponent, this.props, this.state);
      var stageStyles = Utils.getStageStyles({ translate3d: translate3d }, style);

      return _react2.default.createElement(
        'div',
        { className: 'alice-carousel', ref: this._setRootComponentRef },
        _react2.default.createElement(
          'div',
          { ref: function ref(el) {
              return _this6.swipeWrapper = el;
            } },
          _react2.default.createElement(
            'div',
            {
              style: wrapperStyles,
              className: 'alice-carousel__wrapper',
              onMouseEnter: this._handleOnMouseEnter,
              onMouseLeave: this._handleOnMouseLeave
            },
            _react2.default.createElement(
              'ul',
              { style: stageStyles, className: 'alice-carousel__stage', ref: this._setStageComponentRef },
              clones.map(this._renderStageItem)
            )
          )
        ),
        this.props.showSlideInfo ? this._renderSlideInfo() : null,
        !this.props.dotsDisabled ? this._renderDotsNavigation() : null,
        !this.props.buttonsDisabled ? this._renderPrevButton() : null,
        !this.props.buttonsDisabled ? this._renderNextButton() : null,
        this.props.playButtonEnabled ? this._renderPlayPauseButton() : null
      );
    }
  }]);

  return AliceCarousel;
}(_react2.default.PureComponent);

exports.default = AliceCarousel;


AliceCarousel.propTypes = _propTypes.propTypes;
AliceCarousel.defaultProps = _propTypes.defaultProps;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_modal_css__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_modal_css__);


var StatusModal = function (props) {
    var renderData = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-upper-block" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-header" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title-40" }, props.data.title),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-14" }, props.data.text)))); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'modal' + (props.show ? ' modal-show' : ' modal-hide') },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-card" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "close-modal-btn", onClick: props.toggle }),
            renderData(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-footer" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn-modal-continue", onClick: props.toggle }, "OK")))));
};
/* harmony default export */ __webpack_exports__["a"] = (StatusModal);


/***/ }),
/* 13 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(73);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = warn;
/* harmony export (immutable) */ __webpack_exports__["e"] = warnOnce;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadNamespaces;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasLoadedNamespace;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayName;
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
} // not needed right now
//
// export function deprecated(...args) {
//   if (process && process.env && (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')) {
//     if (typeof args[0] === 'string') args[0] = `deprecation warning -> ${args[0]}`;
//     warnOnce(...args);
//   }
// }

function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    // delay ready if not yet initialized i18n instance
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        // due to emitter removing issue in i18next we need to delay remove
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1]; // we're in cimode so this shall pass

  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  }; // bound to trigger on event languageChanging
  // so set ready to false while we are changing the language
  // and namespace pending (depends on having a backend)


  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false; // loaded -> SUCCESS

  if (i18n.hasResourceBundle(lng, ns)) return true; // were not loading at all -> SEMI SUCCESS

  if (!i18n.services.backendConnector.backend) return true; // failed loading ns - but at least fallback is not pending -> SEMI SUCCESS

  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Switch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return matchPath; });
/* unused harmony export useHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return useLocation; });
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* unused harmony export withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(context).history;
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  return path ? matchPath(useLocation().pathname, path) : useContext(context).match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTranslation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(16);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // assert we have the needed i18nInstance
  var i18nFromProps = props.i18n;
  var ReactI18nContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context__["a" /* I18nContext */]);

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_3__context__["e" /* getHasUsedI18nextProvider */])() ? ReactI18nContext || {} : {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || Object(__WEBPACK_IMPORTED_MODULE_3__context__["f" /* getI18n */])();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new __WEBPACK_IMPORTED_MODULE_3__context__["b" /* ReportNamespaces */]();

  if (!i18n) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* warnOnce */])('You will need pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  var i18nOptions = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3__context__["d" /* getDefaults */])(), {}, i18n.options.react, {}, props);

  var useSuspense = i18nOptions.useSuspense; // prepare having a namespace

  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation']; // report namespaces as used

  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces); // are we ready? yes if all namespaces in first language are loaded already (either with data or empty object on failed load)

  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* hasLoadedNamespace */])(n, i18n, i18nOptions);
  }); // binding t function to namespace (acts also as rerender trigger)

  function getT() {
    return {
      t: i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0])
    };
  }

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(getT()),
      _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1]; // seems we can't have functions as value -> wrap it in obj


  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    var isMounted = true;
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore; // if not ready and not using suspense load the namespaces
    // in side effect and do not call resetT if unmounted

    if (!ready && !useSuspense) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* loadNamespaces */])(i18n, namespaces, function () {
        if (isMounted) setT(getT());
      });
    }

    function boundReset() {
      if (isMounted) setT(getT());
    } // bind events to trigger change, like languageChanged


    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset); // unbinding on unmount

    return function () {
      isMounted = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [namespaces.join()]); // re-run effect whenever list of namespaces changes

  var ret = [t.t, i18n, ready];
  ret.t = t.t;
  ret.i18n = i18n;
  ret.ready = ready; // return hook stuff if ready

  if (ready) return ret; // not yet loaded namespaces -> load them -> and return if useSuspense option set false

  if (!ready && !useSuspense) return ret; // not yet loaded namespaces -> load them -> and trigger suspense

  throw new Promise(function (resolve) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* loadNamespaces */])(i18n, namespaces, function () {
      setT(getT());
      resolve();
    });
  });
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(82);

var iterableToArrayLimit = __webpack_require__(83);

var nonIterableRest = __webpack_require__(84);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(25);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_alice_carousel_lib_alice_carousel_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_alice_carousel_lib_alice_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_alice_carousel_lib_alice_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_carousel_css__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_carousel_css__);






var CarouselOutline = function (props) {
    var t = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('common').t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ innerWidth: window.innerWidth }), state = _a[0], setState = _a[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () { return window.addEventListener('resize', function () {
        return setState({ innerWidth: window.innerWidth });
    }); }, []);
    var isTablet = function () { return state.innerWidth > 544 && state.innerWidth < 1105; };
    var renderAudience = function (audience) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "audience" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p fw400" },
            t('Audience'),
            ":"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "audience-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "audience-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "audience-title" }, t('Demo')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "audience-text" }, audience.demo)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "audience-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "audience-title" }, t('Geo')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "audience-list" }, audience.geoList.map(function (geo, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: 'aud-' + i, className: "audience-text" }, geo + (i != audience.geoList.length - 1 ? ',' : ''));
                })))))); };
    var renderBlocks = function () {
        return props.blocks.map(function (block, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: 'block-' + index, className: "carousel-block bordered" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "carousel-image" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: block.img, style: block.title == 'Offer Wall' ? { transform: 'scale(1.2)' } : {} })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.titleClass ? props.titleClass : 'block-p' }, block.title),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.textClass ? props.textClass : 'block-c' }, block.text),
            block.audience != null ? renderAudience(block.audience) : null)); });
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "carousel", style: props.style },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "carousel-container" }, isTablet()
            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default.a, { autoHeight: false, buttonsDisabled: true, infinite: false, items: renderBlocks() })
            : renderBlocks())));
};
/* harmony default export */ __webpack_exports__["a"] = (CarouselOutline);


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(58);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSSR;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context__ = __webpack_require__(10);


function useSSR(initialI18nStore, initialLanguage) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18nFromProps = props.i18n;
  var ReactI18nContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context__["a" /* I18nContext */]);

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_1__context__["e" /* getHasUsedI18nextProvider */])() ? ReactI18nContext || {} : {},
      i18nFromContext = _ref.i18n;

  var i18n = i18nFromProps || i18nFromContext || Object(__WEBPACK_IMPORTED_MODULE_1__context__["f" /* getI18n */])(); // opt out if is a cloned instance, eg. created by i18next-express-middleware on request
  // -> do not set initial stuff on server side

  if (i18n.options && i18n.options.isClone) return; // nextjs / SSR: getting data from next.js or other ssr stack

  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }

  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(100);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageKey; });
/* unused harmony export storageReaderFactory */
/* unused harmony export storageWriterFactory */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var StorageKey;
(function (StorageKey) {
    StorageKey["Authenticated"] = "Authenticated";
})(StorageKey || (StorageKey = {}));
function storageReaderFactory(prefix) {
    return {
        read: function (key) {
            var value = localStorage.getItem(prefix + key);
            return value ? JSON.parse(value) : {};
        }
    };
}
function storageWriterFactory(prefix) {
    return {
        write: function (key, value) {
            var res;
            if (value) {
                var old = localStorage.getItem(prefix + key);
                if (old) {
                    var oldVal = JSON.parse(old);
                    if (typeof oldVal === 'object') {
                        res = __assign(__assign({}, oldVal), value);
                        localStorage.setItem(prefix + key, JSON.stringify(res));
                    }
                    else {
                        res = oldVal + value;
                        localStorage.setItem(prefix + key, JSON.stringify(res));
                    }
                }
                else {
                    res = value;
                    localStorage.setItem(prefix + key, JSON.stringify(res));
                }
            }
            return res;
        }
    };
}


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOptions = createOptions;

function createOptions() {
  var proxy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  Object.defineProperty(proxy, 'passive', {
    get: function get() {
      this.isPassiveSupported = true;
      return true;
    },
    enumerable: true
  });
  return proxy;
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetch;
/* harmony export (immutable) */ __webpack_exports__["b"] = processError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_storage__ = __webpack_require__(40);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


function fetch(input, init, multipart) {
    init = init || {};
    init = __assign(__assign({}, init), { 
        // credentials: 'include',
        headers: __assign({}, init.headers) });
    if (init.body && !(init.headers && init.headers['Content-Type']) && !multipart) {
        init = __assign(__assign({}, init), { headers: __assign(__assign({}, init.headers), { 'Content-Type': 'application/json', 'Accept': 'application/json' }) });
    }
    return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__(input, init).then(function (resp) {
        if (resp.ok) {
            return Promise.resolve(resp);
        }
        if (resp && resp.status === 401) {
            // unauthorized, reset token
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__util_storage__["a" /* StorageKey */].Authenticated);
            return Promise.reject(resp);
        }
        return Promise.reject(resp);
    }).catch(function (resp) {
        return Promise.reject(resp);
    });
}
function processError(err) {
    var resp = err;
    var parsedError = undefined;
    if (typeof (resp.json) == 'function') {
        return resp.json()
            .catch(function () {
            return Promise.reject(undefined);
        })
            .then(function (json) {
            parsedError = json;
            return Promise.reject(parsedError);
        });
    }
    else if (resp['response'] && resp['response'].data) {
        parsedError = resp['response'].data;
    }
    return Promise.reject(parsedError);
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__(2);




var Headquarters = function (props) {
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('common').t;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "offices", className: "headquarters pt-120" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-t muli" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('Our Headquarters'), 'accent-text')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-description" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-israel" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accent-text" }, t('Main Office')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/israel.svg" }),
                                t('Israel')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Meir Wiesgal 2')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Science Park')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Rehovot')))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-units" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accent-text" }, t('Business Units')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/usa.svg" }),
                                t('new york')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/japan.svg" }),
                                t('tokyo')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/korea.svg" }),
                                t('seoul')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/china.svg" }),
                                t('beijing')))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-contacts not-tablet not-mobile" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "info@persona.ly"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "fb", href: "https://www.facebook.com/persona.ly.monetization/" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "ln", href: "https://www.linkedin.com/company/persona-ly/" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "tw", href: "https://twitter.com/persona_ly" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-image-m not-tablet not-desktop" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/group-32.svg" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('personaly is a tech'), 'accent-text fw700')),
                props.showButton && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "about#ad-tech-company" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-grey large" }, t('our story')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-image not-mobile" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/group-32.svg" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (Headquarters);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceVisible = exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(157);

var _scrollParent = __webpack_require__(158);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(159);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(160);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0,
  height: 0
};
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = component.ref;

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = component.ref;

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = component.ref;
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

/**
 * Forces the component to display regardless of whether the element is visible in the viewport.
 */
var forceVisible = function forceVisible() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    listener.visible = true;
    listener.forceUpdate();
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    _this.setRef = _this.setRef.bind(_this);
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(element) {
      if (element) {
        this.ref = element;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          height = _props2.height,
          children = _props2.children,
          placeholder = _props2.placeholder,
          className = _props2.className,
          classNamePrefix = _props2.classNamePrefix,
          style = _props2.style;


      return _react2.default.createElement(
        'div',
        { className: classNamePrefix + '-wrapper ' + className, ref: this.setRef, style: style },
        this.visible ? children : placeholder ? placeholder : _react2.default.createElement('div', {
          style: { height: height },
          className: classNamePrefix + '-placeholder'
        })
      );
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  className: _propTypes2.default.string,
  classNamePrefix: _propTypes2.default.string,
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

LazyLoad.defaultProps = {
  className: '',
  classNamePrefix: 'lazyload',
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

exports.lazyload = decorator;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
exports.forceVisible = forceVisible;

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_dataDriven_css__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_dataDriven_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_dataDriven_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_locales__ = __webpack_require__(6);





var DataDriven = function (props) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])('rtb'), t = _a.t, i18n = _a.i18n;
    var ja = i18n.language.includes(__WEBPACK_IMPORTED_MODULE_4__util_locales__["c" /* locales */].ja);
    var ru = i18n.language.includes(__WEBPACK_IMPORTED_MODULE_4__util_locales__["c" /* locales */].ru);
    var jaStyle = ja ? { margin: '0 -18px' } : {};
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'data-driven-process ' + props.className + (ja ? ' jpDrivenHack' : '') + (ru ? ' ruDrivenHack' : '') },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/exploration.svg" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "data-driven-numbers" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/1.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "data-driven-dot" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ddt" }, t('Exploration')),
                props.full && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ddp-rtb-description", style: jaStyle }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('Bidding in impressions b'), '')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/basic-logic-level.svg" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "data-driven-numbers" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/2.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "data-driven-dot" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ddt" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: ru ? 'ddt-ru-style' : '' }, t('Basic logic level'))),
                props.full && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ddp-rtb-description", style: jaStyle }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('A basic targeting a'), '')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/unique-model.svg" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "data-driven-numbers" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/3.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "data-driven-dot" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ddt" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: ru ? 'ddt-ru-style' : '' }, t('Unique model'))),
                props.full && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ddp-rtb-description", style: jaStyle }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('A tailor made t'), '')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/engagement-optimalization.svg" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "data-driven-numbers" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/4.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "data-driven-dot" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ddt" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: ru ? 'ddt-ru-style ddt-ru-s-optima' : '' }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('Engagement optimization'), ''))),
                props.full && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ddp-rtb-description" }, t('Full-funnel data (f')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/scaling.svg" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "data-driven-numbers" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/5.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "data-driven-dot" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: props.full ? 'https://static.persona.ly/images/rtb/fill-1.svg' : 'https://static.persona.ly/images/fill-1.svg' }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ddt" }, t('Scaling'))))));
};
/* harmony default export */ __webpack_exports__["a"] = (DataDriven);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_simpleList_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_simpleList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_simpleList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_locales__ = __webpack_require__(6);




var SimpleList = function (props) {
    var i18n = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])('landing').i18n;
    var ja = i18n.language.includes(__WEBPACK_IMPORTED_MODULE_3__util_locales__["c" /* locales */].ja);
    var renderText = function (textList) { return textList.map(function (text, index) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { key: 'text-p-' + index }, text); }); };
    var renderBlock = function (block, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: 'item-' + i, className: "list-item" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.bordered ? 'rectangle-100 bordered' : 'rectangle-80' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: block.img })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-block" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, block.title),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c", style: ja ? { width: '100%' } : {} }, renderText(block.textList))))); };
    var renderList = function () { return props.blocks.map(function (block, index) { return renderBlock(block, index + 1); }); };
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "simple-list-container" }, renderList());
};
/* harmony default export */ __webpack_exports__["a"] = (SimpleList);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_steps_css__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_steps_css__);


var Steps = function (props) {
    var renderBlock = function (block, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: 'step-' + i, className: (i % 2) == 0 ? 'steps-block-reverse' : 'steps-block' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "steps-block-left" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "absolute-image" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "steps-text" }, block.title),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "steps-index" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: 'https://static.persona.ly/images/monetization/' + i + '.svg' })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "steps-image" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: block.img })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "hexagon-2 not-mobile", src: "https://static.persona.ly/images/polygon-14.svg" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "steps-block-right" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "hexagon-1", src: "https://static.persona.ly/images/polygon.svg" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "hexagon-2 not-tablet not-desktop", src: "https://static.persona.ly/images/polygon-14.svg" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-container" }, block.textList && block.textList.map(function (text, i) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { key: i }, text); }))))); };
    var renderList = function () { return props.blocks.map(function (block, index) { return renderBlock(block, index + 1); }); };
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "steps-container" }, renderList());
};
/* harmony default export */ __webpack_exports__["a"] = (Steps);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(63);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56);
module.exports = __webpack_require__(61);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(57).enable();
  window.Promise = __webpack_require__(59);
}

// fetch() polyfill for making API calls.
__webpack_require__(60);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(14);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(37);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(37);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serviceWorker__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__(209);








var html = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Router */], { history: Object(__WEBPACK_IMPORTED_MODULE_5_history__["a" /* createBrowserHistory */])() },
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router__["d" /* Switch */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Route */], { path: "/", component: __WEBPACK_IMPORTED_MODULE_3__app__["b" /* default */] }))));
__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"](html, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
__WEBPACK_IMPORTED_MODULE_2__serviceWorker__["a" /* unregister */]();


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.10.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(14),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var z="function"===typeof Symbol&&Symbol.iterator;
function A(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
function D(a,b,c){this.props=a;this.context=b;this.refs=C;this.updater=c||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,c){this.props=a;this.context=b;this.refs=C;this.updater=c||B}var G=F.prototype=new E;
G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var d,e={},g=null,l=null;if(null!=b)for(d in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,d)&&!L.hasOwnProperty(d)&&(e[d]=b[d]);var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];e.children=k}if(a&&a.defaultProps)for(d in f=a.defaultProps,f)void 0===e[d]&&(e[d]=f[d]);return{$$typeof:p,type:a,key:g,ref:l,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,d){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=c;e.context=d;e.count=0;return e}return{result:a,keyPrefix:b,func:c,context:d,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,d){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(d,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){e=a[l];var f=b+T(e,l);g+=S(e,f,c,d)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,l++),g+=S(e,f,c,d);else if("object"===e)throw c=""+a,A(Error(31),"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,"");return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,c){var d=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,d,c,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),d.push(a))}function V(a,b,c,d,e){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,d,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var d=[];V(a,d,null,b,c);return d},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw A(Error(267),a);var d=h({},a.props),
e=a.key,g=a.ref,l=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(e=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(d[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)d.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];d.children=f}return{$$typeof:p,type:a.type,key:e,ref:g,props:d,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},
isValidElement:N,version:"16.10.1",unstable_withSuspenseConfig:function(a,b){var c=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=c}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.10.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(14),r=__webpack_require__(64);function t(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}if(!aa)throw t(Error(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw t(Error(96),a);if(!ea[c]){if(!b.extractEvents)throw t(Error(97),a);ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw t(Error(99),h);fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw t(Error(98),d,a);}}}}
function ha(a,b,c){if(ia[a])throw t(Error(100),a);ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw t(Error(198));na||(na=!0,oa=l)}}var sa=null,ta=null,ua=null;function va(a,b,c){var d=a.type||"unknown-event";a.currentTarget=ua(c);ra(d,b,void 0,a);a.currentTarget=null}function wa(a,b){if(null==b)throw t(Error(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function xa(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var ya=null;function za(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)va(a,b[d],c[d]);else b&&va(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Aa(a){null!==a&&(ya=wa(ya,a));a=ya;ya=null;if(a){xa(a,za);if(ya)throw t(Error(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ba={injectEventPluginOrder:function(a){if(ba)throw t(Error(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw t(Error(102),c);ca[c]=d;b=!0}}b&&da()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw t(Error(231),b,typeof c);
return c}var Da=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Da.hasOwnProperty("ReactCurrentDispatcher")||(Da.ReactCurrentDispatcher={current:null});Da.hasOwnProperty("ReactCurrentBatchConfig")||(Da.ReactCurrentBatchConfig={suspense:null});
var Ea=/^(.*)[\\\/]/,x="function"===typeof Symbol&&Symbol.for,Fa=x?Symbol.for("react.element"):60103,Ga=x?Symbol.for("react.portal"):60106,Ha=x?Symbol.for("react.fragment"):60107,Ia=x?Symbol.for("react.strict_mode"):60108,Ja=x?Symbol.for("react.profiler"):60114,Ka=x?Symbol.for("react.provider"):60109,La=x?Symbol.for("react.context"):60110,Ma=x?Symbol.for("react.concurrent_mode"):60111,Na=x?Symbol.for("react.forward_ref"):60112,Oa=x?Symbol.for("react.suspense"):60113,Pa=x?Symbol.for("react.suspense_list"):
60120,Qa=x?Symbol.for("react.memo"):60115,Ra=x?Symbol.for("react.lazy"):60116;x&&Symbol.for("react.fundamental");x&&Symbol.for("react.responder");x&&Symbol.for("react.scope");var Sa="function"===typeof Symbol&&Symbol.iterator;function Ta(a){if(null===a||"object"!==typeof a)return null;a=Sa&&a[Sa]||a["@@iterator"];return"function"===typeof a?a:null}
function Ua(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Va(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ha:return"Fragment";case Ga:return"Portal";case Ja:return"Profiler";case Ia:return"StrictMode";case Oa:return"Suspense";case Pa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case La:return"Context.Consumer";case Ka:return"Context.Provider";case Na:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Qa:return Va(a.type);case Ra:if(a=1===a._status?a._result:null)return Va(a)}return null}function Wa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Va(a.type);c=null;d&&(c=Va(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ea,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Xa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Ya=null,Za=null,$a=null;function ab(a){if(a=ta(a)){if("function"!==typeof Ya)throw t(Error(280));var b=sa(a.stateNode);Ya(a.stateNode,a.type,b)}}function bb(a){Za?$a?$a.push(a):$a=[a]:Za=a}function cb(){if(Za){var a=Za,b=$a;$a=Za=null;ab(a);if(b)for(a=0;a<b.length;a++)ab(b[a])}}function db(a,b){return a(b)}function eb(a,b,c,d){return a(b,c,d)}function fb(){}
var gb=db,hb=!1,ib=!1;function jb(){if(null!==Za||null!==$a)fb(),cb()}new Map;new Map;new Map;var kb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lb=Object.prototype.hasOwnProperty,mb={},nb={};
function ob(a){if(lb.call(nb,a))return!0;if(lb.call(mb,a))return!1;if(kb.test(a))return nb[a]=!0;mb[a]=!0;return!1}function pb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qb(a,b,c,d){if(null===b||"undefined"===typeof b||pb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var rb=/[\-:]([a-z])/g;function sb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rb,
sb);C[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rb,sb);C[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rb,sb);C[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function tb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function ub(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qb(b,c,e,d)&&(c=null),d||null===e?ob(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function vb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=vb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=vb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=tb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&ub(a,"checked",b,!1)}
function Db(a,b){Cb(a,b);var c=tb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Eb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Eb(a,b.type,tb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Eb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+tb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw t(Error(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw t(Error(92));if(Array.isArray(b)){if(!(1>=b.length))throw t(Error(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:tb(c)}}
function Mb(a,b){var c=tb(b.value),d=tb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Xa&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}
var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),dc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),ec=!1,fc=[],gc=null,hc=null,ic=null,jc=new Map,kc=new Map,lc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),
mc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");function nc(a){var b=oc(a);lc.forEach(function(c){pc(c,a,b)});mc.forEach(function(c){pc(c,a,b)})}function qc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}
function rc(a,b){switch(a){case "focus":case "blur":gc=null;break;case "dragenter":case "dragleave":hc=null;break;case "mouseover":case "mouseout":ic=null;break;case "pointerover":case "pointerout":jc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":kc.delete(b.pointerId)}}function sc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return qc(b,c,d,e);a.eventSystemFlags|=d;return a}
function tc(a,b,c,d){switch(b){case "focus":return gc=sc(gc,a,b,c,d),!0;case "dragenter":return hc=sc(hc,a,b,c,d),!0;case "mouseover":return ic=sc(ic,a,b,c,d),!0;case "pointerover":var e=d.pointerId;jc.set(e,sc(jc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,kc.set(e,sc(kc.get(e)||null,a,b,c,d)),!0}return!1}function uc(a){if(null!==a.blockedOn)return!1;var b=vc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);return null!==b?(a.blockedOn=b,!1):!0}
function wc(a,b,c){uc(a)&&c.delete(b)}function xc(){for(ec=!1;0<fc.length;){var a=fc[0];if(null!==a.blockedOn)break;var b=vc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:fc.shift()}null!==gc&&uc(gc)&&(gc=null);null!==hc&&uc(hc)&&(hc=null);null!==ic&&uc(ic)&&(ic=null);jc.forEach(wc);kc.forEach(wc)}function yc(a,b){a.blockedOn===b&&(a.blockedOn=null,ec||(ec=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,xc)))}
function zc(a){function b(b){return yc(b,a)}if(0<fc.length){yc(fc[0],a);for(var c=1;c<fc.length;c++){var d=fc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==gc&&yc(gc,a);null!==hc&&yc(hc,a);null!==ic&&yc(ic,a);jc.forEach(b);kc.forEach(b)}var D=0,E=2,Ac=1024;function Bc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,(b.effectTag&(E|Ac))!==D&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function Cc(a){if(Bc(a)!==a)throw t(Error(188));}
function Dc(a){var b=a.alternate;if(!b){b=Bc(a);if(null===b)throw t(Error(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return Cc(e),a;if(f===d)return Cc(e),b;f=f.sibling}throw t(Error(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw t(Error(189));}}if(c.alternate!==d)throw t(Error(190));}if(3!==c.tag)throw t(Error(188));return c.stateNode.current===c?a:b}function Ec(a){a=Dc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function Fc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Gc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Hc(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=wa(c._dispatchListeners,b),c._dispatchInstances=wa(c._dispatchInstances,a)}
function Ic(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Gc(b);for(b=c.length;0<b--;)Hc(c[b],"captured",a);for(b=0;b<c.length;b++)Hc(c[b],"bubbled",a)}}function Jc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=wa(c._dispatchListeners,b),c._dispatchInstances=wa(c._dispatchInstances,a))}function Kc(a){a&&a.dispatchConfig.registrationName&&Jc(a._targetInst,null,a)}
function Lc(a){xa(a,Ic)}function Mc(){return!0}function Nc(){return!1}function F(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Mc:Nc;this.isPropagationStopped=Nc;return this}
n(F.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Mc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Mc)},persist:function(){this.isPersistent=Mc},isPersistent:Nc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Nc;this._dispatchInstances=this._dispatchListeners=null}});F.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
F.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Oc(c);return c};Oc(F);function Pc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Qc(a){if(!(a instanceof this))throw t(Error(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Oc(a){a.eventPool=[];a.getPooled=Pc;a.release=Qc}var Rc=F.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Sc=F.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Tc=F.extend({view:null,detail:null}),Uc=Tc.extend({relatedTarget:null});
function Vc(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Wc={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Xc={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Yc={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Zc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Yc[a])?!!b[a]:!1}function $c(){return Zc}
var ad=Tc.extend({key:function(a){if(a.key){var b=Wc[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Vc(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Xc[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:$c,charCode:function(a){return"keypress"===a.type?Vc(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Vc(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),bd=0,cd=0,dd=!1,fd=!1,gd=Tc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:$c,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=bd;bd=a.screenX;return dd?"mousemove"===a.type?a.screenX-
b:0:(dd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=cd;cd=a.screenY;return fd?"mousemove"===a.type?a.screenY-b:0:(fd=!0,0)}}),hd=gd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),id=gd.extend({dataTransfer:null}),jd=Tc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:$c}),kd=F.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),ld=gd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),md=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],nd={},od={},pd=0;for(;pd<md.length;pd++){var qd=md[pd],rd=qd[0],sd=qd[1],td=qd[2],ud="on"+(sd[0].toUpperCase()+sd.slice(1)),vd={phasedRegistrationNames:{bubbled:ud,captured:ud+"Capture"},dependencies:[rd],eventPriority:td};nd[sd]=vd;od[rd]=vd}
var wd={eventTypes:nd,getEventPriority:function(a){a=od[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d,e){b=od[a];if(!b)return null;switch(a){case "keypress":if(0===Vc(d))return null;case "keydown":case "keyup":a=ad;break;case "blur":case "focus":a=Uc;break;case "click":if(2===d.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=gd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
id;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=jd;break;case Zb:case $b:case ac:a=Rc;break;case bc:a=kd;break;case "scroll":a=Tc;break;case "wheel":a=ld;break;case "copy":case "cut":case "paste":a=Sc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=hd;break;default:a=F}c=a.getPooled(b,c,d,e);Lc(c);return c}},xd=wd.getEventPriority,zd=10,Ad=[];
function Bd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;var e=c.tag;5!==e&&6!==e||a.ancestors.push(c);c=Cd(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var f=Fc(a.nativeEvent);d=a.topLevelType;e=a.eventSystemFlags;for(var g=a.nativeEvent,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,e,b,g,f))&&(h=wa(h,l))}Aa(h)}}
var Dd=!0;function G(a,b){Ed(b,a,!1)}function Ed(a,b,c){switch(xd(b)){case 0:var d=Fd.bind(null,b,1);break;case 1:d=Gd.bind(null,b,1);break;default:d=Hd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Fd(a,b,c){hb||fb();var d=Hd,e=hb;hb=!0;try{eb(d,a,b,c)}finally{(hb=e)||jb()}}function Gd(a,b,c){Hd(a,b,c)}
function Id(a,b,c,d){if(Ad.length){var e=Ad.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Bd,c=a,ib)b(c,void 0);else{ib=!0;try{gb(b,c,void 0)}finally{ib=!1,jb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Ad.length<zd&&Ad.push(a)}}
function Hd(a,b,c){if(Dd)if(0<fc.length&&-1<lc.indexOf(a))a=qc(null,a,b,c),fc.push(a);else{var d=vc(a,b,c);null===d?rc(a,c):-1<lc.indexOf(a)?(a=qc(d,a,b,c),fc.push(a)):tc(d,a,b,c)||(rc(a,c),Id(a,b,c,null))}}
function vc(a,b,c){var d=Fc(c),e=Cd(d);if(null!==e)if(d=Bc(e),null===d)e=null;else{var f=d.tag;if(13===f){a:{if(13===d.tag&&(e=d.memoizedState,null===e&&(d=d.alternate,null!==d&&(e=d.memoizedState)),null!==e)){d=e.dehydrated;break a}d=null}if(null!==d)return d;e=null}else if(3===f){if(d.stateNode.hydrate)return 3===d.tag?d.stateNode.containerInfo:null;e=null}else d!==e&&(e=null)}Id(a,b,c,e);return null}
function Jd(a){if(!Xa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Kd=new ("function"===typeof WeakMap?WeakMap:Map);function oc(a){var b=Kd.get(a);void 0===b&&(b=new Set,Kd.set(a,b));return b}
function pc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Ed(b,"scroll",!0);break;case "focus":case "blur":Ed(b,"focus",!0);Ed(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Jd(a)&&Ed(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===dc.indexOf(a)&&G(a,b)}c.add(a)}}
var Ld={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Md=["Webkit","ms","Moz","O"];Object.keys(Ld).forEach(function(a){Md.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Ld[b]=Ld[a]})});function Nd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Ld.hasOwnProperty(a)&&Ld[a]?(""+b).trim():b+"px"}
function Od(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Nd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Pd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Qd(a,b){if(b){if(Pd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw t(Error(137),a,"");if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw t(Error(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw t(Error(61));}if(null!=b.style&&"object"!==typeof b.style)throw t(Error(62),"");}}
function Rd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function Sd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=oc(a);b=ja[b];for(var d=0;d<b.length;d++)pc(b[d],a,c)}function Td(){}
function Ud(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Vd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function Wd(a,b){var c=Vd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Vd(c)}}
function Xd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Xd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function Yd(){for(var a=window,b=Ud();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Ud(a.document)}return b}
function Zd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var $d="$",ae="/$",be="$?",ce="$!",de=null,ee=null;function fe(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function ge(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var he="function"===typeof setTimeout?setTimeout:void 0,ie="function"===typeof clearTimeout?clearTimeout:void 0;function je(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function ke(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===$d||c===ce||c===be){if(0===b)return a;b--}else c===ae&&b++}a=a.previousSibling}return null}var le=Math.random().toString(36).slice(2),me="__reactInternalInstance$"+le,ne="__reactEventHandlers$"+le,oe="__reactContainere$"+le;
function Cd(a){var b=a[me];if(b)return b;for(var c=a.parentNode;c;){if(b=c[oe]||c[me]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=ke(a);null!==a;){if(c=a[me])return c;a=ke(a)}return b}a=c;c=a.parentNode}return null}function pe(a){a=a[me]||a[oe];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function qe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw t(Error(33));}function re(a){return a[ne]||null}var se=null,te=null,ue=null;
function ve(){if(ue)return ue;var a,b=te,c=b.length,d,e="value"in se?se.value:se.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return ue=e.slice(a,1<d?1-d:void 0)}var we=F.extend({data:null}),xe=F.extend({data:null}),ye=[9,13,27,32],ze=Xa&&"CompositionEvent"in window,Ae=null;Xa&&"documentMode"in document&&(Ae=document.documentMode);
var Be=Xa&&"TextEvent"in window&&!Ae,Ce=Xa&&(!ze||Ae&&8<Ae&&11>=Ae),De=String.fromCharCode(32),Ee={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Fe=!1;
function Ge(a,b){switch(a){case "keyup":return-1!==ye.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function He(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ie=!1;function Je(a,b){switch(a){case "compositionend":return He(b);case "keypress":if(32!==b.which)return null;Fe=!0;return De;case "textInput":return a=b.data,a===De&&Fe?null:a;default:return null}}
function Ke(a,b){if(Ie)return"compositionend"===a||!ze&&Ge(a,b)?(a=ve(),ue=te=se=null,Ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Ce&&"ko"!==b.locale?null:b.data;default:return null}}
var Le={eventTypes:Ee,extractEvents:function(a,b,c,d,e){var f;if(ze)b:{switch(a){case "compositionstart":var g=Ee.compositionStart;break b;case "compositionend":g=Ee.compositionEnd;break b;case "compositionupdate":g=Ee.compositionUpdate;break b}g=void 0}else Ie?Ge(a,d)&&(g=Ee.compositionEnd):"keydown"===a&&229===d.keyCode&&(g=Ee.compositionStart);g?(Ce&&"ko"!==d.locale&&(Ie||g!==Ee.compositionStart?g===Ee.compositionEnd&&Ie&&(f=ve()):(se=e,te="value"in se?se.value:se.textContent,Ie=!0)),b=we.getPooled(g,
c,d,e),f?b.data=f:(f=He(d),null!==f&&(b.data=f)),Lc(b),f=b):f=null;(a=Be?Je(a,d):Ke(a,d))?(c=xe.getPooled(Ee.beforeInput,c,d,e),c.data=a,Lc(c)):c=null;return null===f?c:null===c?f:[f,c]}},Me={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Me[a.type]:"textarea"===b?!0:!1}
var Oe={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Pe(a,b,c){a=F.getPooled(Oe.change,a,b,c);a.type="change";bb(c);Lc(a);return a}var Qe=null,Re=null;function Se(a){Aa(a)}function Te(a){var b=qe(a);if(zb(b))return a}function Ue(a,b){if("change"===a)return b}var Ve=!1;Xa&&(Ve=Jd("input")&&(!document.documentMode||9<document.documentMode));
function We(){Qe&&(Qe.detachEvent("onpropertychange",Xe),Re=Qe=null)}function Xe(a){if("value"===a.propertyName&&Te(Re))if(a=Pe(Re,a,Fc(a)),hb)Aa(a);else{hb=!0;try{db(Se,a)}finally{hb=!1,jb()}}}function Ye(a,b,c){"focus"===a?(We(),Qe=b,Re=c,Qe.attachEvent("onpropertychange",Xe)):"blur"===a&&We()}function Ze(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Te(Re)}function $e(a,b){if("click"===a)return Te(b)}function af(a,b){if("input"===a||"change"===a)return Te(b)}
var bf={eventTypes:Oe,_isInputEventSupported:Ve,extractEvents:function(a,b,c,d,e){b=c?qe(c):window;var f=b.nodeName&&b.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===b.type)var g=Ue;else if(Ne(b))if(Ve)g=af;else{g=Ze;var h=Ye}else(f=b.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===b.type||"radio"===b.type)&&(g=$e);if(g&&(g=g(a,c)))return Pe(g,d,e);h&&h(a,b,c);"blur"===a&&(a=b._wrapperState)&&a.controlled&&"number"===b.type&&Eb(b,"number",b.value)}},cf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},df={eventTypes:cf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(b&32)&&(d.relatedTarget||d.fromElement)||!g&&!f)return null;
b=e.window===e?e:(b=e.ownerDocument)?b.defaultView||b.parentWindow:window;if(g){if(g=c,c=(c=d.relatedTarget||d.toElement)?Cd(c):null,null!==c&&(f=Bc(c),c!==f||5!==c.tag&&6!==c.tag))c=null}else g=null;if(g===c)return null;if("mouseout"===a||"mouseover"===a){var h=gd;var k=cf.mouseLeave;var l=cf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=hd,k=cf.pointerLeave,l=cf.pointerEnter,m="pointer";a=null==g?b:qe(g);b=null==c?b:qe(c);k=h.getPooled(k,g,d,e);k.type=m+"leave";k.target=
a;k.relatedTarget=b;d=h.getPooled(l,c,d,e);d.type=m+"enter";d.target=b;d.relatedTarget=a;e=g;m=c;if(e&&m)a:{h=e;l=m;a=0;for(g=h;g;g=Gc(g))a++;g=0;for(c=l;c;c=Gc(c))g++;for(;0<a-g;)h=Gc(h),a--;for(;0<g-a;)l=Gc(l),g--;for(;a--;){if(h===l||h===l.alternate)break a;h=Gc(h);l=Gc(l)}h=null}else h=null;l=h;for(h=[];e&&e!==l;){a=e.alternate;if(null!==a&&a===l)break;h.push(e);e=Gc(e)}for(e=[];m&&m!==l;){a=m.alternate;if(null!==a&&a===l)break;e.push(m);m=Gc(m)}for(m=0;m<h.length;m++)Jc(h[m],"bubbled",k);for(m=
e.length;0<m--;)Jc(e[m],"captured",d);return[k,d]}};function ef(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var ff="function"===typeof Object.is?Object.is:ef,gf=Object.prototype.hasOwnProperty;function hf(a,b){if(ff(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!gf.call(b,c[d])||!ff(a[c[d]],b[c[d]]))return!1;return!0}
var jf=Xa&&"documentMode"in document&&11>=document.documentMode,kf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},lf=null,mf=null,nf=null,of=!1;
function pf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(of||null==lf||lf!==Ud(c))return null;c=lf;"selectionStart"in c&&Zd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return nf&&hf(nf,c)?null:(nf=c,a=F.getPooled(kf.select,mf,a,b),a.type="select",a.target=lf,Lc(a),a)}
var qf={eventTypes:kf,extractEvents:function(a,b,c,d,e){b=e.window===e?e.document:9===e.nodeType?e:e.ownerDocument;var f;if(!(f=!b)){a:{b=oc(b);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!b.has(f[g])){b=!1;break a}b=!0}f=!b}if(f)return null;b=c?qe(c):window;switch(a){case "focus":if(Ne(b)||"true"===b.contentEditable)lf=b,mf=c,nf=null;break;case "blur":nf=mf=lf=null;break;case "mousedown":of=!0;break;case "contextmenu":case "mouseup":case "dragend":return of=!1,pf(d,e);case "selectionchange":if(jf)break;
case "keydown":case "keyup":return pf(d,e)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));sa=re;ta=pe;ua=qe;Ba.injectEventPluginsByName({SimpleEventPlugin:wd,EnterLeaveEventPlugin:df,ChangeEventPlugin:bf,SelectEventPlugin:qf,BeforeInputEventPlugin:Le});new Set;var rf=[],sf=-1;function H(a){0>sf||(a.current=rf[sf],rf[sf]=null,sf--)}
function I(a,b){sf++;rf[sf]=a.current;a.current=b}var tf={},J={current:tf},K={current:!1},uf=tf;function vf(a,b){var c=a.type.contextTypes;if(!c)return tf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function N(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function wf(a){H(K,a);H(J,a)}function xf(a){H(K,a);H(J,a)}function zf(a,b,c){if(J.current!==tf)throw t(Error(168));I(J,b,a);I(K,c,a)}function Af(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw t(Error(108),Va(b)||"Unknown",e);return n({},c,{},d)}function Bf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||tf;uf=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Cf(a,b,c){var d=a.stateNode;if(!d)throw t(Error(169));c?(b=Af(a,b,uf),d.__reactInternalMemoizedMergedChildContext=b,H(K,a),H(J,a),I(J,b,a)):H(K,a);I(K,c,a)}
var Df=r.unstable_runWithPriority,Ef=r.unstable_scheduleCallback,Ff=r.unstable_cancelCallback,Gf=r.unstable_shouldYield,Hf=r.unstable_requestPaint,If=r.unstable_now,Jf=r.unstable_getCurrentPriorityLevel,Kf=r.unstable_ImmediatePriority,Lf=r.unstable_UserBlockingPriority,Mf=r.unstable_NormalPriority,Nf=r.unstable_LowPriority,Of=r.unstable_IdlePriority,Pf={},Qf=void 0!==Hf?Hf:function(){},Rf=null,Sf=null,Tf=!1,Uf=If(),Vf=1E4>Uf?If:function(){return If()-Uf};
function Wf(){switch(Jf()){case Kf:return 99;case Lf:return 98;case Mf:return 97;case Nf:return 96;case Of:return 95;default:throw t(Error(332));}}function Xf(a){switch(a){case 99:return Kf;case 98:return Lf;case 97:return Mf;case 96:return Nf;case 95:return Of;default:throw t(Error(332));}}function Yf(a,b){a=Xf(a);return Df(a,b)}function Zf(a,b,c){a=Xf(a);return Ef(a,b,c)}function $f(a){null===Rf?(Rf=[a],Sf=Ef(Kf,ag)):Rf.push(a);return Pf}function bg(){if(null!==Sf){var a=Sf;Sf=null;Ff(a)}ag()}
function ag(){if(!Tf&&null!==Rf){Tf=!0;var a=0;try{var b=Rf;Yf(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Rf=null}catch(c){throw null!==Rf&&(Rf=Rf.slice(a+1)),Ef(Kf,bg),c;}finally{Tf=!1}}}function cg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var dg={current:null},eg=null,fg=null,gg=null;function hg(){gg=fg=eg=null}function ig(a,b){var c=a.type._context;I(dg,c._currentValue,a);c._currentValue=b}
function jg(a){var b=dg.current;H(dg,a);a.type._context._currentValue=b}function kg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function lg(a,b){eg=a;gg=fg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(mg=!0),a.firstContext=null)}
function ng(a,b){if(gg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)gg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===fg){if(null===eg)throw t(Error(308));fg=b;eg.dependencies={expirationTime:0,firstContext:b,responders:null}}else fg=fg.next=b}return a._currentValue}var og=!1;
function pg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function qg(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function rg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function sg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function tg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=pg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=pg(a.memoizedState),e=c.updateQueue=pg(c.memoizedState)):d=a.updateQueue=qg(e):null===e&&(e=c.updateQueue=qg(d));null===e||d===e?sg(d,b):null===d.lastUpdate||null===e.lastUpdate?(sg(d,b),sg(e,b)):(sg(d,b),e.lastUpdate=b)}
function ug(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=pg(a.memoizedState):vg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function vg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=qg(b));return b}
function wg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:og=!0}return d}
function xg(a,b,c,d,e){og=!1;b=vg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(yg(m,k.suspenseConfig),l=wg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var A=k.expirationTime;A<e?(null===m&&(m=k,null===g&&(f=l)),h<A&&(h=A)):(l=wg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;zg(h);a.expirationTime=h;a.memoizedState=l}
function Ag(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Bg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Bg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Bg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw t(Error(191),c);c.call(d)}a=a.nextEffect}}
var Cg=Da.ReactCurrentBatchConfig,Dg=(new aa.Component).refs;function Eg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Ig={isMounted:function(a){return(a=a._reactInternalFiber)?Bc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Fg(),e=Cg.suspense;d=Gg(d,a,e);e=rg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);tg(a,e);Hg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Fg(),e=Cg.suspense;d=Gg(d,a,e);e=rg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);tg(a,e);Hg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Fg(),d=Cg.suspense;
c=Gg(c,a,d);d=rg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);tg(a,d);Hg(a,c)}};function Jg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!hf(c,d)||!hf(e,f):!0}
function Kg(a,b,c){var d=!1,e=tf;var f=b.contextType;"object"===typeof f&&null!==f?f=ng(f):(e=N(b)?uf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?vf(a,e):tf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Ig;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Lg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Ig.enqueueReplaceState(b,b.state,null)}
function Mg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Dg;var f=b.contextType;"object"===typeof f&&null!==f?e.context=ng(f):(f=N(b)?uf:J.current,e.context=vf(a,f));f=a.updateQueue;null!==f&&(xg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Eg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Ig.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(xg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Ng=Array.isArray;
function Og(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw t(Error(309));var d=c.stateNode}if(!d)throw t(Error(147),a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Dg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw t(Error(284));if(!c._owner)throw t(Error(290),a);}return a}
function Pg(a,b){if("textarea"!==a.type)throw t(Error(31),"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"");}
function Qg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Rg(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
E,c):d;b.effectTag=E;return c}function g(b){a&&null===b.alternate&&(b.effectTag=E);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Sg(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Og(a,b,c),d.return=a,d;d=Tg(c.type,c.key,c.props,null,a.mode,d);d.ref=Og(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Vg(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Sg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Fa:return c=Tg(b.type,b.key,b.props,null,a.mode,c),c.ref=Og(a,null,b),c.return=a,c;case Ga:return b=Ug(b,a.mode,c),b.return=a,b}if(Ng(b)||
Ta(b))return b=Vg(b,a.mode,c,null),b.return=a,b;Pg(a,b)}return null}function w(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Fa:return c.key===e?c.type===Ha?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ga:return c.key===e?l(a,b,c,d):null}if(Ng(c)||Ta(c))return null!==e?null:m(a,b,c,d,null);Pg(a,c)}return null}function L(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Fa:return a=a.get(null===d.key?c:d.key)||null,d.type===Ha?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ga:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Ng(d)||Ta(d))return a=a.get(c)||null,m(b,a,d,e,null);Pg(b,d)}return null}function wb(e,g,h,k){for(var l=null,m=null,q=g,y=g=0,z=null;null!==q&&y<h.length;y++){q.index>y?(z=q,q=null):z=q.sibling;var p=w(e,q,h[y],k);if(null===p){null===q&&(q=z);break}a&&
q&&null===p.alternate&&b(e,q);g=f(p,g,y);null===m?l=p:m.sibling=p;m=p;q=z}if(y===h.length)return c(e,q),l;if(null===q){for(;y<h.length;y++)q=A(e,h[y],k),null!==q&&(g=f(q,g,y),null===m?l=q:m.sibling=q,m=q);return l}for(q=d(e,q);y<h.length;y++)z=L(q,e,y,h[y],k),null!==z&&(a&&null!==z.alternate&&q.delete(null===z.key?y:z.key),g=f(z,g,y),null===m?l=z:m.sibling=z,m=z);a&&q.forEach(function(a){return b(e,a)});return l}function M(e,g,h,k){var l=Ta(h);if("function"!==typeof l)throw t(Error(150));h=l.call(h);
if(null==h)throw t(Error(151));for(var m=l=null,q=g,y=g=0,z=null,p=h.next();null!==q&&!p.done;y++,p=h.next()){q.index>y?(z=q,q=null):z=q.sibling;var M=w(e,q,p.value,k);if(null===M){null===q&&(q=z);break}a&&q&&null===M.alternate&&b(e,q);g=f(M,g,y);null===m?l=M:m.sibling=M;m=M;q=z}if(p.done)return c(e,q),l;if(null===q){for(;!p.done;y++,p=h.next())p=A(e,p.value,k),null!==p&&(g=f(p,g,y),null===m?l=p:m.sibling=p,m=p);return l}for(q=d(e,q);!p.done;y++,p=h.next())p=L(q,e,y,p.value,k),null!==p&&(a&&null!==
p.alternate&&q.delete(null===p.key?y:p.key),g=f(p,g,y),null===m?l=p:m.sibling=p,m=p);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ha&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Fa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){if(7===k.tag?f.type===Ha:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ha?f.props.children:f.props,h);d.ref=Og(a,k,f);d.return=a;a=d;break a}c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ha?(d=Vg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Tg(f.type,f.key,f.props,null,a.mode,h),h.ref=Og(a,d,f),h.return=a,a=h)}return g(a);case Ga:a:{for(k=f.key;null!==d;){if(d.key===k){if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}c(a,d);break}else b(a,d);d=d.sibling}d=Ug(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||
"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=Sg(f,a.mode,h),d.return=a,a=d),g(a);if(Ng(f))return wb(a,d,f,h);if(Ta(f))return M(a,d,f,h);l&&Pg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,t(Error(152),a.displayName||a.name||"Component");}return c(a,d)}}var Wg=Qg(!0),Xg=Qg(!1),Yg={},Zg={current:Yg},$g={current:Yg},ah={current:Yg};function bh(a){if(a===Yg)throw t(Error(174));return a}
function ch(a,b){I(ah,b,a);I($g,a,a);I(Zg,Yg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}H(Zg,a);I(Zg,b,a)}function dh(a){H(Zg,a);H($g,a);H(ah,a)}function eh(a){bh(ah.current);var b=bh(Zg.current);var c=Qb(b,a.type);b!==c&&(I($g,a,a),I(Zg,c,a))}function fh(a){$g.current===a&&(H(Zg,a),H($g,a))}var O={current:0};
function gh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===be||c.data===ce))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if((b.effectTag&64)!==D)return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function hh(a,b){return{responder:a,props:b}}
var ih=Da.ReactCurrentDispatcher,jh=0,kh=null,P=null,lh=null,mh=null,Q=null,nh=null,oh=0,ph=null,qh=0,rh=!1,sh=null,th=0;function uh(){throw t(Error(321));}function vh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!ff(a[c],b[c]))return!1;return!0}
function wh(a,b,c,d,e,f){jh=f;kh=b;lh=null!==a?a.memoizedState:null;ih.current=null===lh?xh:yh;b=c(d,e);if(rh){do rh=!1,th+=1,lh=null!==a?a.memoizedState:null,nh=mh,ph=Q=P=null,ih.current=yh,b=c(d,e);while(rh);sh=null;th=0}ih.current=zh;a=kh;a.memoizedState=mh;a.expirationTime=oh;a.updateQueue=ph;a.effectTag|=qh;a=null!==P&&null!==P.next;jh=0;nh=Q=mh=lh=P=kh=null;oh=0;ph=null;qh=0;if(a)throw t(Error(300));return b}
function Ah(){ih.current=zh;jh=0;nh=Q=mh=lh=P=kh=null;oh=0;ph=null;qh=0;rh=!1;sh=null;th=0}function Eh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?mh=Q=a:Q=Q.next=a;return Q}function Fh(){if(null!==nh)Q=nh,nh=Q.next,P=lh,lh=null!==P?P.next:null;else{if(null===lh)throw t(Error(310));P=lh;var a={memoizedState:P.memoizedState,baseState:P.baseState,queue:P.queue,baseUpdate:P.baseUpdate,next:null};Q=null===Q?mh=a:Q.next=a;lh=P.next}return Q}
function Gh(a,b){return"function"===typeof b?b(a):b}
function Hh(a){var b=Fh(),c=b.queue;if(null===c)throw t(Error(311));c.lastRenderedReducer=a;if(0<th){var d=c.dispatch;if(null!==sh){var e=sh.get(c);if(void 0!==e){sh.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);ff(f,b.memoizedState)||(mg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<jh?(l||(l=!0,h=g,e=f),m>oh&&(oh=m,zg(oh))):(yg(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);ff(f,b.memoizedState)||(mg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Ih(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ph?(ph={lastEffect:null},ph.lastEffect=a.next=a):(b=ph.lastEffect,null===b?ph.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ph.lastEffect=a));return a}function Jh(a,b,c,d){var e=Eh();qh|=a;e.memoizedState=Ih(b,c,void 0,void 0===d?null:d)}
function Kh(a,b,c,d){var e=Fh();d=void 0===d?null:d;var f=void 0;if(null!==P){var g=P.memoizedState;f=g.destroy;if(null!==d&&vh(d,g.deps)){Ih(0,c,f,d);return}}qh|=a;e.memoizedState=Ih(b,c,f,d)}function Lh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Mh(){}
function Nh(a,b,c){if(!(25>th))throw t(Error(301));var d=a.alternate;if(a===kh||null!==d&&d===kh)if(rh=!0,a={expirationTime:jh,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===sh&&(sh=new Map),c=sh.get(b),void 0===c)sh.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Fg(),f=Cg.suspense;e=Gg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(ff(l,k))return}catch(m){}finally{}Hg(a,e)}}
var zh={readContext:ng,useCallback:uh,useContext:uh,useEffect:uh,useImperativeHandle:uh,useLayoutEffect:uh,useMemo:uh,useReducer:uh,useRef:uh,useState:uh,useDebugValue:uh,useResponder:uh},xh={readContext:ng,useCallback:function(a,b){Eh().memoizedState=[a,void 0===b?null:b];return a},useContext:ng,useEffect:function(a,b){return Jh(516,192,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Jh(4,36,Lh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Jh(4,
36,a,b)},useMemo:function(a,b){var c=Eh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Eh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Nh.bind(null,kh,a);return[d.memoizedState,a]},useRef:function(a){var b=Eh();a={current:a};return b.memoizedState=a},useState:function(a){var b=Eh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,
dispatch:null,lastRenderedReducer:Gh,lastRenderedState:a};a=a.dispatch=Nh.bind(null,kh,a);return[b.memoizedState,a]},useDebugValue:Mh,useResponder:hh},yh={readContext:ng,useCallback:function(a,b){var c=Fh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&vh(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:ng,useEffect:function(a,b){return Kh(516,192,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Kh(4,36,Lh.bind(null,b,a),c)},
useLayoutEffect:function(a,b){return Kh(4,36,a,b)},useMemo:function(a,b){var c=Fh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&vh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Hh,useRef:function(){return Fh().memoizedState},useState:function(a){return Hh(Gh,a)},useDebugValue:Mh,useResponder:hh},Oh=null,Ph=null,Qh=!1;
function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=je(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&~Ac|E;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=je(b.firstChild)}else a.effectTag=a.effectTag&~Ac|E,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!ge(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=je(b.nextSibling);Vh(a);if(13===a.tag)if(a=a.memoizedState,a=null!==a?a.dehydrated:null,null===a)a=Ph;else a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ae){if(0===b){a=je(a.nextSibling);break a}b--}else c!==$d&&c!==ce&&c!==be||b++}a=a.nextSibling}a=null}else a=Oh?je(a.stateNode.nextSibling):null;Ph=a;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Da.ReactCurrentOwner,mg=!1;function R(a,b,c,d){b.child=null===a?Xg(b,null,c,d):Wg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;lg(b,e);d=wh(a,b,c,d,f,e);if(null!==a&&!mg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Tg(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:hf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Rg(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&hf(a.memoizedProps,d)&&a.ref===b.ref&&(mg=!1,e<f)?$h(a,b,f):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=N(c)?uf:J.current;f=vf(b,f);lg(b,e);c=wh(a,b,c,d,f,e);if(null!==a&&!mg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(N(c)){var f=!0;Bf(b)}else f=!1;lg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=E),Kg(b,c,d,e),Mg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=ng(l):(l=N(c)?uf:J.current,l=vf(b,l));var m=c.getDerivedStateFromProps,A="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Lg(b,g,d,l);og=!1;var w=b.memoizedState;k=g.state=w;var L=b.updateQueue;null!==L&&(xg(b,L,d,g,e),k=b.memoizedState);h!==d||w!==k||K.current||og?("function"===typeof m&&(Eg(b,c,m,d),k=b.memoizedState),(h=og||Jg(b,c,h,d,w,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:cg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=ng(l):(l=N(c)?uf:J.current,l=vf(b,l)),m=c.getDerivedStateFromProps,(A=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Lg(b,g,d,l),og=!1,k=b.memoizedState,w=g.state=k,L=b.updateQueue,null!==L&&(xg(b,L,d,g,e),w=b.memoizedState),h!==d||k!==w||K.current||og?("function"===typeof m&&(Eg(b,c,m,d),w=b.memoizedState),(m=og||Jg(b,c,h,d,k,w,l))?(A||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,w,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,w,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=w),g.props=d,g.state=w,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=(b.effectTag&64)!==D;if(!d&&!g)return e&&Cf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Wg(b,a.child,null,f),b.child=Wg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Cf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?zf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&zf(a,b.context,!1);ch(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:1};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=O.current,g=!1,h;(h=(b.effectTag&64)!==D)||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(O,f&1,b);if(null===a){if(g){g=e.fallback;e=Vg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Vg(g,d,c,null);c.return=b;e.sibling=c;b.memoizedState=
ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Xg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Rg(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Rg(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Wg(b,a.child,e.children,c);b.memoizedState=null;return b.child=c}a=a.child;
if(g){g=e.fallback;e=Vg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Vg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=E;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Wg(b,a,e.children,c)}
function ki(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.last=d,f.tail=c,f.tailExpiration=0,f.tailMode=e)}
function li(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=O.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&(a.effectTag&64)!==D)a:for(a=b.child;null!==a;){if(13===a.tag){if(null!==a.memoizedState){a.expirationTime<c&&(a.expirationTime=c);var g=a.alternate;null!==g&&g.expirationTime<c&&(g.expirationTime=c);kg(a.return,c)}}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;
a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(O,d,b);if(0===(b.mode&2))b.memoizedState=null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)d=c.alternate,null!==d&&null===gh(d)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);ki(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){d=e.alternate;if(null!==d&&null===gh(d)){b.child=e;break}d=e.sibling;e.sibling=c;c=e;e=d}ki(b,!0,c,null,f);break;case "together":ki(b,
!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&zg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw t(Error(153));if(null!==b.child){a=b.child;c=Rg(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Rg(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function mi(a){a.effectTag|=4}var ni,oi,pi,qi;ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;bh(Zg.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=Td)}Qd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&Sd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&mi(b)}};qi=function(a,b,c,d){c!==d&&mi(b)};
function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a){switch(a.tag){case 1:N(a.type)&&wf(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:dh(a);xf(a);b=a.effectTag;if((b&64)!==D)throw t(Error(285));a.effectTag=b&-4097|64;return a;case 5:return fh(a),null;case 13:return H(O,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(O,a),null;case 4:return dh(a),null;case 10:return jg(a),null;default:return null}}function ti(a,b){return{value:a,source:b,stack:Wa(b)}}
var ui="function"===typeof WeakSet?WeakSet:Set;function vi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Wa(c));null!==c&&Va(c.type);b=b.value;null!==a&&1===a.tag&&Va(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function wi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){xi(a,c)}}function yi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){xi(a,c)}else b.current=null}
function Di(a,b){switch(b.tag){case 0:case 11:case 15:Ei(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:cg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw t(Error(163));}}
function Ei(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Fi(a,b,c){"function"===typeof Gi&&Gi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;Yf(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){xi(g,h)}}a=a.next}while(a!==d)})}break;case 1:yi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&wi(b,c);break;case 5:yi(b);break;case 4:Hi(a,b,c)}}
function Ii(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Ii(b)}function Ji(a){return 5===a.tag||3===a.tag||4===a.tag}
function Ki(a){a:{for(var b=a.return;null!==b;){if(Ji(b)){var c=b;break a}b=b.return}throw t(Error(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw t(Error(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Ji(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&E)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&E)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=Td)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Hi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw t(Error(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Fi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Fi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Li(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ei(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ne]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Rd(a,e);b=Rd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Od(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):ub(c,g,h,b)}switch(a){case "input":Db(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw t(Error(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,zc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,Mi=Vf());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Nd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ni(b);break;case 19:Ni(b);break;case 17:break;case 20:break;case 21:break;default:throw t(Error(163));}}function Ni(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new ui);b.forEach(function(b){var d=Oi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var Pi="function"===typeof WeakMap?WeakMap:Map;
function Qi(a,b,c){c=rg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Ri||(Ri=!0,Si=d);vi(a,b)};return c}
function Ti(a,b,c){c=rg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){vi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ui?Ui=new Set([this]):Ui.add(this),vi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var Vi=Math.ceil,Wi=Da.ReactCurrentDispatcher,Xi=Da.ReactCurrentOwner,S=0,Yi=8,Zi=16,$i=32,aj=0,bj=1,cj=2,dj=3,ej=4,fj=5,gj=6,T=S,U=null,V=null,W=0,X=aj,hj=null,ij=1073741823,jj=1073741823,kj=null,lj=0,mj=!1,Mi=0,nj=500,Y=null,Ri=!1,Si=null,Ui=null,oj=!1,pj=null,qj=90,rj=null,sj=0,tj=null,uj=0;function Fg(){return(T&(Zi|$i))!==S?1073741821-(Vf()/10|0):0!==uj?uj:uj=1073741821-(Vf()/10|0)}
function Gg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=Wf();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&Zi)!==S)return W;if(null!==c)a=1073741821-25*(((1073741821-a+(c.timeoutMs|0||5E3)/10)/25|0)+1);else switch(d){case 99:a=1073741823;break;case 98:a=1073741821-10*(((1073741821-a+15)/10|0)+1);break;case 97:case 96:a=1073741821-25*(((1073741821-a+500)/25|0)+1);break;case 95:a=2;break;default:throw t(Error(326));}null!==U&&a===W&&--a;return a}var vj=0;
function Hg(a,b){if(50<sj)throw sj=0,tj=null,t(Error(185));a=wj(a,b);if(null!==a){var c=Wf();1073741823===b?(T&Yi)!==S&&(T&(Zi|$i))===S?xj(a):(Z(a),T===S&&bg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===rj?rj=new Map([[a,b]]):(c=rj.get(a),(void 0===c||c>b)&&rj.set(a,b)))}}
function wj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(zg(b),X===ej&&yj(e,W)),zj(e,b));return e}
function Aj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Bj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=$f(xj.bind(null,a));else{var b=Aj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Fg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Pf&&Ff(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?$f(xj.bind(null,a)):Zf(d,Cj.bind(null,a),{timeout:10*(1073741821-b)-Vf()});a.callbackNode=b}}}
function Cj(a,b){uj=0;if(b)return b=Fg(),Dj(a,b),Z(a),null;var c=Aj(a);if(0!==c){b=a.callbackNode;if((T&(Zi|$i))!==S)throw t(Error(327));Ej();a===U&&c===W||Fj(a,c);if(null!==V){var d=T;T|=Zi;var e=Gj(a);do try{Hj();break}catch(h){Ij(a,h)}while(1);hg();T=d;Wi.current=e;if(X===bj)throw b=hj,Fj(a,c),yj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,Jj(a,c),d=X,U=null,d){case aj:case bj:throw t(Error(345));case cj:if(2!==c){Dj(a,2);break}Kj(a);break;case dj:yj(a,
c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Lj(e));if(1073741823===ij&&(e=Mi+nj-Vf(),10<e)){if(mj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Fj(a,c);break}}f=Aj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=he(Kj.bind(null,a),e);break}Kj(a);break;case ej:yj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Lj(e));if(mj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Fj(a,c);break}e=Aj(a);if(0!==e&&e!==c)break;if(0!==
d&&d!==c){a.lastPingedTime=d;break}1073741823!==jj?d=10*(1073741821-jj)-Vf():1073741823===ij?d=0:(d=10*(1073741821-ij)-5E3,e=Vf(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*Vi(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=he(Kj.bind(null,a),d);break}Kj(a);break;case fj:if(1073741823!==ij&&null!==kj){f=ij;var g=kj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=Vf()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);
if(10<d){yj(a,c);a.timeoutHandle=he(Kj.bind(null,a),d);break}}Kj(a);break;case gj:yj(a,c);break;default:throw t(Error(329));}Z(a);if(a.callbackNode===b)return Cj.bind(null,a)}}return null}
function xj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Kj(a);else{if((T&(Zi|$i))!==S)throw t(Error(327));Ej();a===U&&b===W||Fj(a,b);if(null!==V){var c=T;T|=Zi;var d=Gj(a);do try{Mj();break}catch(e){Ij(a,e)}while(1);hg();T=c;Wi.current=d;if(X===bj)throw c=hj,Fj(a,b),yj(a,b),Z(a),c;if(null!==V)throw t(Error(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;Jj(a,b);X===gj?yj(a,b):(U=null,Kj(a));Z(a)}}return null}
function Nj(){(T&(1|Zi|$i))===S&&(Oj(),Ej())}function Jj(a,b){var c=a.firstBatch;null!==c&&c._defer&&c._expirationTime>=b&&(Zf(97,function(){c._onComplete();return null}),X=gj)}function Oj(){if(null!==rj){var a=rj;rj=null;a.forEach(function(a,c){Dj(c,a);Z(c)});bg()}}function Pj(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&bg()}}function Qj(a,b,c,d){var e=T;T|=4;try{return Yf(98,a.bind(null,b,c,d))}finally{T=e,T===S&&bg()}}
function Rj(a,b){var c=T;T&=-2;T|=Yi;try{return a(b)}finally{T=c,T===S&&bg()}}
function Fj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,ie(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&wf(d);break;case 3:dh(d);xf(d);break;case 5:fh(d);break;case 4:dh(d);break;case 13:H(O,d);break;case 19:H(O,d);break;case 10:jg(d)}c=c.return}U=a;V=Rg(a.current,null,b);W=b;X=aj;hj=null;jj=ij=1073741823;kj=null;lj=0;mj=!1}
function Ij(a,b){do{try{hg();Ah();if(null===V||null===V.return)return X=bj,hj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(O.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var A=k.memoizedProps;l=void 0===A.fallback?!1:!0!==A.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var w=k.updateQueue;if(null===w){var L=new Set;
L.add(g);k.updateQueue=L}else w.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var wb=rg(1073741823,null);wb.tag=2;tg(e,wb)}e.expirationTime=1073741823;break a}f=void 0;e=b;var M=c.pingCache;null===M?(M=c.pingCache=new Pi,f=new Set,M.set(g,f)):(f=M.get(g),void 0===f&&(f=new Set,M.set(g,f)));if(!f.has(e)){f.add(e);var q=Sj.bind(null,c,g,e);g.then(q,q)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Va(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Wa(e))}X!==fj&&(X=cj);f=ti(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var y=Qi(k,g,b);ug(k,y);break a;case 1:g=f;var z=k.type,p=k.stateNode;if((k.effectTag&64)===D&&("function"===typeof z.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===Ui||!Ui.has(p)))){k.effectTag|=4096;k.expirationTime=b;var u=Ti(k,g,b);ug(k,u);break a}}k=k.return}while(null!==k)}V=Tj(V)}catch(v){b=v;continue}break}while(1)}function Gj(){var a=Wi.current;Wi.current=zh;return null===a?zh:a}function yg(a,b){a<ij&&2<a&&(ij=a);null!==b&&a<jj&&2<a&&(jj=a,kj=b)}function zg(a){a>lj&&(lj=a)}function Mj(){for(;null!==V;)V=Uj(V)}function Hj(){for(;null!==V&&!Gf();)V=Uj(V)}
function Uj(a){var b=Vj(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=Tj(a));Xi.current=null;return b}
function Tj(a){V=a;do{var b=V.alternate;a=V.return;if((V.effectTag&2048)===D){a:{var c=b;b=V;var d=W,e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:N(b.type)&&wf(b);break;case 3:dh(b);xf(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);(null===c||null===c.child)&&Wh(b)&&mi(b);oi(b);break;case 5:fh(b);d=bh(ah.current);var f=b.type;if(null!==c&&null!=b.stateNode)pi(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
bh(Zg.current);if(Wh(b)){e=b;f=void 0;c=e.stateNode;var h=e.type,k=e.memoizedProps;c[me]=e;c[ne]=k;switch(h){case "iframe":case "object":case "embed":G("load",c);break;case "video":case "audio":for(var l=0;l<dc.length;l++)G(dc[l],c);break;case "source":G("error",c);break;case "img":case "image":case "link":G("error",c);G("load",c);break;case "form":G("reset",c);G("submit",c);break;case "details":G("toggle",c);break;case "input":Bb(c,k);G("invalid",c);Sd(d,"onChange");break;case "select":c._wrapperState=
{wasMultiple:!!k.multiple};G("invalid",c);Sd(d,"onChange");break;case "textarea":Lb(c,k),G("invalid",c),Sd(d,"onChange")}Qd(h,k);l=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?c.textContent!==g&&(l=["children",g]):"number"===typeof g&&c.textContent!==""+g&&(l=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&Sd(d,f));switch(h){case "input":yb(c);Gb(c,k,!0);break;case "textarea":yb(c);Nb(c,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(c.onclick=Td)}d=l;e.updateQueue=d;null!==d&&mi(b)}else{k=f;c=e;h=b;l=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(k));g===Ob.html?"script"===k?(k=l.createElement("div"),k.innerHTML="<script>\x3c/script>",l=k.removeChild(k.firstChild)):"string"===typeof c.is?l=l.createElement(k,{is:c.is}):(l=l.createElement(k),"select"===k&&(k=l,c.multiple?k.multiple=!0:c.size&&(k.size=c.size))):l=l.createElementNS(g,k);k=l;k[me]=h;k[ne]=c;c=k;ni(c,b,!1,!1);b.stateNode=c;g=d;var m=Rd(f,e);switch(f){case "iframe":case "object":case "embed":G("load",
c);d=e;break;case "video":case "audio":for(d=0;d<dc.length;d++)G(dc[d],c);d=e;break;case "source":G("error",c);d=e;break;case "img":case "image":case "link":G("error",c);G("load",c);d=e;break;case "form":G("reset",c);G("submit",c);d=e;break;case "details":G("toggle",c);d=e;break;case "input":Bb(c,e);d=Ab(c,e);G("invalid",c);Sd(g,"onChange");break;case "option":d=Ib(c,e);break;case "select":c._wrapperState={wasMultiple:!!e.multiple};d=n({},e,{value:void 0});G("invalid",c);Sd(g,"onChange");break;case "textarea":Lb(c,
e);d=Kb(c,e);G("invalid",c);Sd(g,"onChange");break;default:d=e}Qd(f,d);h=void 0;k=f;l=c;var A=d;for(h in A)if(A.hasOwnProperty(h)){var w=A[h];"style"===h?Od(l,w):"dangerouslySetInnerHTML"===h?(w=w?w.__html:void 0,null!=w&&Sb(l,w)):"children"===h?"string"===typeof w?("textarea"!==k||""!==w)&&Tb(l,w):"number"===typeof w&&Tb(l,""+w):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=w&&Sd(g,h):null!=w&&ub(l,h,w,m))}switch(f){case "input":yb(c);
Gb(c,e,!1);break;case "textarea":yb(c);Nb(c,e);break;case "option":null!=e.value&&c.setAttribute("value",""+tb(e.value));break;case "select":d=c;c=e;d.multiple=!!c.multiple;h=c.value;null!=h?Jb(d,!!c.multiple,h,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(c.onclick=Td)}fe(f,e)&&mi(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw t(Error(166));break;case 6:if(c&&null!=b.stateNode)qi(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw t(Error(166));f=bh(ah.current);bh(Zg.current);Wh(b)?(d=b.stateNode,e=b.memoizedProps,d[me]=b,d.nodeValue!==e&&mi(b)):(d=b,e=(9===f.nodeType?f:f.ownerDocument).createTextNode(e),e[me]=b,d.stateNode=e)}break;case 11:break;case 13:H(O,b);e=b.memoizedState;if((b.effectTag&64)!==D){b.expirationTime=d;break a}d=null!==e;e=!1;null===c?Wh(b):(f=c.memoizedState,e=null!==f,d||null===f||(f=c.child.sibling,null!==f&&(h=b.firstEffect,null!==h?(b.firstEffect=f,f.nextEffect=h):
(b.firstEffect=b.lastEffect=f,f.nextEffect=null),f.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(O.current&1))X===aj&&(X=dj);else{if(X===aj||X===dj)X=ej;0!==lj&&null!==U&&(yj(U,W),zj(U,lj))}if(d||e)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:dh(b);oi(b);break;case 10:jg(b);break;case 9:break;case 14:break;case 17:N(b.type)&&wf(b);break;case 19:H(O,b);e=b.memoizedState;if(null===e)break;f=(b.effectTag&64)!==D;h=e.rendering;
if(null===h)if(f)ri(e,!1);else{if(X!==aj||null!==c&&(c.effectTag&64)!==D)for(c=b.child;null!==c;){h=gh(c);if(null!==h){b.effectTag|=64;ri(e,!1);e=h.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);b.firstEffect=b.lastEffect=null;for(e=b.child;null!==e;)f=e,c=d,f.effectTag&=E,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,h=f.alternate,null===h?(f.childExpirationTime=0,f.expirationTime=c,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null):(f.childExpirationTime=
h.childExpirationTime,f.expirationTime=h.expirationTime,f.child=h.child,f.memoizedProps=h.memoizedProps,f.memoizedState=h.memoizedState,f.updateQueue=h.updateQueue,c=h.dependencies,f.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),e=e.sibling;I(O,O.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=gh(h),null!==c){if(b.effectTag|=64,f=!0,ri(e,!0),null===e.tail&&"hidden"===e.tailMode){d=c.updateQueue;null!==d&&(b.updateQueue=
d,b.effectTag|=4);b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else Vf()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,ri(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(h.sibling=b.child,b.child=h):(d=e.last,null!==d?d.sibling=h:b.child=h,e.last=h)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=Vf()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=b.lastEffect;d.sibling=null;e=O.current;e=f?e&1|2:e&1;I(O,e,b);b=d;break a}break;case 20:break;
case 21:break;default:throw t(Error(156),b.tag);}b=null}d=V;if(1===W||1!==d.childExpirationTime){e=0;for(f=d.child;null!==f;)c=f.expirationTime,h=f.childExpirationTime,c>e&&(e=c),h>e&&(e=h),f=f.sibling;d.childExpirationTime=e}if(null!==b)return b;null!==a&&(a.effectTag&2048)===D&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=
V:a.firstEffect=V,a.lastEffect=V))}else{b=si(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===aj&&(X=fj);return null}function Lj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Kj(a){var b=Wf();Yf(99,Wj.bind(null,a,b));return null}
function Wj(a,b){Ej();if((T&(Zi|$i))!==S)throw t(Error(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw t(Error(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Lj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=d-1);d<=a.lastPingedTime&&
(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=$i;Xi.current=null;de=Dd;var g=Yd();if(Zd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,m=k.focusNode;k=k.focusOffset;
try{h.nodeType,m.nodeType}catch(Fb){h=null;break a}var A=0,w=-1,L=-1,wb=0,M=0,q=g,y=null;b:for(;;){for(var z;;){q!==h||0!==l&&3!==q.nodeType||(w=A+l);q!==m||0!==k&&3!==q.nodeType||(L=A+k);3===q.nodeType&&(A+=q.nodeValue.length);if(null===(z=q.firstChild))break;y=q;q=z}for(;;){if(q===g)break b;y===h&&++wb===l&&(w=A);y===m&&++M===k&&(L=A);if(null!==(z=q.nextSibling))break;q=y;y=q.parentNode}q=z}h=-1===w||-1===L?null:{start:w,end:L}}else h=null}h=h||{start:0,end:0}}else h=null;ee={focusedElem:g,selectionRange:h};
Dd=!1;Y=e;do try{Xj()}catch(Fb){if(null===Y)throw t(Error(330));xi(Y,Fb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var u=Y.alternate;if(null!==u){var v=u.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&(E|12|Ac)){case E:Ki(Y);Y.effectTag&=~E;break;case 6:Ki(Y);Y.effectTag&=~E;Li(Y.alternate,Y);break;case Ac:Y.effectTag&=~Ac;break;case 1028:Y.effectTag&=~Ac;Li(Y.alternate,Y);break;case 4:Li(Y.alternate,
Y);break;case 8:l=Y,Hi(g,l,h),Ii(l)}Y=Y.nextEffect}}catch(Fb){if(null===Y)throw t(Error(330));xi(Y,Fb);Y=Y.nextEffect}while(null!==Y);v=ee;u=Yd();p=v.focusedElem;h=v.selectionRange;if(u!==p&&p&&p.ownerDocument&&Xd(p.ownerDocument.documentElement,p)){null!==h&&Zd(p)&&(u=h.start,v=h.end,void 0===v&&(v=u),"selectionStart"in p?(p.selectionStart=u,p.selectionEnd=Math.min(v,p.value.length)):(v=(u=p.ownerDocument||document)&&u.defaultView||window,v.getSelection&&(v=v.getSelection(),l=p.textContent.length,
g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=Wd(p,g),m=Wd(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(u=u.createRange(),u.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(u),v.extend(m.node,m.offset)):(u.setEnd(m.node,m.offset),v.addRange(u))))));u=[];for(v=p;v=v.parentNode;)1===v.nodeType&&u.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===
typeof p.focus&&p.focus();for(p=0;p<u.length;p++)v=u[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}ee=null;Dd=!!de;de=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Bh=Y.effectTag;if(Bh&36){var cc=Y.alternate;u=Y;v=p;switch(u.tag){case 0:case 11:case 15:Ei(16,32,u);break;case 1:var ed=u.stateNode;if(u.effectTag&4)if(null===cc)ed.componentDidMount();else{var Zj=u.elementType===u.type?cc.memoizedProps:cg(u.type,cc.memoizedProps);ed.componentDidUpdate(Zj,cc.memoizedState,ed.__reactInternalSnapshotBeforeUpdate)}var Ch=
u.updateQueue;null!==Ch&&Ag(u,Ch,ed,v);break;case 3:var Dh=u.updateQueue;if(null!==Dh){g=null;if(null!==u.child)switch(u.child.tag){case 5:g=u.child.stateNode;break;case 1:g=u.child.stateNode}Ag(u,Dh,g,v)}break;case 5:var pk=u.stateNode;null===cc&&u.effectTag&4&&(v=pk,fe(u.type,u.memoizedProps)&&v.focus());break;case 6:break;case 4:break;case 12:break;case 13:if(null===u.memoizedState){var zi=u.alternate;if(null!==zi){var Ai=zi.memoizedState;if(null!==Ai){var Bi=Ai.dehydrated;null!==Bi&&zc(Bi)}}}break;
case 19:case 17:case 20:case 21:break;default:throw t(Error(163));}}if(Bh&128){u=Y;var yd=u.ref;if(null!==yd){var Ci=u.stateNode;switch(u.tag){case 5:var yf=Ci;break;default:yf=Ci}"function"===typeof yd?yd(yf):yd.current=yf}}Y=Y.nextEffect}}catch(Fb){if(null===Y)throw t(Error(330));xi(Y,Fb);Y=Y.nextEffect}while(null!==Y);Y=null;Qf();T=f}else a.current=c;if(oj)oj=!1,pj=a,qj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(Ui=null);1073741823===b?a===tj?sj++:
(sj=0,tj=a):sj=0;"function"===typeof Yj&&Yj(c.stateNode,d);Z(a);if(Ri)throw Ri=!1,a=Si,Si=null,a;if((T&Yi)!==S)return null;bg();return null}function Xj(){for(;null!==Y;){var a=Y.effectTag;(a&256)!==D&&Di(Y.alternate,Y);(a&512)===D||oj||(oj=!0,Zf(97,function(){Ej();return null}));Y=Y.nextEffect}}function Ej(){if(90!==qj){var a=97<qj?97:qj;qj=90;return Yf(a,ak)}}
function ak(){if(null===pj)return!1;var a=pj;pj=null;if((T&(Zi|$i))!==S)throw t(Error(331));var b=T;T|=$i;for(a=a.current.firstEffect;null!==a;){try{var c=a;if((c.effectTag&512)!==D)switch(c.tag){case 0:case 11:case 15:Ei(128,0,c),Ei(0,64,c)}}catch(d){if(null===a)throw t(Error(330));xi(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;bg();return!0}function bk(a,b,c){b=ti(c,b);b=Qi(a,b,1073741823);tg(a,b);a=wj(a,1073741823);null!==a&&Z(a)}
function xi(a,b){if(3===a.tag)bk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){bk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ui||!Ui.has(d))){a=ti(b,a);a=Ti(c,a,1073741823);tg(c,a);c=wj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Sj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===ej||X===dj&&1073741823===ij&&Vf()-Mi<nj?Fj(a,W):mj=!0:Bj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function Oi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=1;1===b&&(b=Fg(),b=Gg(b,a,null));a=wj(a,b);null!==a&&Z(a)}var Vj;
Vj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)mg=!0;else{if(d<c){mg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:eh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:N(b.type)&&Bf(b);break;case 4:ch(b,b.stateNode.containerInfo);break;case 10:ig(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return ji(a,b,c);I(O,O.current&
1,b);b=$h(a,b,c);return null!==b?b.sibling:null}I(O,O.current&1,b);break;case 19:d=b.childExpirationTime>=c;if((a.effectTag&64)!==D){if(d)return li(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(O,O.current,b);if(!d)return null}return $h(a,b,c)}mg=!1}}else mg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=E);a=b.pendingProps;e=vf(b,J.current);lg(b,c);e=wh(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Ah();if(N(d)){var f=!0;Bf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Eg(b,d,g,a);e.updater=Ig;b.stateNode=e;e._reactInternalFiber=b;Mg(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=E);a=b.pendingProps;Ua(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=ck(e);a=cg(e,a);switch(f){case 0:b=di(null,b,e,a,c);break;case 1:b=fi(null,b,e,a,c);break;case 11:b=Zh(null,b,e,a,c);break;case 14:b=ai(null,b,e,cg(e.type,a),d,c);break;default:throw t(Error(306),e,"");}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:cg(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:cg(d,e),fi(a,b,d,e,c);case 3:hi(b);d=b.updateQueue;if(null===d)throw t(Error(282));e=b.memoizedState;e=null!==e?e.element:
null;xg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=je(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Xg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&~E|Ac,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return eh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,ge(d,e)?g=null:null!==f&&ge(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return ch(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Wg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:cg(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;ig(b,f);if(null!==g){var h=g.value;f=ff(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=rg(c,null),l.tag=2,tg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);kg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,lg(b,c),e=ng(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=cg(e,b.pendingProps),f=cg(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:cg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=E),b.tag=1,N(d)?(a=!0,Bf(b)):a=!1,lg(b,c),Kg(b,d,e,c),Mg(b,d,e,c),gi(null,b,d,!0,a,c);case 19:return li(a,b,c)}throw t(Error(156),b.tag);};var Yj=null,Gi=null;
function dk(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Yj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Gi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function ek(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=D;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new ek(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function ck(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Na)return 11;if(a===Qa)return 14}return 2}
function Rg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=D,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Tg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ha:return Vg(c.children,e,f,b);case Ma:g=8;e|=7;break;case Ia:g=8;e|=1;break;case Ja:return a=Sh(12,c,b,e|8),a.elementType=Ja,a.type=Ja,a.expirationTime=f,a;case Oa:return a=Sh(13,c,b,e),a.type=Oa,a.elementType=Oa,a.expirationTime=f,a;case Pa:return a=Sh(19,c,b,e),a.elementType=Pa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case Ka:g=
10;break a;case La:g=9;break a;case Na:g=11;break a;case Qa:g=14;break a;case Ra:g=16;d=null;break a}throw t(Error(130),null==a?a:typeof a,"");}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Vg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Sg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Ug(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function fk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=this.firstBatch=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Bj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function yj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function zj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Dj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function gk(a,b,c,d,e,f){var g=b.current;a:if(c){c=c._reactInternalFiber;b:{if(Bc(c)!==c||1!==c.tag)throw t(Error(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(N(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw t(Error(171));}if(1===c.tag){var k=c.type;if(N(k)){c=Af(c,k,h);break a}}c=h}else c=tf;null===b.context?b.context=c:b.pendingContext=c;b=f;e=rg(d,e);e.payload={element:a};b=void 0===b?null:b;null!==b&&
(e.callback=b);tg(g,e);Hg(g,d);return d}function hk(a,b,c,d){var e=b.current,f=Fg(),g=Cg.suspense;e=Gg(f,e,g);return gk(a,b,c,e,g,d)}function ik(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ga,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ya=function(a,b,c){switch(b){case "input":Db(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=re(d);if(!e)throw t(Error(90));zb(d);Db(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};
function kk(a){var b=1073741821-25*(((1073741821-Fg()+500)/25|0)+1);b<=vj&&--b;this._expirationTime=vj=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}kk.prototype.render=function(a){if(!this._defer)throw t(Error(250));this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new lk;gk(a,b,null,c,null,d._onCommit);return d};
kk.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
kk.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;if(!this._defer||null===b)throw t(Error(251));if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;if(null===d)throw t(Error(251));d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;if((T&(Zi|$i))!==S)throw t(Error(253));Dj(a,b);Z(a);bg();b=this._next;this._next=null;
b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};kk.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function lk(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}lk.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
lk.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];if("function"!==typeof c)throw t(Error(191),c);c()}}};function mk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new fk(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[oe]=d.current;c&&0!==b&&nc(9===a.nodeType?a:a.ownerDocument);return d}function nk(a,b,c){this._internalRoot=mk(a,b,c)}function ok(a,b){this._internalRoot=mk(a,2,b)}
ok.prototype.render=nk.prototype.render=function(a,b){var c=this._internalRoot,d=new lk;b=void 0===b?null:b;null!==b&&d.then(b);hk(a,c,null,d._onCommit);return d};ok.prototype.unmount=nk.prototype.unmount=function(a){var b=this._internalRoot,c=new lk;a=void 0===a?null:a;null!==a&&c.then(a);hk(null,b,null,c._onCommit);return c};
ok.prototype.createBatch=function(){var a=new kk(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function qk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}db=Pj;eb=Qj;fb=Nj;gb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&bg()}};
function rk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new nk(a,0,b?{hydrate:!0}:void 0)}
function sk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ik(g);h.call(a)}}hk(b,g,a,e)}else{f=c._reactRootContainer=rk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ik(g);k.call(a)}}Rj(function(){hk(b,g,a,e)})}return ik(g)}function tk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!qk(b))throw t(Error(200));return jk(a,b,null,c)}
var wk={createPortal:tk,findDOMNode:function(a){if(null==a)a=null;else if(1!==a.nodeType){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw t(Error(188));throw t(Error(268),Object.keys(a));}a=Ec(b);a=null===a?null:a.stateNode}return a},hydrate:function(a,b,c){if(!qk(b))throw t(Error(200));return sk(null,a,b,!0,c)},render:function(a,b,c){if(!qk(b))throw t(Error(200));return sk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!qk(c))throw t(Error(200));
if(null==a||void 0===a._reactInternalFiber)throw t(Error(38));return sk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!qk(a))throw t(Error(40));return a._reactRootContainer?(Rj(function(){sk(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return tk.apply(void 0,arguments)},unstable_batchedUpdates:Pj,unstable_interactiveUpdates:function(a,b,c,d){Nj();return Qj(a,b,c,d)},unstable_discreteUpdates:Qj,unstable_flushDiscreteUpdates:Nj,flushSync:function(a,
b){if((T&(Zi|$i))!==S)throw t(Error(187));var c=T;T|=1;try{return Yf(99,a.bind(null,b))}finally{T=c,bg()}},unstable_createRoot:uk,unstable_createSyncRoot:vk,unstable_flushControlled:function(a){var b=T;T|=1;try{Yf(99,a)}finally{T=b,T===S&&bg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[pe,qe,re,Ba.injectEventPluginsByName,fa,Lc,function(a){xa(a,Kc)},bb,cb,Hd,Aa,Ej,{current:!1}]}};function uk(a,b){if(!qk(a))throw t(Error(299),"unstable_createRoot");return new ok(a,b)}
function vk(a,b){if(!qk(a))throw t(Error(299),"unstable_createRoot");return new nk(a,1,b)}
(function(a){var b=a.findFiberByHostInstance;return dk(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Da.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=Ec(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Cd,bundleType:0,version:"16.10.1",
rendererPackageName:"react-dom"});var xk={default:wk},yk=xk&&wk||xk;module.exports=yk.default||yk;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(65);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.16.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout,A=window.requestAnimationFrame,B=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));if("object"===typeof w&&
"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var C=x.now();exports.unstable_now=function(){return x.now()-C}}var D=!1,E=null,F=-1,G=5,H=0;k=function(){return exports.unstable_now()>=H};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):G=0<a?Math.floor(1E3/a):33.33};var I=new MessageChannel,J=I.port2;I.port1.onmessage=
function(){if(null!==E){var a=exports.unstable_now();H=a+G;try{E(!0,a)?J.postMessage(null):(D=!1,E=null)}catch(b){throw J.postMessage(null),b;}}else D=!1};f=function(a){E=a;D||(D=!0,J.postMessage(null))};g=function(a,b){F=y(function(){a(exports.unstable_now())},b)};h=function(){z(F);F=-1}}function K(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<L(e,b))a[d]=b,a[c]=e,c=d;else break a}}function M(a){a=a[0];return void 0===a?null:a}
function N(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>L(n,c))void 0!==r&&0>L(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>L(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function L(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var O=[],P=[],Q=1,R=null,S=3,T=!1,U=!1,V=!1;
function W(a){for(var b=M(P);null!==b;){if(null===b.callback)N(P);else if(b.startTime<=a)N(P),b.sortIndex=b.expirationTime,K(O,b);else break;b=M(P)}}function X(a){V=!1;W(a);if(!U)if(null!==M(O))U=!0,f(Y);else{var b=M(P);null!==b&&g(X,b.startTime-a)}}
function Y(a,b){U=!1;V&&(V=!1,h());T=!0;var c=S;try{W(b);for(R=M(O);null!==R&&(!(R.expirationTime>b)||a&&!k());){var d=R.callback;if(null!==d){R.callback=null;S=R.priorityLevel;var e=d(R.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?R.callback=e:R===M(O)&&N(O);W(b)}else N(O);R=M(O)}if(null!==R)var m=!0;else{var n=M(P);null!==n&&g(X,n.startTime-b);m=!1}return m}finally{R=null,S=c,T=!1}}
function Z(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var aa=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=S;S=a;try{return b()}finally{S=c}};
exports.unstable_next=function(a){switch(S){case 1:case 2:case 3:var b=3;break;default:b=S}var c=S;S=b;try{return a()}finally{S=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Z(a)}else c=Z(a),e=d;c=e+c;a={id:Q++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,K(P,a),null===M(O)&&a===M(P)&&(V?h():V=!0,g(X,e-d))):(a.sortIndex=c,K(O,a),U||T||(U=!0,f(Y)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=S;return function(){var c=S;S=b;try{return a.apply(this,arguments)}finally{S=c}}};exports.unstable_getCurrentPriorityLevel=function(){return S};exports.unstable_shouldYield=function(){var a=exports.unstable_now();W(a);var b=M(O);return b!==R&&null!==R&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<R.expirationTime||k()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){U||T||(U=!0,f(Y))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M(O)};exports.unstable_Profiling=null;


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export register */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register(config) {
    if ("production" === 'production' && 'serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        var publicUrl = new URL("https://static.persona.ly", window.location.href);
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebook/create-react-app/issues/2374
            return;
        }
        window.addEventListener('load', function () {
            var swUrl = "https://static.persona.ly" + "/service-worker.js";
            if (isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(function () {
                    console.log('This web app is being served cache-first by a service ' +
                        'worker. To learn more, visit https://bit.ly/CRA-PWA');
                });
            }
            else {
                // Is not localhost. Just register service worker
                registerValidSW(swUrl, config);
            }
        });
    }
}
function registerValidSW(swUrl, config) {
    navigator.serviceWorker
        .register(swUrl)
        .then(function (registration) {
        registration.onupdatefound = function () {
            var installingWorker = registration.installing;
            if (installingWorker == null) {
                return;
            }
            installingWorker.onstatechange = function () {
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log('New content is available and will be used when all ' +
                            'tabs for this page are closed. See https://bit.ly/CRA-PWA.');
                        // Execute callback
                        if (config && config.onUpdate) {
                            config.onUpdate(registration);
                        }
                    }
                    else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log('Content is cached for offline use.');
                        // Execute callback
                        if (config && config.onSuccess) {
                            config.onSuccess(registration);
                        }
                    }
                }
            };
        };
    })
        .catch(function (error) {
        console.error('Error during service worker registration:', error);
    });
}
function checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl)
        .then(function (response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        var contentType = response.headers.get('content-type');
        if (response.status === 404 ||
            (contentType != null && contentType.indexOf('javascript') === -1)) {
            // No service worker found. Probably a different app. Reload the page.
            navigator.serviceWorker.ready.then(function (registration) {
                registration.unregister().then(function () {
                    window.location.reload();
                });
            });
        }
        else {
            // Service worker found. Proceed as normal.
            registerValidSW(swUrl, config);
        }
    })
        .catch(function () {
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(function (registration) {
            registration.unregister();
        });
    }
}


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(68);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_info_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_info_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_info_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__(2);





var InfoBlock = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('footer'), t = _a.t, i18n = _a.i18n;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "info-container", style: Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["k" /* getFont */])(i18n) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "info" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "not-tablet not-mobile" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "mailto:info@persona.ly" }, "INFO@PERSONA.LY")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "not-tablet not-mobile" }, "+1-888-724-8205"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "not-mobile" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "privacy_policy" }, t('privacy policy'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "not-mobile" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "terms_use" }, t('terms of use'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                t('all rights 1'),
                new Date().getFullYear(),
                t('all rights 2')))));
};
/* harmony default export */ __webpack_exports__["a"] = (InfoBlock);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nodesToString */
/* unused harmony export Trans */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify2__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html_parse_stringify2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(16);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  if (!node) return [];
  return node && node.children ? node.children : node.props && node.props.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function nodesToString(startingString, children, index, i18nOptions) {
  if (!children) return '';
  var stringNode = startingString;
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  childrenArray.forEach(function (child, i) {
    var elementKey = "".concat(i);

    if (typeof child === 'string') {
      stringNode = "".concat(stringNode).concat(child);
    } else if (hasChildren(child)) {
      var elementTag = keepArray.indexOf(child.type) > -1 && Object.keys(child.props).length === 1 && typeof hasChildren(child) === 'string' ? child.type : elementKey;

      if (child.props && child.props.i18nIsDynamicList) {
        // we got a dynamic list like "<ul>{['a', 'b'].map(item => ( <li key={item}>{item}</li> ))}</ul>""
        // the result should be "<0></0>" and not "<0><0>a</0><1>b</1></0>"
        stringNode = "".concat(stringNode, "<").concat(elementTag, "></").concat(elementTag, ">");
      } else {
        // regular case mapping the inner children
        stringNode = "".concat(stringNode, "<").concat(elementTag, ">").concat(nodesToString('', getChildren(child), i + 1, i18nOptions), "</").concat(elementTag, ">");
      }
    } else if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child)) {
      if (keepArray.indexOf(child.type) > -1 && Object.keys(child.props).length === 0) {
        stringNode = "".concat(stringNode, "<").concat(child.type, "/>");
      } else {
        stringNode = "".concat(stringNode, "<").concat(elementKey, "></").concat(elementKey, ">");
      }
    } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(child) === 'object') {
      var clone = _objectSpread({}, child);

      var format = clone.format;
      delete clone.format;
      var keys = Object.keys(clone);

      if (format && keys.length === 1) {
        stringNode = "".concat(stringNode, "{{").concat(keys[0], ", ").concat(format, "}}");
      } else if (keys.length === 1) {
        stringNode = "".concat(stringNode, "{{").concat(keys[0], "}}");
      } else {
        // not a valid interpolation object (can only contain one value plus format)
        Object(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* warn */])("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* warn */])("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts) {
  if (targetString === '') return []; // check if contains tags we need to replace from html string to react nodes

  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString); // no need to replace tags in the targetstring

  if (!children && !emptyChildrenButNeedsHandling) return [targetString]; // v2 -> interpolates upfront no need for "some <0>{{var}}</0>"" -> will be just "some {{var}}" in translation file

  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(child) === 'object' && !__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var interpolatedString = i18n.services.interpolator.interpolate(targetString, _objectSpread({}, data, {}, combinedTOpts), i18n.language); // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes

  var ast = __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify2___default.a.parse("<0>".concat(interpolatedString, "</0>"));

  function mapAST(reactNode, astNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content;

      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = __WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var childs = getChildren(child);
          var mappedChildren = mapAST(childs, node.children);
          var inner = hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
          if (child.dummy) child.children = inner; // needed on preact!

          mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, _objectSpread({}, child.props, {
            key: i
          }), inner));
        } else if (emptyChildrenButNeedsHandling && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(child) === 'object' && child.dummy && !isElement) {
          // we have a empty Trans node (the dummy element) with a targetstring that contains html tags needing
          // conversion to react nodes
          // so we just need to map the inner stuff
          var _inner = mapAST(reactNodes
          /* wrong but we need something */
          , node.children);

          mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, _objectSpread({}, child.props, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner2 = mapAST(reactNodes
              /* wrong but we need something */
              , node.children);

              mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner2));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner3 = mapAST(reactNodes
            /* wrong but we need something */
            , node.children);

            mem.push("<".concat(node.name, ">").concat(_inner3, "</").concat(node.name, ">"));
          }
        } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null; // v1
          // as interpolation was done already we just have a regular content node
          // in the translation AST while having an object in reactNodes
          // -> push the content no need to interpolate again

          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          // If component does not have children, but translation - has
          // with this in component could be components={[<span class='make-beautiful'/>]} and in translation - 'some text <0>some highlighted message</0>'
          mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, _objectSpread({}, child.props, {
            key: i
          }), translationContent));
        } else {
          mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, _objectSpread({}, child.props, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }

      return mem;
    }, []);
  } // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result


  var result = mapAST([{
    dummy: true,
    children: children
  }], ast);
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      tOptions = _ref.tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      additionalProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["children", "count", "parent", "i18nKey", "tOptions", "values", "defaults", "components", "ns", "i18n", "t"]);

  var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_5__context__["e" /* getHasUsedI18nextProvider */])() ? Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context__["a" /* I18nContext */]) || {} : {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || Object(__WEBPACK_IMPORTED_MODULE_5__context__["f" /* getI18n */])();

  if (!i18n) {
    Object(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* warnOnce */])('You will need pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  var reactI18nextOptions = _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_5__context__["d" /* getDefaults */])(), {}, i18n.options && i18n.options.react);

  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent; // prepare having a namespace

  var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString('', children, 0, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? {} : {
    interpolation: {
      prefix: '#$?',
      suffix: '?$#'
    }
  };

  var combinedTOpts = _objectSpread({}, tOptions, {
    count: count
  }, values, {}, interpolationOverride, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  if (!useAsParent) return renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(useAsParent, additionalProps, renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts));
}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__(76),
    stringify: __webpack_require__(79)
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__(77);
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__(78);

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withTranslation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useTranslation__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(16);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["forwardedRef"]);

      var _useTranslation = Object(__WEBPACK_IMPORTED_MODULE_4__useTranslation__["a" /* useTranslation */])(ns, rest),
          _useTranslation2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = _objectSpread({}, rest, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getDisplayName */])(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(forwardRef) : I18nextWithTranslation;
  };
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Translation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useTranslation__ = __webpack_require__(21);



function Translation(props) {
  var ns = props.ns,
      children = props.children,
      options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(props, ["ns", "children"]);

  var _useTranslation = Object(__WEBPACK_IMPORTED_MODULE_2__useTranslation__["a" /* useTranslation */])(ns, options),
      _useTranslation2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useTranslation, 3),
      t = _useTranslation2[0],
      i18n = _useTranslation2[1],
      ready = _useTranslation2[2];

  return children(t, {
    i18n: i18n,
    lng: i18n.language
  }, ready);
}

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export I18nextProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context__ = __webpack_require__(10);


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  Object(__WEBPACK_IMPORTED_MODULE_1__context__["h" /* usedI18nextProvider */])(true);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__context__["a" /* I18nContext */].Provider, {
    value: {
      i18n: i18n,
      defaultNS: defaultNS
    }
  }, children);
}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withSSR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useSSR__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(16);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      var initialI18nStore = _ref.initialI18nStore,
          initialLanguage = _ref.initialLanguage,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["initialI18nStore", "initialLanguage"]);

      Object(__WEBPACK_IMPORTED_MODULE_3__useSSR__["a" /* useSSR */])(initialI18nStore, initialLanguage);
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrappedComponent, _objectSpread({}, rest));
    }

    I18nextWithSSR.getInitialProps = Object(__WEBPACK_IMPORTED_MODULE_4__context__["c" /* composeInitialProps */])(WrappedComponent);
    I18nextWithSSR.displayName = "withI18nextSSR(".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getDisplayName */])(WrappedComponent), ")");
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(96);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default()() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 94 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(99)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.10.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(39);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_topbar_css__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_topbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_topbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_locales__ = __webpack_require__(6);








var SUB_MENU_VISIBLE = 'sub-menu sub-menu-visible';
var SUB_MENU_HIDDEN = 'sub-menu sub-menu-hidden';
var TopBar = function (props) {
    var _a;
    var appContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* AppContext */]);
    var topbarColor = appContext.topbarColor, setTopbarColor = appContext.setTopbarColor;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('topbar'), t = _b.t, i18n = _b.i18n;
    var isMobile = window.innerWidth <= 1104;
    var handleClick = function (e) {
        var subMenu1Button = document.getElementById('sub-menu-1-b');
        var subMenu2Button = document.getElementById('sub-menu-2-b');
        if (isMobile) {
            var menuButton = document.getElementById('menu-toggle');
            var menuButtonS = document.getElementById('menu-toggle-s');
            if (e.target != menuButton && e.target != menuButtonS) {
                menuButton.checked = e.target == subMenu1Button || e.target == subMenu2Button;
            }
        }
        else {
            var subMenu1 = document.getElementById('sub-menu-1');
            var subMenu2 = document.getElementById('sub-menu-2');
            var subMenu3 = document.getElementById('sub-menu-3');
            var subMenu3Button = document.getElementById('sub-menu-3-b');
            var subMenu3ButtonImg = document.getElementById('sub-menu-3-b-i');
            subMenu1.className = e.target == subMenu1Button ? SUB_MENU_VISIBLE : SUB_MENU_HIDDEN;
            subMenu2.className = e.target == subMenu2Button ? SUB_MENU_VISIBLE : SUB_MENU_HIDDEN;
            subMenu3.className = e.target == subMenu3Button || e.target == subMenu3ButtonImg ? SUB_MENU_VISIBLE : SUB_MENU_HIDDEN;
        }
    };
    var handleWindowSize = function () {
        isMobile = window.innerWidth <= 1104;
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        window.addEventListener('resize', handleWindowSize);
        document.onclick = handleClick;
    }, []);
    var path = props.location.pathname.substring(3);
    var hash = props.location.hash;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        switch (path) {
            case '/contact':
            case '/rtb':
                setTopbarColor(__WEBPACK_IMPORTED_MODULE_5__util_util__["g" /* TOPBAR_COLOR_AQUA */]);
                break;
            case '/monetization':
                setTopbarColor(__WEBPACK_IMPORTED_MODULE_5__util_util__["h" /* TOPBAR_COLOR_RED */]);
                break;
            default:
                setTopbarColor(__WEBPACK_IMPORTED_MODULE_5__util_util__["f" /* TOPBAR_COLOR_ACCENT */]);
        }
    }, [props.location.pathname]);
    var handleChangeLanguage = function (lang) {
        i18n.changeLanguage(lang);
        props.history.push('/' + lang + path + hash);
        Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["u" /* updateMuliFont */])(lang);
    };
    var langImage = (_a = __WEBPACK_IMPORTED_MODULE_5__util_util__["q" /* localeToInternalLang */].get(i18n.language)) === null || _a === void 0 ? void 0 : _a.flag;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "topbar-container", style: Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["k" /* getFont */])(i18n) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "topbar" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: '/' + Object(__WEBPACK_IMPORTED_MODULE_6__util_locales__["b" /* getCurrentLocale */])() },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/logo_personaly.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { id: "menu-toggle", type: "checkbox" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "menu__btn", htmlFor: "menu-toggle" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { id: "menu-toggle-s" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: 'menu ' + topbarColor.hoverColor, style: !isMobile && i18n.language.includes(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].ru) ? { fontSize: 14 } : {} },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "menu-i-with-sub" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { id: "sub-menu-1-b" }, t('programmatic')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { id: "sub-menu-1", className: "sub-menu sub-menu-hidden" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "rtb" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: path == '/rtb' && hash != '#retargeting' ? topbarColor.linkColor : '' }, t('ua'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "rtb#retargeting" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: hash == '#retargeting' ? topbarColor.linkColor : '' }, t('retargeting'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://dashboard.personaly.bid", target: "_blank", rel: "noopener noreferrer" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('dashboard'))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: path == '/monetization' ? topbarColor.linkColor : '' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "monetization" }, t('monetization'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: handleClick, className: path == '/market-research' ? topbarColor.linkColor : '' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "market-research" }, t('market research'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: path == '/about' && hash != '#contact' ? topbarColor.linkColor : '' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "about" }, t('about'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "menu-i-with-sub" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { id: "sub-menu-2-b" }, t('resources')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { id: "sub-menu-2", className: "sub-menu sub-menu-hidden" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: '/blog/' + (i18n.language.includes(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].en) ? '' : i18n.language.substring(0, 2)) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('blog'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/glossary" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "UA Glossary")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "rtb#case-studies" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: hash == '#case-studies' ? topbarColor.linkColor : '' }, "Case Studies")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "http://knowledge.persona.ly" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('knowledge base'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "context-distance-calculator" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: path == '/context-distance-calculator' ? topbarColor.linkColor : '' }, t('context distance calculator'))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: hash == '#contact' ? topbarColor.linkColor : '' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "about#contact" }, t('contact'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "login" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "login" }, t('login'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["l" /* getSignUpPath */])(path) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: topbarColor.buttonColor }, t('get started')))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "not-mobile not-tablet" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { id: "sub-menu-3-b-i", src: langImage || 'https://static.persona.ly/images/usa.svg' }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { id: "sub-menu-3-b" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { id: "sub-menu-3", className: "sub-menu sub-menu-hidden" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].en); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/usa.svg" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('english'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].zh); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/china.svg" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('chinese'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].ja); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/japan.svg" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('japanese'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].ko); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/korea.svg" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('korean'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].ru); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/russia.svg" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('russian'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].id); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/indonesia.svg" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('indonesian'))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "sub-menu-mobile" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "sub-menu sub-menu-hidden" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].en); } }, t('en')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "/"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].zh); } }, t('chi')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "/"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].ja); } }, t('jp')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "/"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].ko); } }, t('kor')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "/"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].ru); } }, t('ru')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "/"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { onClick: function () { return handleChangeLanguage(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].id); } }, t('id'))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (TopBar);


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notification__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_footer__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_common_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__css_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_about__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_contact__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_forgotPassword__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_gdpr__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_getInTouch__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_ghostCompletions__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_landing__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_login__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_marketResearch__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_monetization__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_mrContact__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_privacyDsp__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_privacyPolicy__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_privacySdk__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_register__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_restored__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_rtb__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_security__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_termsUse__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_welcome__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_contextDistanceCalculator__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__util_locales__ = __webpack_require__(6);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/camelcase */































var baseLocaleUrl = "/:locale(" + __WEBPACK_IMPORTED_MODULE_29__util_locales__["a" /* availableLocales */].join('|') + ")";
var routes = Object.freeze({
    white_papersGhost_completes_mr_05_2020: '/white_papers/ghost_completes_mr_05_2020',
    marketResearch: '/market-research',
    forgot_password: '/forgot_password',
    privacy_policy: '/privacy_policy',
    monetization: '/monetization',
    privacy_dsp: '/privacy_dsp',
    privacy_sdk: '/privacy_sdk',
    welcomeBack: '/welcomeBack',
    getInTouch: '/getInTouch',
    mrcontact: '/mrcontact',
    terms_use: '/terms_use',
    security: '/security',
    restored: '/restored',
    sign_up: '/sign_up',
    welcome: '/welcome',
    contact: '/contact',
    about: '/about',
    login: '/login',
    gdpr: '/gdpr',
    rtb: '/rtb',
    contextDistanceCalculator: '/context-distance-calculator',
});
var PageContent = function (props) {
    var i18n = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])('landing').i18n;
    var simple = Object(__WEBPACK_IMPORTED_MODULE_28__util_util__["p" /* isSimplePage */])(props.location.pathname);
    var lastLocaleRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(Object(__WEBPACK_IMPORTED_MODULE_29__util_locales__["b" /* getCurrentLocale */])());
    var path = props.location.pathname;
    var currentLocale = '/' + (Object(__WEBPACK_IMPORTED_MODULE_29__util_locales__["b" /* getCurrentLocale */])('dontPassDefaultEn') || lastLocaleRef.current);
    var pathWithoutLocale = path.replace(currentLocale, '');
    var isPathValid = Object.values(routes).some(function (route) { return pathWithoutLocale.startsWith(route); });
    if (Object(__WEBPACK_IMPORTED_MODULE_29__util_locales__["b" /* getCurrentLocale */])('dontPassDefaultEn')) {
        lastLocaleRef.current = Object(__WEBPACK_IMPORTED_MODULE_29__util_locales__["b" /* getCurrentLocale */])('dontPassDefaultEn');
    }
    var redirectTo = isPathValid ? pathWithoutLocale + props.location.search + props.location.hash : '';
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'page-content' + (simple ? ' simple-bg' : ''), style: Object(__WEBPACK_IMPORTED_MODULE_28__util_util__["k" /* getFont */])(i18n) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_helmet__["a" /* Helmet */], { htmlAttributes: { lang: Object(__WEBPACK_IMPORTED_MODULE_29__util_locales__["b" /* getCurrentLocale */])() } }, __WEBPACK_IMPORTED_MODULE_29__util_locales__["a" /* availableLocales */].map(function (locale) {
            if (currentLocale.includes(locale))
                return;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("link", { key: locale, rel: "alternate", hrefLang: locale, href: "/" + locale + redirectTo });
        })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Router */], { history: props.history },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* Switch */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { exact: true, path: baseLocaleUrl, component: __WEBPACK_IMPORTED_MODULE_13__pages_landing__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.white_papersGhost_completes_mr_05_2020, component: __WEBPACK_IMPORTED_MODULE_12__pages_ghostCompletions__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.marketResearch, component: __WEBPACK_IMPORTED_MODULE_15__pages_marketResearch__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.forgot_password, component: __WEBPACK_IMPORTED_MODULE_9__pages_forgotPassword__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.privacy_policy, component: __WEBPACK_IMPORTED_MODULE_19__pages_privacyPolicy__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.monetization, component: __WEBPACK_IMPORTED_MODULE_16__pages_monetization__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.privacy_dsp, component: __WEBPACK_IMPORTED_MODULE_18__pages_privacyDsp__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.privacy_sdk, component: __WEBPACK_IMPORTED_MODULE_20__pages_privacySdk__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.welcomeBack, component: __WEBPACK_IMPORTED_MODULE_26__pages_welcome__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.getInTouch, component: __WEBPACK_IMPORTED_MODULE_11__pages_getInTouch__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.mrcontact, component: __WEBPACK_IMPORTED_MODULE_17__pages_mrContact__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.terms_use, component: __WEBPACK_IMPORTED_MODULE_25__pages_termsUse__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.security, component: __WEBPACK_IMPORTED_MODULE_24__pages_security__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.restored, component: __WEBPACK_IMPORTED_MODULE_22__pages_restored__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.sign_up, component: __WEBPACK_IMPORTED_MODULE_21__pages_register__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.welcome, component: __WEBPACK_IMPORTED_MODULE_26__pages_welcome__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.contact, component: __WEBPACK_IMPORTED_MODULE_8__pages_contact__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.about, component: __WEBPACK_IMPORTED_MODULE_7__pages_about__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.login, component: __WEBPACK_IMPORTED_MODULE_14__pages_login__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.gdpr, component: __WEBPACK_IMPORTED_MODULE_10__pages_gdpr__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.rtb, component: __WEBPACK_IMPORTED_MODULE_23__pages_rtb__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */], { path: baseLocaleUrl + routes.contextDistanceCalculator, component: __WEBPACK_IMPORTED_MODULE_27__pages_contextDistanceCalculator__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Redirect */], { to: currentLocale + redirectTo }))),
        !simple && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_footer__["a" /* default */], __assign({}, props)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_notification__["a" /* Notification */], null)));
};
/* harmony default export */ __webpack_exports__["a"] = (PageContent);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_notification_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useShowNotification__ = __webpack_require__(113);





var Notification = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('notification').t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_4__hooks_useShowNotification__["a" /* useShowNotification */])(), isNotificationVisible = _a[0], hideNotification = _a[1];
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "news-notification " + (isNotificationVisible && 'news-notification_visible') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "news-notification__close-button", src: "https://static.persona.ly/images/notification/notification_close.svg", onClick: hideNotification }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "news-notification__image", src: "https://static.persona.ly/images/notification/Rummy-Circle-Logo.webp" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "news-notification__content" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", { className: "news-notification__title" }, Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["t" /* tagger */])(t('title'), 'news-notification__nowrap')),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "news-notification__text" }, Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["t" /* tagger */])(t('text'), 'news-notification__link', '', true)))));
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useShowNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useShowNotification = function () {
    var itemName = 'news_notification_timestamp';
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
        var notificationItem = localStorage.getItem(itemName);
        if (!notificationItem) {
            localStorage.setItem(itemName, Date.now().toString());
            notificationItem = Date.now().toString();
        }
        var notificationTimestamp = +notificationItem;
        var currentShowingTime = Date.now() - notificationTimestamp;
        var isNotificationVisible = currentShowingTime < 30000;
        return isNotificationVisible;
    }), isNotificationVisible = _a[0], setIsNotificationVisible = _a[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var notificationItem = localStorage.getItem(itemName);
        if (notificationItem) {
            var notificationTimestamp = +notificationItem;
            var currentShowingTime = Date.now() - notificationTimestamp;
            var timerId_1 = setTimeout(function () { return setIsNotificationVisible(false); }, 30000 - currentShowingTime);
            return function () { return clearTimeout(timerId_1); };
        }
        return;
    });
    var hideNotification = function () {
        localStorage.setItem(itemName, (Date.now() - 30000).toString());
        setIsNotificationVisible(false);
    };
    return [isNotificationVisible, hideNotification];
};


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_footer_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_locales__ = __webpack_require__(6);







var takeYouAppMap = new Map([
    ['/', 'Lets take your a'],
    ['/rtb', 'RTB Lets build'],
    ['/monetization', 'Monetize'],
    ['/market-research', 'MR Reach']
]);
var Footer = function (props) {
    var shortFooterPaths = [
        '/gdpr',
        '/privacy_policy',
        '/security',
        '/login',
        '/sign_up',
        '/welcome',
        '/welcomeBack',
        '/forgot_password',
        '/terms_use',
        '/privacy_dsp',
        '/privacy_sdk',
        '/getInTouch',
        '/contact',
        '/mrcontact',
        '/restored',
        '/context-distance-calculator'
    ];
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('footer'), t = _a.t, i18n = _a.i18n;
    var i18nCommon = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('common').t;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        textColor: '',
        buttonColor: '',
        buttonText: ''
    }), state = _b[0], setState = _b[1];
    var path = props.location.pathname.substring(3);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        switch (path) {
            case '/rtb':
                setState({
                    textColor: 'aqua-text fw700',
                    buttonColor: 'button-aqua large',
                    buttonText: 'Start Now'
                });
                break;
            case '/monetization':
                setState({
                    textColor: 'red-text fw700',
                    buttonColor: 'button-red large',
                    buttonText: 'Start Now'
                });
                break;
            default:
                setState({
                    textColor: 'accent-text fw700',
                    buttonColor: 'button-blue large',
                    buttonText: 'Get Started'
                });
        }
    }, [props.location.pathname]);
    var pathKey = takeYouAppMap.get(path);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "footer-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "footer" },
            !shortFooterPaths.includes(path) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "f-ready-to-go" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "footer-t muli" }, i18nCommon('Ready to Go?')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "footer-d" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(i18nCommon(pathKey || takeYouAppMap.get('/')), state.textColor)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "/contact" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: state.buttonColor },
                        i18nCommon(state.buttonText),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "f-main" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "footer-info" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: state.textColor }, t('Solutions')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "rtb" }, t('Programmatic UA'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "rtb#retargeting" }, t('Re-targeting'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "market-research" }, t('Market Research'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "monetization" }, t('Monetization'))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: state.textColor }, t('Resources')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: '/blog/' + (i18n.language.includes(__WEBPACK_IMPORTED_MODULE_5__util_locales__["c" /* locales */].en) ? '' : i18n.language.substring(0, 2)) }, t('Blog'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/glossary" }, "UA Glossary")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "rtb#case-studies" }, "Case Studies")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "http://knowledge.persona.ly" }, t('Knowledge Base'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "context-distance-calculator" }, t('Context Distance Calculator'))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: state.textColor }, t('About')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "about" }, t('Values and Ideals'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "about#careers" }, t('Careers'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "about#offices" }, t('Our Offices'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "about#contact" }, t('Contact Us'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "security" }, t('Information Security'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "gdpr" }, t('GDPR'))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: state.textColor }, t('Social')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "fb", href: "https://www.facebook.com/persona.ly.monetization/" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "ln", href: "https://www.linkedin.com/company/persona-ly/" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "tw", href: "https://twitter.com/persona_ly" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "not-desktop fs12 f-m fw700" }, "INFO@PERSONA.LY"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "not-desktop fs12 f-m fw700" }, "+1-888-724-8205"))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "footer-pr fw700 not-desktop not-tablet" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "privacy_policy" }, t('privacy policy'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "terms_use" }, t('terms of use')))))));
};
/* harmony default export */ __webpack_exports__["a"] = (Footer);


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_carouselOutline__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_headquarters__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_statusModal__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_about_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_about_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__css_about_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_util__ = __webpack_require__(2);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};












var contactImgList = [
    'https://static.persona.ly/images/about/carousel-1.webp',
    'https://static.persona.ly/images/about/carousel-2.webp',
    'https://static.persona.ly/images/about/carousel-3.webp'
];
var HiringIdToIconMap = new Map([
    ['5a01de057c4b310010d29c91', 'https://static.persona.ly/images/about/group-26.svg'],
    ['5a01de897c4b310010d29c93', 'https://static.persona.ly/images/about/group-56.svg'],
    ['5a97f90a3ff6d600186851fa', 'https://static.persona.ly/images/about/group-23.svg'],
    ['5a5f7b5926ba6d00110f7832', 'https://static.persona.ly/images/about/group-62.svg'],
    ['5a4361ec355bf000120abac0', 'https://static.persona.ly/images/about/group-63.svg'],
    ['5a4362d9355bf000120abac1', 'https://static.persona.ly/images/about/group-63.svg'],
    ['5a01de477c4b310010d29c92', 'https://static.persona.ly/images/about/group-54.svg'],
    ['5a3a2e788f07940011ee8b7e', 'https://static.persona.ly/images/about/group-55.svg'],
    ['5a01dec27c4b310010d29c94', 'https://static.persona.ly/images/about/group-49.svg']
]);
var About = function (props) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])('about'), t = _a.t, i18n = _a.i18n;
    var tC = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])('common').t;
    var appContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__app__["a" /* AppContext */]);
    var utmParameters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__app__["a" /* AppContext */]).utmParameters;
    var customizeListBlocks = [
        {
            title: t('Innovation'),
            text: t('Is about daring'),
            img: 'https://static.persona.ly/images/about/group-60.svg'
        },
        {
            title: t('Longevity'),
            text: t('Is about longevity'),
            img: 'https://static.persona.ly/images/about/survey-time-icon.svg'
        },
        {
            title: t('Challenge'),
            text: t('Is about facing'),
            img: 'https://static.persona.ly/images/about/group-61.svg'
        }
    ];
    var statusModalData1 = {
        title: 'Application Sent',
        text: 'Your job application has been recorded. We will review it and reply as soon as possible.'
    };
    var statusModalData2 = {
        title: 'Message Sent',
        text: 'Your message has been recorded. We will reply as soon as possible.'
    };
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        formError: false,
        showModal: false,
        dataModal: {
            title: 'null',
            text: 'null',
            brief: ['null'],
            requirements: ['null']
        },
        hiringList: []
    }), state = _b[0], setState = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        placement: 'about',
        type: 'monetization',
        name: '',
        company: '',
        email: '',
        phone: '',
        message: '',
        utm: utmParameters || {}
    }), form = _c[0], setForm = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eName = _d[0], setEName = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eCompany = _e[0], setECompany = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eEmail = _f[0], setEEmail = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eMessage = _g[0], setEMessage = _g[1];
    var _h = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), statusModal1 = _h[0], setStatusModal1 = _h[1];
    var _j = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), statusModal2 = _j[0], setStatusModal2 = _j[1];
    var updateErrors = function (name, company, email, message) {
        setEName(name);
        setECompany(company);
        setEEmail(email);
        setEMessage(message);
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["r" /* setTitleFont */])(i18n.language);
        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* api */].hiring().then(function (response) { return setState(__assign(__assign({}, state), { hiringList: response.results ? response.results : [] })); });
        appContext.setAboutIsMounted(true);
        return function () { return appContext.setAboutIsMounted(false); };
    }, []);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () { return Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["n" /* goToHash */])(props); }, [props.location.hash]);
    var imageOnLoadFunc = function () {
        if (props.location.hash) {
            Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["n" /* goToHash */])(props);
        }
    };
    var toggleCareerModal = function () { return setState(__assign(__assign({}, state), { showModal: !state.showModal })); };
    var toggleStatusModal1 = function () { return setStatusModal1(!statusModal1); };
    var toggleStatusModal2 = function () { return setStatusModal2(!statusModal2); };
    var scrollToHandler = function () { Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["m" /* goToElementId */])('about-carousel', true); };
    var renderHiringList = function () { return state.hiringList.map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: data._id, className: "job-element", onClick: function () { return setState(__assign(__assign({}, state), { showModal: !state.showModal, dataModal: data })); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { width: "37", height: "37", src: HiringIdToIconMap.has(data._id) ? HiringIdToIconMap.get(data._id) : 'https://static.persona.ly/images/about/group-63.svg' }),
            data.title);
    }); };
    var onFormRadioChange = function (e) { return setForm(__assign(__assign({}, form), { type: e.currentTarget.value })); };
    var sendFormData = function () {
        updateErrors([], [], [], []);
        if (form.name && form.company && form.email && form.message) {
            __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* api */].postContactFormData(JSON.stringify(form))
                .then(function () {
                setForm(__assign(__assign({}, form), { name: '', company: '', email: '', phone: '', message: '' }));
                toggleStatusModal2();
                window.dataLayer.push({ 'event': 'form-completed', 'location': 'About' });
            })
                .catch(function () { return setState(__assign(__assign({}, state), { formError: true })); });
        }
        else {
            updateErrors(form.name ? [] : [tC('required field')], form.company ? [] : [tC('required field')], form.email ? [] : [tC('required field')], form.message ? [] : [tC('required field')]);
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "about" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_modal__["a" /* default */], { data: state.dataModal, show: state.showModal, action: toggleStatusModal1, toggle: toggleCareerModal }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_statusModal__["a" /* default */], { data: statusModalData1, show: statusModal1, toggle: toggleStatusModal1 }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_statusModal__["a" /* default */], { data: statusModalData2, show: statusModal2, toggle: toggleStatusModal2 }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "top-block" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "top-text-block text-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-text ht-large muli" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "accent-text" }, t('We Lead')),
                    " ",
                    t('We dont Follow')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-text mt-40" }, t('We believe leadership'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "scroll", onClick: scrollToHandler },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/path-2-copy-2.svg" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "about-carousel", style: { paddingTop: '6rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_carouselOutline__["a" /* default */], { blocks: customizeListBlocks, titleClass: "medium-text about-car-m fw700", textClass: "small-text mt-20" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "ad-tech-company", className: "column-block cb-personaly text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-text ht-medium muli" }, Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('Is a global mobile ad-tech'), __WEBPACK_IMPORTED_MODULE_10__util_util__["a" /* ACCENT_TEXT */])),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { maxWidth: 672 } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text mt-30" }, Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('We create mobile monetization'), __WEBPACK_IMPORTED_MODULE_10__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "we-work-block rb-1" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-block-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "img-1", src: "https://static.persona.ly/images/about/about-1.webp" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "img-2", src: "https://static.persona.ly/images/about/about-2.webp" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "img-3", src: "https://static.persona.ly/images/about/about-3.webp" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block cb-55 we-work-smarter" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-text ht-medium muli" }, Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('We Work'), __WEBPACK_IMPORTED_MODULE_10__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-text mt-25 fw700" }, t('We hold d')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text mt-20" },
                    Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('Our founders focused on building'), __WEBPACK_IMPORTED_MODULE_10__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('Our systems are constantly evolving'), __WEBPACK_IMPORTED_MODULE_10__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "we-work-block-2 cb-55" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block we-work-block-2-column" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text mt-30" },
                    t('When faced with a new challenge'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('Whats optimal today'), __WEBPACK_IMPORTED_MODULE_10__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/about/image-block-22.svg", style: { alignSelf: 'flex-end' } })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-block-2" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sub-block-2" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "img-1", src: "https://static.persona.ly/images/about/about-4.webp" })))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "we-provide-block rb-3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-block-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "not-mobile", style: { marginRight: '1rem' } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "img-1", src: "https://static.persona.ly/images/about/about-5.webp" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "img-3", src: "https://static.persona.ly/images/about/about-6.webp" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "img-2", src: "https://static.persona.ly/images/about/about-7.webp" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block cb-55" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-text ht-medium muli" }, Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('We Provide'), __WEBPACK_IMPORTED_MODULE_10__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-text mt-25 fw700" }, t('We approach every')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text mt-20" },
                    t('Our partners success'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('We learn to know'), __WEBPACK_IMPORTED_MODULE_10__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "we-provide-block-2 rb-4" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block cb-50 as-a-company" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text" },
                    Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('As a company, we believe in'), __WEBPACK_IMPORTED_MODULE_10__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('These ideals are embedded'), __WEBPACK_IMPORTED_MODULE_10__util_util__["b" /* ACCENT_TEXT_FW500 */]))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-block-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sub-block-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "img-1", src: "https://static.persona.ly/images/about/about-8.webp" })))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "careers", className: "we-provide-block-2 rb-4-c" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block cb-50" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-text ht-medium muli" }, Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('Join Our Team'), __WEBPACK_IMPORTED_MODULE_10__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text mt-20" },
                    Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('We strive to maintain a work'), __WEBPACK_IMPORTED_MODULE_10__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    t('Always looking for passionate'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "accent-text fw500" }, t('Applicant discretion is guaranteed')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "img-block-5 not-tablet not-mobile" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sub-block-5" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "img-1", src: "https://static.persona.ly/images/about/team.webp" })))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "looking-for-block mt-60" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block cb-60" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-text fw700" }, t('Looking For')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jobs-block mt-40" }, renderHiringList())),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block cb-40" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "medium-text not-tablet not-mobile fw700" }, t('Our Values')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "values-block mt-40" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "values-elem" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { width: "83", height: "88", src: "https://static.persona.ly/images/about/04.svg" }),
                        t('Encouraging Personal')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "values-elem" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { width: "83", height: "88", src: "https://static.persona.ly/images/about/05.svg" }),
                        t('A Dynamic Company')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "values-elem" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { width: "83", height: "88", src: "https://static.persona.ly/images/about/06.svg" }),
                        t('Positive Atmosphere'))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "contact", className: "contact-block" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block cb-50" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-text ht-medium muli" }, Object(__WEBPACK_IMPORTED_MODULE_10__util_util__["t" /* tagger */])(t('Wed Love to'), __WEBPACK_IMPORTED_MODULE_10__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text mt-25" }, t('What can we help you with')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-radio-block" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { htmlFor: "1", className: "contact-radio-label" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { id: "1", className: "contact-radio", type: "radio", name: "contactType", value: "monetization", checked: form.type == 'monetization', onChange: onFormRadioChange }),
                        t('Monetization')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { htmlFor: "2", className: "contact-radio-label" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { id: "2", className: "contact-radio", type: "radio", name: "contactType", value: "acquisition", checked: form.type == 'acquisition', onChange: onFormRadioChange }),
                        t('User Acquisition')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { htmlFor: "3", className: "contact-radio-label" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { id: "3", className: "contact-radio", type: "radio", name: "contactType", value: "research", checked: form.type == 'research', onChange: onFormRadioChange }),
                        t('Market Research'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-row-block" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eName.length > 0 ? ' error-input' : ''), type: "text", name: "contactName", placeholder: "\u00A0", value: form.name, onChange: function (e) { return setForm(__assign(__assign({}, form), { name: e.currentTarget.value })); } }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Full name')),
                            eName && eName.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eCompany.length > 0 ? ' error-input' : ''), type: "text", name: "contactCompany", placeholder: "\u00A0", value: form.company, onChange: function (e) { return setForm(__assign(__assign({}, form), { company: e.currentTarget.value })); } }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Company name')),
                            eCompany && eCompany.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-row-block" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : ''), type: "email", name: "contactEmail", placeholder: "\u00A0", value: form.email, onChange: function (e) { return setForm(__assign(__assign({}, form), { email: e.currentTarget.value })); } }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Email address')),
                            eEmail && eEmail.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "contact-input small-text", type: "tel", name: "contactPhone", placeholder: "\u00A0", value: form.phone, onChange: function (e) { return setForm(__assign(__assign({}, form), { phone: e.currentTarget.value })); } }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Phone number')))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row-block" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-area-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", { className: 'contact-input contact-textarea small-text' + (eMessage.length > 0 ? ' error-input' : ''), name: "contactMessage", placeholder: "\u00A0", value: form.message, onChange: function (e) { return setForm(__assign(__assign({}, form), { message: e.currentTarget.value })); } }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Message')),
                            eMessage && eMessage.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "contact-button mt-50", type: "submit", onClick: sendFormData }, tC('Send'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "column-block pictures images-rounded" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default.a, { autoHeight: false, buttonsDisabled: true, infinite: false, mouseTrackingEnabled: true, items: contactImgList.map(function (img, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { onDragStart: function (e) { return e.preventDefault(); }, key: i, src: img });
                    }) }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_headquarters__["a" /* default */], { showButton: false }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { width: "0", height: "0", src: "https://static.persona.ly/images/on-load-pixel.gif", onLoad: imageOnLoadFunc })));
};
/* harmony default export */ __webpack_exports__["a"] = (About);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Utils = _interopRequireWildcard(__webpack_require__(118));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VanillaSwipe =
/*#__PURE__*/
function () {
  function VanillaSwipe(props) {
    _classCallCheck(this, VanillaSwipe);

    _defineProperty(this, "state", void 0);

    _defineProperty(this, "props", void 0);

    _defineProperty(this, "isPassiveSupported", void 0);

    this.state = Utils.getInitialState();
    this.props = Utils.getInitialProps(props);
    this.isPassiveSupported = Utils.checkIsPassiveSupported();
    this.handleSwipeStart = this.handleSwipeStart.bind(this);
    this.handleSwipeMove = this.handleSwipeMove.bind(this);
    this.handleSwipeEnd = this.handleSwipeEnd.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  _createClass(VanillaSwipe, [{
    key: "init",
    value: function init() {
      this.setupTouchListeners();
      this.setupMouseListeners();
    }
  }, {
    key: "update",
    value: function update(props) {
      var prevProps = this.props;
      var nextProps = Object.assign({}, prevProps, props);

      if (prevProps.element !== nextProps.element) {
        this.destroy();
        this.props = nextProps;
        this.init();
        return;
      }

      this.props = nextProps;

      if (prevProps.mouseTrackingEnabled !== nextProps.mouseTrackingEnabled) {
        nextProps.mouseTrackingEnabled ? this.setupMouseListeners() : this.cleanupMouseListeners();
      }

      if (prevProps.touchTrackingEnabled !== nextProps.touchTrackingEnabled) {
        nextProps.touchTrackingEnabled ? this.setupTouchListeners() : this.cleanupTouchListeners();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.cleanupMouseListeners();
      this.cleanupTouchListeners();
      this.state = Utils.getInitialState();
      this.props = Utils.getInitialProps();
    }
  }, {
    key: "setupTouchListeners",
    value: function setupTouchListeners() {
      var _this$props = this.props,
          element = _this$props.element,
          touchTrackingEnabled = _this$props.touchTrackingEnabled;

      if (element && touchTrackingEnabled) {
        var options = this.isPassiveSupported ? {
          passive: false
        } : {};
        element.addEventListener('touchstart', this.handleSwipeStart, options);
        element.addEventListener('touchmove', this.handleSwipeMove, options);
        element.addEventListener('touchend', this.handleSwipeEnd, options);
      }
    }
  }, {
    key: "cleanupTouchListeners",
    value: function cleanupTouchListeners() {
      var element = this.props.element;

      if (element) {
        element.removeEventListener('touchstart', this.handleSwipeStart);
        element.removeEventListener('touchmove', this.handleSwipeMove);
        element.removeEventListener('touchend', this.handleSwipeEnd);
      }
    }
  }, {
    key: "setupMouseListeners",
    value: function setupMouseListeners() {
      var _this$props2 = this.props,
          element = _this$props2.element,
          mouseTrackingEnabled = _this$props2.mouseTrackingEnabled;

      if (element && mouseTrackingEnabled) {
        element.addEventListener('mousedown', this.handleMouseDown);
        element.addEventListener('mousemove', this.handleMouseMove);
        element.addEventListener('mouseup', this.handleMouseUp);
        element.addEventListener('mouseleave', this.handleMouseLeave);
      }
    }
  }, {
    key: "cleanupMouseListeners",
    value: function cleanupMouseListeners() {
      var element = this.props.element;

      if (element) {
        element.removeEventListener('mousedown', this.handleMouseDown);
        element.removeEventListener('mousemove', this.handleMouseMove);
        element.removeEventListener('mouseup', this.handleMouseUp);
        element.removeEventListener('mouseleave', this.handleMouseLeave);
      }
    }
  }, {
    key: "getPosition",
    value: function getPosition(e) {
      var _this$state = this.state,
          x = _this$state.x,
          y = _this$state.y,
          start = _this$state.start;
      var rotationAngle = this.props.rotationAngle;
      var movingPosition = Utils.calculateMovingPosition(e);
      var rotatePosition = Utils.rotateByAngle(movingPosition, rotationAngle);
      return Utils.calculatePosition({
        x: x,
        y: y,
        start: start
      }, rotatePosition);
    }
  }, {
    key: "handleSwipeStart",
    value: function handleSwipeStart(e) {
      if (Utils.checkIsMoreThanSingleTouches(e)) return;
      var rotationAngle = this.props.rotationAngle;
      var movingPosition = Utils.calculateMovingPosition(e);

      var _Utils$rotateByAngle = Utils.rotateByAngle(movingPosition, rotationAngle),
          x = _Utils$rotateByAngle.x,
          y = _Utils$rotateByAngle.y;

      this.state = {
        start: Date.now(),
        x: x,
        y: y,
        isSwiping: false
      };
    }
  }, {
    key: "handleSwipeMove",
    value: function handleSwipeMove(e) {
      var _this$state2 = this.state,
          x = _this$state2.x,
          y = _this$state2.y;
      if (!x || !y || Utils.checkIsMoreThanSingleTouches(e)) return;

      var _this$getPosition = this.getPosition(e),
          absX = _this$getPosition.absX,
          absY = _this$getPosition.absY,
          deltaX = _this$getPosition.deltaX,
          deltaY = _this$getPosition.deltaY,
          duration = _this$getPosition.duration;

      var _this$props3 = this.props,
          _this$props3$delta = _this$props3.delta,
          delta = _this$props3$delta === void 0 ? 0 : _this$props3$delta,
          onSwiping = _this$props3.onSwiping,
          preventDefaultTouchmoveEvent = _this$props3.preventDefaultTouchmoveEvent;
      if (e.cancelable && preventDefaultTouchmoveEvent) e.preventDefault();
      if (absX < delta && absY < delta) return;
      this.state.isSwiping = true;

      if (onSwiping) {
        onSwiping(e, deltaX, deltaY, absX, absY, duration);
      }
    }
  }, {
    key: "handleSwipeEnd",
    value: function handleSwipeEnd(e) {
      var _this$props4 = this.props,
          onSwiped = _this$props4.onSwiped,
          onTap = _this$props4.onTap;

      if (this.state.isSwiping) {
        var position = this.getPosition(e);
        var deltaX = position.deltaX,
            deltaY = position.deltaY,
            absX = position.absX,
            absY = position.absY,
            duration = position.duration;
        onSwiped && onSwiped(e, deltaX, deltaY, absX, absY, duration);
      } else {
        onTap && onTap(e);
      }

      this.state = Utils.getInitialState();
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      this.handleSwipeStart(e);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(e) {
      this.handleSwipeMove(e);
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(e) {
      this.handleSwipeEnd(e);
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var element = this.props.element;
      var isSwiping = this.state.isSwiping;

      if (element && isSwiping) {
        element.dispatchEvent(new Event('mouseup', {
          bubbles: true,
          cancelable: true
        }));
      }
    }
  }]);

  return VanillaSwipe;
}();

exports["default"] = VanillaSwipe;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getInitialState = __webpack_require__(119);

Object.keys(_getInitialState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getInitialState[key];
    }
  });
});

var _getInitialProps = __webpack_require__(120);

Object.keys(_getInitialProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getInitialProps[key];
    }
  });
});

var _checkIsPassiveSupported = __webpack_require__(121);

Object.keys(_checkIsPassiveSupported).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkIsPassiveSupported[key];
    }
  });
});

var _calculatePosition = __webpack_require__(122);

Object.keys(_calculatePosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculatePosition[key];
    }
  });
});

var _calculateMovingPosition = __webpack_require__(123);

Object.keys(_calculateMovingPosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateMovingPosition[key];
    }
  });
});

var _rotateByAngle = __webpack_require__(124);

Object.keys(_rotateByAngle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _rotateByAngle[key];
    }
  });
});

var _checkIsMoreThanSingleTouches = __webpack_require__(125);

Object.keys(_checkIsMoreThanSingleTouches).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkIsMoreThanSingleTouches[key];
    }
  });
});

var _createOptions = __webpack_require__(41);

Object.keys(_createOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createOptions[key];
    }
  });
});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialState = void 0;

var getInitialState = function getInitialState() {
  return {
    x: 0,
    y: 0,
    start: 0,
    isSwiping: false
  };
};

exports.getInitialState = getInitialState;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialProps = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getInitialProps = function getInitialProps() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    element: null,
    delta: 10,
    rotationAngle: 0,
    stopPropagation: false,
    mouseTrackingEnabled: false,
    touchTrackingEnabled: true,
    preventDefaultTouchmoveEvent: false
  }, props);
};

exports.getInitialProps = getInitialProps;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIsPassiveSupported = checkIsPassiveSupported;

var _createOptions = __webpack_require__(41);

function checkIsPassiveSupported() {
  var isPassiveSupported = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var proxy = {
    isPassiveSupported: isPassiveSupported
  };

  try {
    var options = (0, _createOptions.createOptions)(proxy);
    window.addEventListener('checkIsPassiveSupported', console.log, options);
    window.removeEventListener('checkIsPassiveSupported', console.log, options);
  } catch (err) {}

  return proxy.isPassiveSupported;
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePosition = calculatePosition;

function calculatePosition(prevPos, nextPos) {
  var deltaX = prevPos.x - nextPos.x;
  var deltaY = prevPos.y - nextPos.y;
  var absX = Math.abs(deltaX);
  var absY = Math.abs(deltaY);
  var duration = Date.now() - prevPos.start;
  return {
    deltaX: deltaX,
    deltaY: deltaY,
    absX: absX,
    absY: absY,
    duration: duration
  };
}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateMovingPosition = calculateMovingPosition;

function calculateMovingPosition(e) {
  if ('changedTouches' in e) {
    var touches = e.changedTouches && e.changedTouches[0];
    return {
      x: touches && touches.clientX,
      y: touches && touches.clientY
    };
  }

  return {
    x: e.clientX,
    y: e.clientY
  };
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rotateByAngle = rotateByAngle;

function rotateByAngle(position) {
  var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (angle === 0) {
    return position;
  }

  var x = position.x,
      y = position.y;
  var angleInRadians = Math.PI / 180 * angle;
  var rotatedX = x * Math.cos(angleInRadians) + y * Math.sin(angleInRadians);
  var rotatedY = y * Math.cos(angleInRadians) - x * Math.sin(angleInRadians);
  return {
    x: rotatedX,
    y: rotatedY
  };
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIsMoreThanSingleTouches = void 0;

var checkIsMoreThanSingleTouches = function checkIsMoreThanSingleTouches(e) {
  return Boolean(e.touches && e.touches.length > 1);
};

exports.checkIsMoreThanSingleTouches = checkIsMoreThanSingleTouches;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAnimatedItem = exports.getTranslate3dPosition = undefined;
exports.animate = animate;
exports.getTranslateX = getTranslateX;
exports.getTransformMatrix = getTransformMatrix;

var _index = __webpack_require__(8);

var Utils = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function animate(element) {
  var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var durationMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (Utils.isElement(element)) {
    element.style['transition'] = 'transform ' + durationMs + 'ms ease-out';
    element.style['transform'] = 'translate3d(' + position + 'px, 0, 0)';
  }
  return element;
}

function getTranslateX(element) {
  var translateXIndex = 4;
  var matrix = getTransformMatrix(element);
  return matrix[translateXIndex] || '';
}

function getTransformMatrix(element) {
  if (Utils.isElement(element)) {
    var _ref = getComputedStyle(element) || {},
        _ref$transform = _ref.transform,
        transform = _ref$transform === undefined ? '' : _ref$transform;

    var matched = transform.match(/[0-9., -]+/) || [];
    if (typeof matched[0] === 'string') {
      return matched[0].split(',');
    }
  }
  return [];
}

var getTranslate3dPosition = exports.getTranslate3dPosition = function getTranslate3dPosition() {
  var currentIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var itemWidth = state.itemWidth,
      items = state.items,
      infinite = state.infinite,
      _state$stagePadding = state.stagePadding,
      stagePadding = _state$stagePadding === undefined ? {} : _state$stagePadding;


  if (infinite) {
    var paddingLeft = stagePadding.paddingLeft,
        paddingRight = stagePadding.paddingRight;

    if (paddingLeft || paddingRight) {
      currentIndex += 1;
    }
  }
  return (items + currentIndex) * -itemWidth || 0;
};

var isAnimatedItem = exports.isAnimatedItem = function isAnimatedItem() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var animationProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var allowFadeOutAnimation = animationProps.allowFadeOutAnimation,
      fadeOutIndex = animationProps.fadeOutIndex;

  return !!allowFadeOutAnimation && fadeOutIndex === i;
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateInitialProps = exports.setTotalItemsInSlide = undefined;

var _index = __webpack_require__(8);

var Utils = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setTotalItemsInSlide = exports.setTotalItemsInSlide = function setTotalItemsInSlide(responsiveConfig, childrenLength) {
  var items = 1;
  if (responsiveConfig) {
    var configKeys = Object.keys(responsiveConfig);

    if (configKeys.length) {
      configKeys.forEach(function (width) {
        if (width < window.innerWidth) {
          items = Math.min(responsiveConfig[width].items, childrenLength) || items;
        }
      });
    }
  }
  return items;
};

var calculateInitialProps = exports.calculateInitialProps = function calculateInitialProps(props, rootComponent) {
  var startIndex = props.startIndex,
      responsive = props.responsive,
      infinite = props.infinite;

  var style = Utils.getDefaultStyles();
  var slides = Utils.getSlides(props);
  var stagePadding = Utils.getStagePadding(props);
  var items = setTotalItemsInSlide(responsive, slides.length);
  var currentIndex = Utils.setStartIndex(slides.length, startIndex);
  var galleryWidth = Utils.getElementWidth(rootComponent);
  var itemWidth = Utils.getItemWidth(galleryWidth, items);
  var clones = Utils.cloneCarouselItems(slides, items, { stagePadding: stagePadding, infinite: infinite });
  var translate3d = Utils.getTranslate3dPosition(currentIndex, { itemWidth: itemWidth, items: items, stagePadding: stagePadding, infinite: infinite });

  return {
    items: items,
    itemWidth: itemWidth,
    currentIndex: currentIndex,
    slides: slides,
    clones: clones,
    infinite: infinite,
    translate3d: translate3d,
    stagePadding: stagePadding,
    style: style
  };
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debug = debug;
function debug() {
  if (window.__DEBUG__) {
    var _console;

    (_console = console).debug.apply(_console, arguments); 
    return arguments;
  }
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentIndex = exports.getNextItemIndexBeforeTouchEnd = exports.isElement = exports.getSlideInfo = exports.getGalleryItemHeight = exports.getNextItem = exports.getItemWidth = exports.isStagePadding = exports.getStagePadding = exports.itemInfo = exports.getSlides = exports.getElementWidth = exports.cloneCarouselItems = undefined;
exports.getElementDimensions = getElementDimensions;
exports.shouldHandleResizeEvent = shouldHandleResizeEvent;

var _index = __webpack_require__(8);

var Utils = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var cloneCarouselItems = exports.cloneCarouselItems = function cloneCarouselItems() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var itemsInSlide = arguments[1];
  var props = arguments[2];

  var items = itemsInSlide || 1;

  var _ref = props || {},
      stagePadding = _ref.stagePadding,
      infinite = _ref.infinite;

  var _ref2 = stagePadding || {},
      paddingLeft = _ref2.paddingLeft,
      paddingRight = _ref2.paddingRight;

  if (items > children.length) {
    items = children.length;
  }

  if (infinite) {
    if (paddingLeft || paddingRight) {
      if (itemsInSlide < children.length) {
        items = itemsInSlide + 1;
      } else {
        var lastElement = children.slice(-1);
        var firstElement = children.slice(0, 1);
        var _clonesBefore = lastElement.concat(children);
        var _clonesAfter = children.concat(firstElement);

        return [].concat(_clonesBefore, children, _clonesAfter);
      }
    }
  }

  var clonesAfter = children.slice(0, items);
  var clonesBefore = children.slice(children.length - items);

  return [].concat(clonesBefore, children, clonesAfter);
};

var getElementWidth = exports.getElementWidth = function getElementWidth(element) {
  if (element && element.getBoundingClientRect) {
    return element.getBoundingClientRect().width;
  }
};

var getSlides = exports.getSlides = function getSlides(props) {
  var _ref3 = props || {},
      children = _ref3.children,
      _ref3$items = _ref3.items,
      items = _ref3$items === undefined ? [] : _ref3$items;

  return children && children.length ? children : items;
};

var itemInfo = exports.itemInfo = function itemInfo(props) {
  var _ref4 = props || {},
      items = _ref4.items,
      currentIndex = _ref4.currentIndex,
      infinite = _ref4.infinite,
      _ref4$slides = _ref4.slides,
      slides = _ref4$slides === undefined ? [] : _ref4$slides;

  var isPrevSlideDisabled = infinite === false && currentIndex === 0;
  var isNextSlideDisabled = infinite === false && slides.length - items === currentIndex;

  return { isPrevSlideDisabled: isPrevSlideDisabled, isNextSlideDisabled: isNextSlideDisabled };
};

var getStagePadding = exports.getStagePadding = function getStagePadding(props) {
  var _ref5 = props || {},
      _ref5$stagePadding = _ref5.stagePadding,
      stagePadding = _ref5$stagePadding === undefined ? {} : _ref5$stagePadding;

  var paddingLeft = Math.abs(stagePadding.paddingLeft) || 0;
  var paddingRight = Math.abs(stagePadding.paddingRight) || 0;

  return { paddingLeft: paddingLeft, paddingRight: paddingRight };
};

var isStagePadding = exports.isStagePadding = function isStagePadding() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref6 = props.stagePadding || {},
      paddingLeft = _ref6.paddingLeft,
      paddingRight = _ref6.paddingRight;

  return paddingLeft || paddingRight;
};

var getItemWidth = exports.getItemWidth = function getItemWidth() {
  var galleryWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var totalItems = arguments[1];

  var width = Number(galleryWidth);
  var items = Number(totalItems);
  return width && items > 0 ? width / items : 0;
};

var getNextItem = exports.getNextItem = function getNextItem(stageComponent, itemIndex) {
  var children = stageComponent && stageComponent.children || [];
  return children[itemIndex] && children[itemIndex].firstChild || null;
};

var getGalleryItemHeight = exports.getGalleryItemHeight = function getGalleryItemHeight(stageComponent, props, state) {
  var currentIndex = state.currentIndex;

  var slidesOffset = Utils.calculateSlidesOffset(props, state);
  var itemIndex = Utils.getIndexForItemHeightCalculation(currentIndex, slidesOffset);
  var element = getNextItem(stageComponent, itemIndex);

  if (isElement(element)) {
    var styles = getComputedStyle(element);
    var marginTop = parseFloat(styles['marginTop']);
    var marginBottom = parseFloat(styles['marginBottom']);

    return Math.ceil(element.offsetHeight + marginTop + marginBottom);
  }
};

var getSlideInfo = exports.getSlideInfo = function getSlideInfo() {
  var currentIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var slidesLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var slideIndex = currentIndex + 1;

  if (slideIndex < 1) {
    slideIndex = slidesLength;
  } else if (slideIndex > slidesLength) {
    slideIndex = 1;
  }

  return { slideIndex: slideIndex, slidesLength: slidesLength };
};

var isElement = exports.isElement = function isElement(element) {
  return element instanceof Element || element instanceof HTMLDocument;
};

var getNextItemIndexBeforeTouchEnd = exports.getNextItemIndexBeforeTouchEnd = function getNextItemIndexBeforeTouchEnd(currentTranslateXPosition) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var infinite = props.infinite,
      _props$items = props.items,
      items = _props$items === undefined ? 1 : _props$items,
      _props$itemWidth = props.itemWidth,
      itemWidth = _props$itemWidth === undefined ? 0 : _props$itemWidth,
      _props$slides = props.slides,
      slides = _props$slides === undefined ? [] : _props$slides,
      _props$stagePadding = props.stagePadding,
      stagePadding = _props$stagePadding === undefined ? {} : _props$stagePadding;
  var paddingLeft = stagePadding.paddingLeft,
      paddingRight = stagePadding.paddingRight;


  if (itemWidth <= 0 || items > slides.length) {
    return 0;
  }

  var currentIndex = getCurrentIndex(currentTranslateXPosition, itemWidth, items);

  if (infinite && (paddingLeft || paddingRight)) {
    currentIndex -= 1;
  }

  if (currentIndex === slides.length) {
    return 0;
  }

  if (currentIndex < 0) {
    return slides.length + currentIndex;
  }

  return currentIndex;
};

var getCurrentIndex = exports.getCurrentIndex = function getCurrentIndex(currentTranslateXPosition, itemWidth, items) {
  var value = Math.abs(currentTranslateXPosition / itemWidth);
  return Math.ceil(value) - items;
};

function getElementDimensions(element) {
  var dimensions = {};

  if (element) {
    dimensions['clientWidth'] = element.clientWidth;
    dimensions['clientHeight'] = element.clientHeight;
  }
  return dimensions;
}

function shouldHandleResizeEvent(e) {
  var prevDimensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return prevDimensions.clientWidth !== currentDimensions.clientWidth || prevDimensions.clientHeight !== currentDimensions.clientHeight;
}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isVerticalTouchMoveDetected = exports.isVerticalTouchMoveDetected = function isVerticalTouchMoveDetected(e, deltaX, deltaY) {
  var gap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 32;

  var vertical = Math.abs(deltaY);
  var horizontal = Math.abs(deltaX);
  return vertical > horizontal && horizontal < gap;
};

var calculateSwipeIndex = exports.calculateSwipeIndex = function calculateSwipeIndex(itemWidth, position, direction) {
  var index = getSwipeIndex(position, itemWidth);
  var offset = getSwipeOffset(direction);
  return index + offset;
};

var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(deltaX) {
  return deltaX > 0 ? 'LEFT' : 'RIGHT';
};

var getSwipeOffset = exports.getSwipeOffset = function getSwipeOffset(direction) {
  return direction === 'LEFT' ? 1 : 0;
};

var getSwipeIndex = exports.getSwipeIndex = function getSwipeIndex(position, itemWidth) {
  var swipePosition = Math.abs(position);
  return Math.floor(swipePosition / itemWidth);
};

var getSwipeIndexOnBeforeTouchEnd = exports.getSwipeIndexOnBeforeTouchEnd = function getSwipeIndexOnBeforeTouchEnd(swipeIndex, items) {
  return swipeIndex - items || 0;
};

var getSwipePositionOnBeforeTouchEnd = exports.getSwipePositionOnBeforeTouchEnd = function getSwipePositionOnBeforeTouchEnd(swipeIndex, itemWidth) {
  return swipeIndex * -itemWidth || 0;
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
function debounce(func) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var timer = null;

  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      func.apply(_this, args);
      timer = null;
    }, ms);
  };
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndexForItemHeightCalculation = exports.calculateSlidesOffset = exports.recalculateTranslatePosition = exports.recalculateCurrentSlideIndex = exports.isTheLastDotIndex = exports.getItemIndexForDotNavigation = exports.getDotsNavigationLength = exports.getMaxSwipeLimitIfNotInfinite = exports.shouldRecalculateSwipePosition = exports.getMinSwipeLimitIfNotInfinite = exports.getSlideOffset = exports.getMaxSwipeLimit = exports.getMinSwipeLimit = exports.recalculateCurrentIndexOnBeforeTouchEnd = exports.recalculatePositionOnBeforeTouchEnd = exports.getMinSwipePosition = exports.getMaxSwipePosition = exports.getFadeOutOffsetOnClick = exports.getFadeOutIndexOnClick = exports.getFadeOutOffsetOnDotClick = exports.setStartIndex = exports.getSlideIndexForMultipleItems = exports.getSlideIndexForNotMultipleItems = exports.getActiveSlideIndex = exports.getDotsLength = undefined;

var _index = __webpack_require__(8);

var Utils = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getDotsLength = exports.getDotsLength = function getDotsLength(slidesLength, items) {
  if (slidesLength && items) {
    var dots = Math.floor(slidesLength / items);
    return slidesLength % items === 0 ? dots - 1 : dots;
  }
  return 0;
};

var getActiveSlideIndex = exports.getActiveSlideIndex = function getActiveSlideIndex(isNextSlideDisabled) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var index = props.currentIndex,
      items = props.items,
      _props$slides = props.slides,
      slides = _props$slides === undefined ? [] : _props$slides;

  var currentIndex = index + items;
  var slidesLength = slides.length;

  return items === 1 ? getSlideIndexForNotMultipleItems(currentIndex, items, slidesLength) : getSlideIndexForMultipleItems(currentIndex, items, slidesLength, isNextSlideDisabled);
};

var getSlideIndexForNotMultipleItems = exports.getSlideIndexForNotMultipleItems = function getSlideIndexForNotMultipleItems(currentIndex, items, slidesLength) {
  if (currentIndex < items) return slidesLength - items;
  if (currentIndex > slidesLength) return 0;
  return currentIndex - 1;
};

var getSlideIndexForMultipleItems = exports.getSlideIndexForMultipleItems = function getSlideIndexForMultipleItems(currentIndex, items, slidesLength, isNextSlideDisabled) {
  var dotsLength = getDotsLength(slidesLength, items);

  if (currentIndex === slidesLength + items) return 0;
  if (isNextSlideDisabled || currentIndex < items && currentIndex !== 0) return dotsLength;
  if (currentIndex === 0) {
    return slidesLength % items === 0 ? dotsLength : dotsLength - 1;
  }

  return items > 0 ? Math.floor(currentIndex / items) - 1 : 0;
};

var setStartIndex = exports.setStartIndex = function setStartIndex(childrenLength, index) {
  var startIndex = index ? Math.abs(Math.ceil(index)) : 0;
  return Math.min(startIndex, childrenLength - 1) || 0;
};

var getFadeOutOffsetOnDotClick = exports.getFadeOutOffsetOnDotClick = function getFadeOutOffsetOnDotClick(itemIndex, currentIndex, itemWidth) {
  if (itemIndex < currentIndex) {
    return (currentIndex - itemIndex) * -itemWidth || 0;
  } else {
    return (itemIndex - currentIndex) * itemWidth || 0;
  }
};

var getFadeOutIndexOnClick = exports.getFadeOutIndexOnClick = function getFadeOutIndexOnClick(currentIndex) {
  return currentIndex === 0 ? 1 : currentIndex + 1;
};

var getFadeOutOffsetOnClick = exports.getFadeOutOffsetOnClick = function getFadeOutOffsetOnClick(direction, itemWidth) {
  return direction === 'next' ? itemWidth : -itemWidth;
};

var getMaxSwipePosition = exports.getMaxSwipePosition = function getMaxSwipePosition(items, itemWidth, slidesLength) {
  return (slidesLength + items) * itemWidth || 0;
};

var getMinSwipePosition = exports.getMinSwipePosition = function getMinSwipePosition(items, itemWidth) {
  return items * itemWidth || 0;
};

var recalculatePositionOnBeforeTouchEnd = exports.recalculatePositionOnBeforeTouchEnd = function recalculatePositionOnBeforeTouchEnd(items, itemWidth) {
  return -getMinSwipePosition(items, itemWidth);
};

var recalculateCurrentIndexOnBeforeTouchEnd = exports.recalculateCurrentIndexOnBeforeTouchEnd = function recalculateCurrentIndexOnBeforeTouchEnd(slidesLength, items) {
  return slidesLength - items || 0;
};

var getMinSwipeLimit = exports.getMinSwipeLimit = function getMinSwipeLimit(minSwipePosition) {
  var stagePadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _stagePadding$padding = stagePadding.paddingLeft,
      paddingLeft = _stagePadding$padding === undefined ? 0 : _stagePadding$padding;

  var result = paddingLeft ? minSwipePosition + paddingLeft : 0;
  return result || 0;
};

var getMaxSwipeLimit = exports.getMaxSwipeLimit = function getMaxSwipeLimit(maxSwipePosition) {
  var stagePadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _stagePadding$padding2 = stagePadding.paddingRight,
      paddingRight = _stagePadding$padding2 === undefined ? 0 : _stagePadding$padding2;

  var limit = paddingRight ? maxSwipePosition + paddingRight : maxSwipePosition;
  return limit || 0;
};

var getSlideOffset = exports.getSlideOffset = function getSlideOffset(itemWidth) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

  return Math.min(itemWidth / 2, offset) || 0;
};

var getMinSwipeLimitIfNotInfinite = exports.getMinSwipeLimitIfNotInfinite = function getMinSwipeLimitIfNotInfinite(items, itemWidth) {
  return items * itemWidth - getSlideOffset(itemWidth) || 0;
};

var shouldRecalculateSwipePosition = exports.shouldRecalculateSwipePosition = function shouldRecalculateSwipePosition(currentPosition, minPosition, maxPosition) {
  return currentPosition >= 0 - minPosition || Math.abs(currentPosition) >= maxPosition;
};

var getMaxSwipeLimitIfNotInfinite = exports.getMaxSwipeLimitIfNotInfinite = function getMaxSwipeLimitIfNotInfinite(slidesLength, itemWidth) {
  return slidesLength * itemWidth + getSlideOffset(itemWidth) || 0;
};

var getDotsNavigationLength = exports.getDotsNavigationLength = function getDotsNavigationLength(slidesLength, items) {
  if (Number(items) !== 0) {
    return Math.ceil(slidesLength / items) || 0;
  }
  return 0;
};

var getItemIndexForDotNavigation = exports.getItemIndexForDotNavigation = function getItemIndexForDotNavigation(index, isTheLastIndex, slidesLength, itemsLength) {
  var result = isTheLastIndex ? slidesLength - itemsLength : index * itemsLength;
  return result || 0;
};

var isTheLastDotIndex = exports.isTheLastDotIndex = function isTheLastDotIndex(index, infinite, dotsLength) {
  return infinite === false && index === dotsLength - 1;
};

var recalculateCurrentSlideIndex = exports.recalculateCurrentSlideIndex = function recalculateCurrentSlideIndex() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentIndex = state.currentIndex,
      _state$slides = state.slides,
      slides = _state$slides === undefined ? [] : _state$slides;

  return currentIndex < 0 ? slides.length - 1 : 0;
};

var recalculateTranslatePosition = exports.recalculateTranslatePosition = function recalculateTranslatePosition() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var items = state.items,
      itemWidth = state.itemWidth,
      _state$stagePadding = state.stagePadding,
      stagePadding = _state$stagePadding === undefined ? {} : _state$stagePadding,
      _state$slides2 = state.slides,
      slides = _state$slides2 === undefined ? [] : _state$slides2;

  var maxSlidePosition = slides.length - 1;

  var currentIndex = state.currentIndex < 0 ? maxSlidePosition : 0;
  var nextIndex = currentIndex === 0 ? items : maxSlidePosition + items;

  if (stagePadding.paddingLeft || stagePadding.paddingRight) {
    return (nextIndex + 1) * -itemWidth || 0;
  }
  return nextIndex * -itemWidth || 0;
};

var calculateSlidesOffset = exports.calculateSlidesOffset = function calculateSlidesOffset(props, state) {
  var items = state.items,
      infinite = state.infinite;

  var offset = infinite && Utils.isStagePadding(props) ? 1 : 0;
  return items + offset;
};

var getIndexForItemHeightCalculation = exports.getIndexForItemHeightCalculation = function getIndexForItemHeightCalculation(currentIndex, slidesOffset) {
  return currentIndex + slidesOffset;
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWrapperStyles = exports.getStageStyles = exports.getDefaultStyles = exports.itemStyles = exports.getIntermediateTransitionProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _index = __webpack_require__(8);

var Utils = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getIntermediateTransitionProps = exports.getIntermediateTransitionProps = function getIntermediateTransitionProps(condition, duration) {
  return condition ? { fadeoutAnimationProcessing: true, style: { transition: 'transform 0ms ease-out' } } : { style: { transition: 'transform ' + duration + 'ms ease-out' } };
};

var itemStyles = exports.itemStyles = function itemStyles(i, state, animationProps) {
  var fadeOutOffset = animationProps.fadeOutOffset;
  var itemWidth = state.itemWidth,
      duration = state.duration;


  return Utils.isAnimatedItem(i, animationProps) ? { transform: 'translateX(' + fadeOutOffset + 'px)', animationDuration: duration + 'ms', width: itemWidth + 'px' } : { width: itemWidth + 'px' };
};

var getDefaultStyles = exports.getDefaultStyles = function getDefaultStyles() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return { transition: 'transform ' + duration + 'ms ease-out' };
};

var getStageStyles = exports.getStageStyles = function getStageStyles() {
  var nextStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _nextStyles$translate = nextStyles.translate3d,
      translate3d = _nextStyles$translate === undefined ? 0 : _nextStyles$translate,
      height = nextStyles.height;

  var transform = 'translate3d(' + translate3d + 'px, 0, 0)';

  return _extends({}, currentStyles, { transform: transform, height: height });
};

var getWrapperStyles = exports.getWrapperStyles = function getWrapperStyles(element) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _Utils$getStagePaddin = Utils.getStagePadding(props),
      paddingLeft = _Utils$getStagePaddin.paddingLeft,
      paddingRight = _Utils$getStagePaddin.paddingRight;

  var height = props.autoHeight && Utils.getGalleryItemHeight(element, props, state);
  var transition = height && 'height ' + state.duration + 'ms ease-out';

  return {
    height: height,
    transition: transition,
    paddingLeft: paddingLeft + 'px',
    paddingRight: paddingRight + 'px'
  };
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemClassName = exports.isClonedItem = exports.isActiveItem = undefined;

var _index = __webpack_require__(8);

var Utils = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isActiveItem = exports.isActiveItem = function isActiveItem() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentIndex = state.currentIndex,
      items = state.items,
      infinite = state.infinite,
      _state$stagePadding = state.stagePadding,
      stagePadding = _state$stagePadding === undefined ? {} : _state$stagePadding;


  if (infinite && (stagePadding.paddingLeft || stagePadding.paddingRight)) {
    currentIndex += 1;
  }

  var index = currentIndex + items;
  return i >= index && i < index + items;
};

var isClonedItem = exports.isClonedItem = function isClonedItem() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var infinite = state.infinite,
      items = state.items,
      _state$slides = state.slides,
      slides = _state$slides === undefined ? [] : _state$slides;

  return infinite === false && (i < items || i > slides.length + items - 1);
};

var itemClassName = exports.itemClassName = function itemClassName() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var animationProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var isActive = isActiveItem(i, state) ? ' __active' : '';
  var isCloned = isClonedItem(i, state) ? ' __cloned' : '';
  var isAnimated = Utils.isAnimatedItem(i, animationProps) ? ' animated animated-out fadeOut' : '';

  return 'alice-carousel__stage-item' + isActive + isCloned + isAnimated;
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SlideInfo = __webpack_require__(136);

Object.keys(_SlideInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SlideInfo[key];
    }
  });
});

var _StageItem = __webpack_require__(137);

Object.keys(_StageItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StageItem[key];
    }
  });
});

var _DotsNavigation = __webpack_require__(138);

Object.keys(_DotsNavigation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DotsNavigation[key];
    }
  });
});

var _PlayPauseButton = __webpack_require__(139);

Object.keys(_PlayPauseButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PlayPauseButton[key];
    }
  });
});

var _PrevNextButton = __webpack_require__(140);

Object.keys(_PrevNextButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PrevNextButton[key];
    }
  });
});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlideInfo = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(8);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideInfo = exports.SlideInfo = function SlideInfo(_ref) {
  var currentIndex = _ref.currentIndex,
      slidesLength = _ref.slidesLength;

  var info = Utils.getSlideInfo(currentIndex, slidesLength);

  return _react2.default.createElement(
    'div',
    { className: 'alice-carousel__slide-info' },
    _react2.default.createElement(
      'span',
      { className: 'alice-carousel__slide-info-item' },
      info.slideIndex
    ),
    _react2.default.createElement(
      'span',
      { className: 'alice-carousel__slide-info-item alice-carousel__slide-info-item--separator' },
      '/'
    ),
    _react2.default.createElement(
      'span',
      { className: 'alice-carousel__slide-info-item' },
      info.slidesLength
    )
  );
};

SlideInfo.propTypes = {
  currentIndex: _propTypes2.default.number.isRequired,
  slidesLength: _propTypes2.default.number.isRequired
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StageItem = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StageItem = exports.StageItem = function StageItem(_ref) {
  var item = _ref.item,
      className = _ref.className,
      styles = _ref.styles;

  return _react2.default.createElement(
    'li',
    { style: styles, className: className },
    item
  );
};

StageItem.propTypes = {
  item: _propTypes2.default.node,
  className: _propTypes2.default.string.isRequired,
  styles: _propTypes2.default.object.isRequired
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DotsNavigation = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(8);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DotsNavigation = exports.DotsNavigation = function DotsNavigation(_ref) {
  var state = _ref.state,
      _onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;
  var slides = state.slides,
      items = state.items,
      infinite = state.infinite;

  var _Utils$itemInfo = Utils.itemInfo(state),
      isNextSlideDisabled = _Utils$itemInfo.isNextSlideDisabled;

  var dotsLength = Utils.getDotsNavigationLength(slides.length, items);

  return _react2.default.createElement(
    'ul',
    { className: 'alice-carousel__dots' },
    slides.map(function (item, i) {
      if (i < dotsLength) {
        var isTheLastDotIndex = Utils.isTheLastDotIndex(i, infinite, dotsLength);
        var itemIndex = Utils.getItemIndexForDotNavigation(i, isTheLastDotIndex, slides.length, items);
        var activeIndex = Utils.getActiveSlideIndex(isNextSlideDisabled, state);
        var className = activeIndex === i ? ' __active' : '';

        return _react2.default.createElement('li', {
          key: 'dot-item-' + i,
          onClick: function onClick() {
            return _onClick(itemIndex);
          },
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          className: 'alice-carousel__dots-item' + className
        });
      }
    })
  );
};

DotsNavigation.propTypes = {
  state: _propTypes2.default.object.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  onMouseEnter: _propTypes2.default.func.isRequired,
  onMouseLeave: _propTypes2.default.func.isRequired
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayPauseButton = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayPauseButton = exports.PlayPauseButton = function PlayPauseButton(_ref) {
  var isPlaying = _ref.isPlaying,
      onClick = _ref.onClick;

  return _react2.default.createElement(
    'div',
    { className: 'alice-carousel__play-btn' },
    _react2.default.createElement(
      'div',
      { className: 'alice-carousel__play-btn-wrapper' },
      _react2.default.createElement('div', { onClick: onClick, className: 'alice-carousel__play-btn-item' + (isPlaying ? ' __pause' : '') })
    )
  );
};

PlayPauseButton.propTypes = {
  isPlaying: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrevNextButton = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrevNextButton = exports.PrevNextButton = function PrevNextButton(_ref) {
  var name = _ref.name,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;

  var className = 'alice-carousel__' + name + '-btn-item' + (disabled ? ' __inactive' : '');

  return _react2.default.createElement(
    'div',
    { className: 'alice-carousel__' + name + '-btn' },
    _react2.default.createElement(
      'div',
      { className: 'alice-carousel__' + name + '-btn-wrapper', onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
      _react2.default.createElement(
        'p',
        { className: className, onClick: onClick },
        _react2.default.createElement('span', { 'data-area': name })
      )
    )
  );
};

PrevNextButton.propTypes = {
  name: _propTypes2.default.oneOf(['next', 'prev']),
  disabled: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  onMouseEnter: _propTypes2.default.func.isRequired,
  onMouseLeave: _propTypes2.default.func.isRequired
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  items: _propTypes2.default.array,
  children: _propTypes2.default.array,
  onSlideChange: _propTypes2.default.func,
  onSlideChanged: _propTypes2.default.func,
  onInitialized: _propTypes2.default.func,
  onResized: _propTypes2.default.func,
  shouldHandleResizeEvent: _propTypes2.default.func,
  keysControlDisabled: _propTypes2.default.bool,
  playButtonEnabled: _propTypes2.default.bool,
  buttonsDisabled: _propTypes2.default.bool,
  dotsDisabled: _propTypes2.default.bool,
  swipeDisabled: _propTypes2.default.bool,
  responsive: _propTypes2.default.object,
  stagePadding: _propTypes2.default.object,
  duration: _propTypes2.default.number,
  startIndex: _propTypes2.default.number,
  slideToIndex: _propTypes2.default.number,
  autoPlay: _propTypes2.default.bool,
  infinite: _propTypes2.default.bool,
  showSlideInfo: _propTypes2.default.bool,
  mouseTrackingEnabled: _propTypes2.default.bool,
  touchTrackingEnabled: _propTypes2.default.bool,
  fadeOutAnimation: _propTypes2.default.bool,
  autoPlayInterval: _propTypes2.default.number,
  autoPlayDirection: _propTypes2.default.string,
  disableAutoPlayOnAction: _propTypes2.default.bool,
  stopAutoPlayOnHover: _propTypes2.default.bool,
  preventEventOnTouchMove: _propTypes2.default.bool,
  autoHeight: _propTypes2.default.bool
};

var defaultProps = exports.defaultProps = {
  items: [],
  children: [],
  responsive: {},
  stagePadding: {},
  duration: 250,
  startIndex: 0,
  slideToIndex: 0,
  autoPlay: false,
  infinite: true,
  dotsDisabled: false,
  showSlideInfo: false,
  swipeDisabled: false,
  autoPlayInterval: 250,
  buttonsDisabled: false,
  mouseTrackingEnabled: false,
  touchTrackingEnabled: true,
  fadeOutAnimation: false,
  playButtonEnabled: false,
  autoPlayDirection: 'ltr',
  keysControlDisabled: false,
  disableAutoPlayOnAction: false,
  stopAutoPlayOnHover: true,
  preventEventOnTouchMove: false,
  autoHeight: false
};

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return configuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(42);


var configuration = {
    basePath: __WEBPACK_IMPORTED_MODULE_0__env__["a" /* env */].endpoint
};
var BaseApi = /** @class */ (function () {
    function BaseApi() {
        this.fetch = __WEBPACK_IMPORTED_MODULE_1__fetch__["a" /* fetch */];
    }
    return BaseApi;
}());



/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return env; });
var env = {
    endpoint: location.protocol + '//' + "persona.ly/api"
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(145);
module.exports = self.fetch.bind(self);


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_modal_css__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_modal_css__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var Dropzone = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 228)); });
var Modal = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var _a, _b;
        var html = document.querySelector('html');
        if (props.show) {
            (_a = html) === null || _a === void 0 ? void 0 : _a.classList.add('not-scrollable');
        }
        else {
            (_b = html) === null || _b === void 0 ? void 0 : _b.classList.remove('not-scrollable');
        }
    }, [props.show]);
    var applyData = {
        title: undefined,
        name: undefined,
        email: undefined,
        phone: undefined,
        cv: undefined
    };
    var tC = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('common').t;
    var tM = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('modal').t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        isApply: false,
        isDropdown: false,
        applyData: applyData
    }), state = _a[0], setState = _a[1];
    var renderData = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-upper-block" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-header" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title-40" }, props.data.title),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-14" }, props.data.text)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-body" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title-18 accent-text" },
                "As the ",
                props.data.title,
                ", you will be:"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "text-14" }, props.data.brief.map(function (point, i) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: 'ip-' + i }, point); })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title-18 accent-text" }, tM('Required experience')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "text-14" }, props.data.requirements.map(function (point, i) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: 'ip-' + i }, point); }))))); };
    var onDrop = function (files) { return setState(__assign(__assign({}, state), { applyData: __assign(__assign({}, state.applyData), { cv: files[0] }) })); };
    var renderImageDropzone = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "drag-n-drop" }) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Dropzone, { onDrop: onDrop }, function (_a) {
            var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ className: "drag-n-drop" }, getRootProps()),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({}, getInputProps())),
                state.applyData.cv ?
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-14" }, state.applyData.cv.name) :
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-14" },
                        tM('Drag & Drop your CV here or'),
                        " ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "accent-text" }, tM('browse')))));
        }))); };
    var setTitle = function (title) { return setState(__assign(__assign({}, state), { isDropdown: false, applyData: { title: title } })); };
    var submitApply = function () {
        var _a = state.applyData, title = _a.title, name = _a.name, email = _a.email, phone = _a.phone, cv = _a.cv;
        if (name != undefined && email != undefined && phone != undefined && cv != undefined) {
            var payload = new FormData();
            payload.append('position', props.data.title);
            payload.append('name', title ? title + '. ' + name : name);
            payload.append('email', email);
            payload.append('phone', phone);
            payload.append('cv', cv);
            __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].postApplicantCvData(payload)
                .then(function (response) {
                if (response && response._id) {
                    props.toggle();
                    setTimeout(function () {
                        setState(__assign(__assign({}, state), { isApply: false, isDropdown: false, applyData: {
                                title: undefined
                            } }));
                        props.action();
                    }, 1000);
                }
            })
                .catch(function (e) { return console.log(tM('CV Data post request is failed') + ': ' + e); });
        }
    };
    var renderForm = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-upper-block" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-body" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title-18 accent-text" }, "Enter your credentials"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-row-block" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: state.isDropdown ? 'dropdown is-active' : 'dropdown' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dropdown-button", onClick: function () {
                                return setState(__assign(__assign({}, state), { isDropdown: !state.isDropdown }));
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, state.applyData.title ? state.applyData.title : tM('Title')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dropdown-menu" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "dropdown-item", onClick: function () { return setTitle('Mr'); } }, "Mr"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "dropdown-item", onClick: function () { return setTitle('Ms'); } }, "Ms"))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "contact-input small-text", type: "text", name: "contactCompany", placeholder: "\u00A0", onInput: function (e) { return setState(__assign(__assign({}, state), { applyData: __assign(__assign({}, state.applyData), { name: e.currentTarget.value }) })); } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tM('Full name')))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-row-block" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "contact-input small-text", type: "text", name: "contactName", placeholder: "\u00A0", onInput: function (e) { return setState(__assign(__assign({}, state), { applyData: __assign(__assign({}, state.applyData), { email: e.currentTarget.value }) })); } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, "Email address")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "contact-input small-text", type: "text", name: "contactCompany", placeholder: "\u00A0", onInput: function (e) { return setState(__assign(__assign({}, state), { applyData: __assign(__assign({}, state.applyData), { phone: e.currentTarget.value }) })); } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tM('Phone')))),
                renderImageDropzone())))); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'modal' + (props.show ? ' modal-show' : ' modal-hide') },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-card" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "close-modal-btn", onClick: function () {
                    props.toggle();
                    setTimeout(function () { return setState(__assign(__assign({}, state), { isApply: false, isDropdown: false, applyData: {
                            title: undefined
                        } })); }, 1000);
                } }),
            state.isApply ? renderForm() : renderData(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-footer" }, state.isApply ?
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn-modal-continue", onClick: submitApply }, tM('Submit Documents')) :
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn-modal-continue", onClick: function () { return setState(__assign(__assign({}, state), { isApply: true })); } }, tC('Apply'))))));
};
/* harmony default export */ __webpack_exports__["a"] = (Modal);


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_statusModal__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_contact_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_contact_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_contact_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_i18next__ = __webpack_require__(1);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};








var UserAppAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 19)); });
var Contact = function () {
    var tAbout = Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* useTranslation */])('about').t;
    var tCommon = Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* useTranslation */])('common').t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_6_react_i18next__["b" /* useTranslation */])('contact'), t = _a.t, i18n = _a.i18n;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    var utmParameters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__app__["a" /* AppContext */]).utmParameters;
    var statusModalData = {
        title: 'Message Sent',
        text: 'Your message has been recorded. We will reply as soon as possible.'
    };
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        placement: 'RTB_form',
        name: '',
        email: '',
        phone: '',
        message: '',
        utm: utmParameters || {}
    }), form = _b[0], setForm = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eName = _c[0], setEName = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eEmail = _d[0], setEEmail = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eMessage = _e[0], setEMessage = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), statusModal = _f[0], setStatusModal = _f[1];
    var toggleStatusModal = function () { return setStatusModal(!statusModal); };
    var updateErrors = function (name, email, message) {
        setEName(name);
        setEEmail(email);
        setEMessage(message);
    };
    var sendFormData = function () {
        updateErrors([], [], []);
        if (form.name && form.email && form.message) {
            __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* api */].postContactFormData(JSON.stringify(form))
                .then(function () {
                setForm(__assign(__assign({}, form), { name: '', email: '', phone: '', message: '' }));
                toggleStatusModal();
                window.dataLayer.push({ 'event': 'form-completed', 'location': 'Contact' });
            });
        }
        else {
            updateErrors(form.name ? [] : [tCommon('required field')], form.email ? [] : [tCommon('required field')], form.message ? [] : [tCommon('required field')]);
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container contact" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_statusModal__["a" /* default */], { data: statusModalData, show: statusModal, toggle: toggleStatusModal }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-left" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-desktop not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["t" /* tagger */])(t('Get in Touch'), __WEBPACK_IMPORTED_MODULE_5__util_util__["d" /* AQUA_TEXT */])),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "get-in-t-l" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-tablet" }, Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["t" /* tagger */])(t('Get in Touch'), __WEBPACK_IMPORTED_MODULE_5__util_util__["d" /* AQUA_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" },
                    Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["t" /* tagger */])(t('Lets grow your userbase'), __WEBPACK_IMPORTED_MODULE_5__util_util__["e" /* AQUA_TEXT_FW500 */]),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", { className: "not-desktop not-mobile" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", { className: "not-desktop not-mobile" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "get-in-tablet-span" }, t('were looking forward')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-user-app-container get-in-t-r" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UserAppAnimation, null)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-right" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text mt-10 mb-35 not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["t" /* tagger */])(t('Fill in the form'), __WEBPACK_IMPORTED_MODULE_5__util_util__["e" /* AQUA_TEXT_FW500 */])),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eName.length > 0 ? ' error-input' : ''), type: "input", name: "name", placeholder: "\u00A0", value: form.name, onChange: function (e) { return setForm(__assign(__assign({}, form), { name: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tAbout('Full name'))),
            eName && eName.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : ''), type: "email", name: "email", placeholder: "\u00A0", value: form.email, onChange: function (e) { return setForm(__assign(__assign({}, form), { email: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tAbout('Email address'))),
            eEmail && eEmail.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "contact-input small-text", type: "input", name: "phone", placeholder: "\u00A0", value: form.phone, onChange: function (e) { return setForm(__assign(__assign({}, form), { phone: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tAbout('Phone number'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-area-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", { className: 'contact-input contact-textarea small-text' + (eMessage.length > 0 ? ' error-input' : ''), name: "contactMessage", placeholder: "\u00A0", value: form.message, onChange: function (e) { return setForm(__assign(__assign({}, form), { message: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Message'))),
            eMessage && eMessage.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-aqua large", onClick: sendFormData }, tCommon('Send')))));
};
/* harmony default export */ __webpack_exports__["a"] = (Contact);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_statusModal__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_login_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_util__ = __webpack_require__(2);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var ForgotPassword = function (props) {
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('forgotPassword').t;
    var forgotRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), email = _a[0], setEmail = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eEmail = _b[0], setEEmail = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eOther = _c[0], setEOther = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), showModal = _d[0], setShowModal = _d[1];
    var toggleShowModal = function () { return setShowModal(!showModal); };
    var updateErrors = function (email, other) {
        setEEmail(email);
        setEOther(other);
    };
    var handleErrors = function (errors) {
        var parsed = Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["j" /* errorSwitcher */])(errors);
        updateErrors(parsed.email, parsed.other);
    };
    var modalData = {
        title: 'Restore Successful',
        text: 'Please check your inbox for an e-mail with additional instructions to restore your password.'
    };
    var login = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateErrors([], []);
                    forgotRef.current.classList.toggle('active');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].resetPass(email)];
                case 2:
                    response = _a.sent();
                    if (response && response.redirectUrl) {
                        if (response.redirectUrl == '/restored') {
                            setShowModal(true);
                        }
                        else {
                            props.history.push(response.redirectUrl);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    forgotRef.current.classList.toggle('active');
                    handleErrors(e_1 ? e_1.errors : __WEBPACK_IMPORTED_MODULE_5__util_util__["i" /* UNKNOWN_SERVER_ERROR */]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container text-center login-page" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_statusModal__["a" /* default */], { data: modalData, show: showModal, toggle: toggleShowModal }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/logo_persona.svg" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('reset y')),
        eOther && eOther.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : ''), type: "email", name: "email", placeholder: "\u00A0", onInput: function (e) { return setEmail(e.currentTarget.value); }, onKeyPress: function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["o" /* isEnter */])(e) && login(); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('type y'))),
        eEmail && eEmail.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { ref: forgotRef, className: "button-blue large animated", onClick: login },
            t('reset p'),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (ForgotPassword);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_common_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__(2);





var GDPR = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('gdpr'), t = _a.t, i18n = _a.i18n;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('personaly gdpr c'), __WEBPACK_IMPORTED_MODULE_3__util_util__["a" /* ACCENT_TEXT */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('the general data p'), __WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('personaly company is'), __WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, t('data processing')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('company only processes p'), __WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('technological organizational'), __WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('the company completed'), '')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('transparency and fairness'), __WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, t('company maintains a')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, t('incident responsiveness')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('company has the ability'), __WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('data protection officer'), __WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('company has appointed a'), 'text-underline'))));
};
/* harmony default export */ __webpack_exports__["a"] = (GDPR);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_statusModal__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_contact_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_contact_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_contact_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_locales__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_util__ = __webpack_require__(2);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};









var UserAppAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 19)); });
var GetInTouch = function (props) {
    var utmParameters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* AppContext */]).utmParameters;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('contact'), t = _a.t, i18n = _a.i18n;
    var tCommon = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('common').t;
    var statusModalData = {
        title: 'Message Sent',
        text: 'Your message has been recorded. We will reply as soon as possible.'
    };
    var getUserId = function () {
        var search = props.location.search;
        var params = new URLSearchParams(search);
        return params.get('id');
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var userId = getUserId();
        if (!userId) {
            props.history.push('/' + Object(__WEBPACK_IMPORTED_MODULE_6__util_locales__["b" /* getCurrentLocale */])());
        }
        Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        placement: 'getintouch',
        website: '',
        skype: '',
        phone: '',
        message: '',
        userId: getUserId(),
        utm: utmParameters || {}
    }), form = _b[0], setForm = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eWebsite = _c[0], setEWebsite = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eSkype = _d[0], setESkype = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eMessage = _e[0], setEMessage = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), statusModal = _f[0], setStatusModal = _f[1];
    var toggleStatusModal = function () { return setStatusModal(!statusModal); };
    var updateErrors = function (website, skype, message) {
        setEWebsite(website);
        setESkype(skype);
        setEMessage(message);
    };
    var sendFormData = function () {
        updateErrors([], [], []);
        if (form.website && form.skype && form.message) {
            __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].postContactFormData(JSON.stringify(form))
                .then(function () {
                setForm(__assign(__assign({}, form), { website: '', skype: '', phone: '', message: '' }));
                toggleStatusModal();
            });
        }
        else {
            updateErrors(form.website ? [] : [tCommon('required field')], form.skype ? [] : [tCommon('required field')], form.message ? [] : [tCommon('required field')]);
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container contact" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_statusModal__["a" /* default */], { data: statusModalData, show: statusModal, toggle: toggleStatusModal }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-left" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-desktop not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["t" /* tagger */])(t('Get in Touch'), 'accent-text')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "get-in-t-l" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-tablet" }, Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["t" /* tagger */])(t('Get in Touch'), 'accent-text')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" },
                    Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["t" /* tagger */])(t('Lets grow your userbase'), __WEBPACK_IMPORTED_MODULE_7__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", { className: "not-desktop not-mobile" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", { className: "not-desktop not-mobile" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "get-in-tablet-span" }, t('were looking forward')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-user-app-container get-in-t-r" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UserAppAnimation, null)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-right" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text mt-10 mb-35 not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_7__util_util__["t" /* tagger */])(t('Fill in the form'), __WEBPACK_IMPORTED_MODULE_7__util_util__["b" /* ACCENT_TEXT_FW500 */])),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eWebsite.length > 0 ? ' error-input' : ''), type: "input", name: "app", placeholder: "\u00A0", value: form.website, onChange: function (e) { return setForm(__assign(__assign({}, form), { website: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('App / Website URL'))),
            eWebsite && eWebsite.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eSkype.length > 0 ? ' error-input' : ''), type: "input", name: "skype", placeholder: "\u00A0", value: form.skype, onChange: function (e) { return setForm(__assign(__assign({}, form), { skype: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Skype ID'))),
            eSkype && eSkype.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "contact-input small-text", type: "input", name: "phone", placeholder: "\u00A0", value: form.phone, onChange: function (e) { return setForm(__assign(__assign({}, form), { phone: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Phone number'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-area-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", { className: 'contact-input contact-textarea small-text' + (eMessage.length > 0 ? ' error-input' : ''), name: "contactMessage", placeholder: "\u00A0", value: form.message, onChange: function (e) { return setForm(__assign(__assign({}, form), { message: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Message'))),
            eMessage && eMessage.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-blue large", onClick: sendFormData }, tCommon('Send')))));
};
/* harmony default export */ __webpack_exports__["a"] = (GetInTouch);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__countries_json__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_ghostCompletions_css__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_ghostCompletions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_ghostCompletions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_locales__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet__ = __webpack_require__(9);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









var COUNTRIES_VISIBLE = 'g-selector-countries g-s-c-block';
var COUNTRIES_HIDDEN = 'g-selector-countries g-s-c-none';
var C_TITLE_BORDERED = 'contact-input-container contact-input g-s-country-title';
var C_TITLE_NO_BORDERED = 'contact-input-container contact-input g-s-country-title g-s-t-no-border';
var countryToggle;
var countries;
var companyToggle;
var GhostCompletions = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_3__countries_json___default.a), countriesFiltered = _a[0], setCountriesFiltered = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eName = _b[0], setEName = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eEmailAddress = _c[0], setEEmailAddress = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eCompanyName = _d[0], setECompanyName = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eCompanyType = _e[0], setECompanyType = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eCountry = _f[0], setECountry = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eOther = _g[0], setEOther = _g[1];
    var handleClick = function (e) {
        var companies = document.getElementById('g-s-companies');
        var companyLabel = document.getElementById('g-s-company-label');
        if (e.target.parentNode != countries && e.target != countryToggle) {
            countries.className = COUNTRIES_HIDDEN;
            countryToggle.className = C_TITLE_BORDERED + (countryToggle.className.includes('error-input') ? ' error-input' : '');
            setCountriesFiltered(__WEBPACK_IMPORTED_MODULE_3__countries_json___default.a);
        }
        if (e.target.parentNode != companies && e.target != companyToggle && e.target != companyLabel) {
            companyToggle.checked = false;
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        countryToggle = document.getElementById('g-s-country-toggle');
        countries = document.getElementById('g-s-countries');
        companyToggle = document.getElementById('g-s-company-toggle');
        Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["r" /* setTitleFont */])(__WEBPACK_IMPORTED_MODULE_6__util_locales__["c" /* locales */].en);
        document.onclick = handleClick;
    }, []);
    var _h = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        Name: '',
        EmailAddress: '',
        CompanyName: '',
        CompanyType: '',
        Country: ''
    }), form = _h[0], setForm = _h[1];
    var updateErrors = function (Name, EmailAddress, CompanyName, CompanyType, Country) {
        setEName(Name);
        setEEmailAddress(EmailAddress);
        setECompanyName(CompanyName);
        setECompanyType(CompanyType);
        setECountry(Country);
    };
    var sendFormData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Name, EmailAddress, CompanyName, CompanyType, Country, body, windowReference, resp, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateErrors([], [], [], [], []);
                    setEOther([]);
                    if (!(form.Name && form.EmailAddress && form.CompanyName && form.CompanyType && form.Country)) return [3 /*break*/, 5];
                    Name = form.Name, EmailAddress = form.EmailAddress, CompanyName = form.CompanyName, CompanyType = form.CompanyType, Country = form.Country;
                    body = {
                        Name: Name,
                        EmailAddress: EmailAddress,
                        CustomFields: [
                            { key: 'CompanyName', value: CompanyName },
                            { key: 'CompanyType', value: CompanyType },
                            { key: 'Country', value: Country }
                        ],
                        Resubscribe: true,
                        RestartSubscriptionBasedAutoresponders: true,
                        ConsentToTrack: 'Yes'
                    };
                    windowReference = window.open();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].postGhostCompletionsFormData(JSON.stringify(body))];
                case 2:
                    resp = _a.sent();
                    setForm(__assign(__assign({}, form), { Name: '', EmailAddress: '', CompanyName: '', CompanyType: '', Country: '' }));
                    if (resp && windowReference) {
                        windowReference.location.replace('/personaly_white_paper_ghost_completions_june_2020.pdf');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setEOther([e_1 ? e_1.Message : 'server error']);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    updateErrors(form.Name ? [] : ['Required field'], form.EmailAddress ? [] : ['Required field'], form.CompanyName ? [] : ['Required field'], form.CompanyType ? [] : ['Required field'], form.Country ? [] : ['Required field']);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleCompanyTypeSelect = function (e) {
        setForm(__assign(__assign({}, form), { CompanyType: e.currentTarget.textContent }));
        companyToggle.checked = false;
    };
    var handleCountrySelect = function (e) {
        setForm(__assign(__assign({}, form), { Country: e.currentTarget.textContent }));
        setCountriesFiltered(__WEBPACK_IMPORTED_MODULE_3__countries_json___default.a);
        countries.className = COUNTRIES_HIDDEN;
        countryToggle.className = C_TITLE_BORDERED + (eCountry.length > 0 ? ' error-input' : '');
    };
    var renderCountries = function () {
        return countriesFiltered.map(function (country) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { onClick: handleCountrySelect, key: country.Code }, country.Name); });
    };
    var searchCountry = function (e) {
        var search = e.target.value;
        setCountriesFiltered(__WEBPACK_IMPORTED_MODULE_3__countries_json___default.a.filter(function (country) { return country.Name.toLowerCase().includes(search.toLowerCase()); }));
        setForm(__assign(__assign({}, form), { Country: search }));
    };
    var activateCountryList = function () {
        countries.className = COUNTRIES_VISIBLE;
        countryToggle.className = C_TITLE_NO_BORDERED + (eCountry.length > 0 ? ' error-input' : '');
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ghost-comp" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_helmet__["a" /* Helmet */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Ghost Completions - The Venezuelan Fraud Scheme - Persona.ly"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "title", content: "Ghost Completions - The Venezuelan Fraud Scheme - Persona.ly" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "In this white paper we detail the technological vulnerabilities enabling these ghost completions, their estimated scale, and easily preventable measures the MR industry can take, as a whole, to prevent it." })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "g-p-logo" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */], { to: "/" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/logo_personaly.svg" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "g-p-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-left" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_5__util_util__["a" /* ACCENT_TEXT */] }, "Ghost Completions"),
                    " - The\u00A0Venezuelan Fraud\u00A0Scheme"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "pre-text rgba087" }, "Technological Vulnerabilities in the MR Industry in 2020."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-g g-main-descr rgba087" },
                    "\"...This ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_5__util_util__["a" /* ACCENT_TEXT */] }, "easily preventable vulnerability"),
                    " enables\u00A0",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_5__util_util__["a" /* ACCENT_TEXT */] }, "wide\u2011scale fraud"),
                    " and hurts the market\u00A0research\u00A0industry throughout.\""),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ghost-title-ul rgba087" }, "This white paper covers:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "1. How we\u2019ve tracked and uncovered wide-scale ghost completions fraud originating in Venezuela."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "2. Two simple ways to prevent a recurrence of this fraud - explained in detail."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "3. The paradigm shift required for a long term industry-wide solution to effectively combat fraud in the MR industry.")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "ghost-share", target: "_blank", rel: "noopener noreferrer", href: "https://www.linkedin.com/shareArticle?mini=true&url=persona.ly/white_papers/ghost_completes_mr_05_2020/&title=&summary=&source=" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/ghost_completions/group-8.svg" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "rgba087 fw500" }, "Share on LinkedIn"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-right" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "ghost-circle-3 not-mobile not-tablet", src: "https://static.persona.ly/images/ghost_completions/group-6.svg" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ghost-r-internal" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "g-book-w" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "g-book", src: "https://static.persona.ly/images/ghost_completions/hardcover-book-mockup-presentation.webp" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "ghost-circle-1 not-mobile", src: "https://static.persona.ly/images/ghost_completions/group-3.svg" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "ghost-circle-1-m not-tablet not-desktop", src: "https://static.persona.ly/images/ghost_completions/group-37.svg" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-g g-download-descr rgba087 mt-30" },
                        "Download Our ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_5__util_util__["a" /* ACCENT_TEXT */] }, "White Paper")),
                    eOther && eOther.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error", key: err }, err); }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eName.length > 0 ? ' error-input' : ''), type: "input", name: "name", placeholder: "\u00A0", value: form.Name, onChange: function (e) { return setForm(__assign(__assign({}, form), { Name: e.currentTarget.value })); } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, "Name*")),
                    eName && eName.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eEmailAddress.length > 0 ? ' error-input' : ''), type: "email", name: "email", placeholder: "\u00A0", value: form.EmailAddress, onChange: function (e) { return setForm(__assign(__assign({}, form), { EmailAddress: e.currentTarget.value })); } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, "Email address*")),
                    eEmailAddress && eEmailAddress.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eCompanyName.length > 0 ? ' error-input' : ''), type: "input", name: "company", placeholder: "\u00A0", value: form.CompanyName, onChange: function (e) { return setForm(__assign(__assign({}, form), { CompanyName: e.currentTarget.value })); } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, "Company name*")),
                    eCompanyName && eCompanyName.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "g-selector-w" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { id: "g-s-company-toggle", type: "checkbox" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { id: "g-s-company-label", className: 'contact-input-container contact-input g-s-company-title' + (eCompanyType.length > 0 ? ' error-input' : ''), htmlFor: "g-s-company-toggle" },
                            form.CompanyType || 'Company type*',
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null)),
                        eCompanyType && eCompanyType.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "g-s-companies", className: "g-selector-companies" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { onClick: handleCompanyTypeSelect }, "Agency"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { onClick: handleCompanyTypeSelect }, "Buyer"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { onClick: handleCompanyTypeSelect }, "End Client"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { onClick: handleCompanyTypeSelect }, "Panel"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { onClick: handleCompanyTypeSelect }, "Supplier"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { onClick: handleCompanyTypeSelect }, "Technology Vendor"))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "g-selector-w" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { id: "g-s-country-toggle", className: C_TITLE_BORDERED + (eCountry.length > 0 ? ' error-input' : ''), type: "input", required: true, onChange: searchCountry, onClick: activateCountryList, placeholder: "Country*", value: form.Country }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null),
                        eCountry && eCountry.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "g-s-countries", className: COUNTRIES_HIDDEN }, renderCountries())),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ghost-subscribe" }, "By clicking Download, you agree to receive occasional email content from Persona.ly. You can unsubscribe at any time."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-blue large", onClick: sendFormData }, "Download")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "ghost-circle-2 not-mobile", src: "https://static.persona.ly/images/ghost_completions/group-38.svg" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (GhostCompletions);


/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = [{"Code":"AF","Name":"Afghanistan"},{"Code":"AX","Name":"Åland Islands"},{"Code":"AL","Name":"Albania"},{"Code":"DZ","Name":"Algeria"},{"Code":"AS","Name":"American Samoa"},{"Code":"AD","Name":"Andorra"},{"Code":"AO","Name":"Angola"},{"Code":"AI","Name":"Anguilla"},{"Code":"AQ","Name":"Antarctica"},{"Code":"AG","Name":"Antigua and Barbuda"},{"Code":"AR","Name":"Argentina"},{"Code":"AM","Name":"Armenia"},{"Code":"AW","Name":"Aruba"},{"Code":"AU","Name":"Australia"},{"Code":"AT","Name":"Austria"},{"Code":"AZ","Name":"Azerbaijan"},{"Code":"BS","Name":"Bahamas"},{"Code":"BH","Name":"Bahrain"},{"Code":"BD","Name":"Bangladesh"},{"Code":"BB","Name":"Barbados"},{"Code":"BY","Name":"Belarus"},{"Code":"BE","Name":"Belgium"},{"Code":"BZ","Name":"Belize"},{"Code":"BJ","Name":"Benin"},{"Code":"BM","Name":"Bermuda"},{"Code":"BT","Name":"Bhutan"},{"Code":"BO","Name":"Bolivia, Plurinational State of"},{"Code":"BQ","Name":"Bonaire, Sint Eustatius and Saba"},{"Code":"BA","Name":"Bosnia and Herzegovina"},{"Code":"BW","Name":"Botswana"},{"Code":"BV","Name":"Bouvet Island"},{"Code":"BR","Name":"Brazil"},{"Code":"IO","Name":"British Indian Ocean Territory"},{"Code":"BN","Name":"Brunei Darussalam"},{"Code":"BG","Name":"Bulgaria"},{"Code":"BF","Name":"Burkina Faso"},{"Code":"BI","Name":"Burundi"},{"Code":"KH","Name":"Cambodia"},{"Code":"CM","Name":"Cameroon"},{"Code":"CA","Name":"Canada"},{"Code":"CV","Name":"Cape Verde"},{"Code":"KY","Name":"Cayman Islands"},{"Code":"CF","Name":"Central African Republic"},{"Code":"TD","Name":"Chad"},{"Code":"CL","Name":"Chile"},{"Code":"CN","Name":"China"},{"Code":"CX","Name":"Christmas Island"},{"Code":"CC","Name":"Cocos (Keeling) Islands"},{"Code":"CO","Name":"Colombia"},{"Code":"KM","Name":"Comoros"},{"Code":"CG","Name":"Congo"},{"Code":"CD","Name":"Congo, the Democratic Republic of the"},{"Code":"CK","Name":"Cook Islands"},{"Code":"CR","Name":"Costa Rica"},{"Code":"CI","Name":"Côte d'Ivoire"},{"Code":"HR","Name":"Croatia"},{"Code":"CU","Name":"Cuba"},{"Code":"CW","Name":"Curaçao"},{"Code":"CY","Name":"Cyprus"},{"Code":"CZ","Name":"Czech Republic"},{"Code":"DK","Name":"Denmark"},{"Code":"DJ","Name":"Djibouti"},{"Code":"DM","Name":"Dominica"},{"Code":"DO","Name":"Dominican Republic"},{"Code":"EC","Name":"Ecuador"},{"Code":"EG","Name":"Egypt"},{"Code":"SV","Name":"El Salvador"},{"Code":"GQ","Name":"Equatorial Guinea"},{"Code":"ER","Name":"Eritrea"},{"Code":"EE","Name":"Estonia"},{"Code":"ET","Name":"Ethiopia"},{"Code":"FK","Name":"Falkland Islands (Malvinas)"},{"Code":"FO","Name":"Faroe Islands"},{"Code":"FJ","Name":"Fiji"},{"Code":"FI","Name":"Finland"},{"Code":"FR","Name":"France"},{"Code":"GF","Name":"French Guiana"},{"Code":"PF","Name":"French Polynesia"},{"Code":"TF","Name":"French Southern Territories"},{"Code":"GA","Name":"Gabon"},{"Code":"GM","Name":"Gambia"},{"Code":"GE","Name":"Georgia"},{"Code":"DE","Name":"Germany"},{"Code":"GH","Name":"Ghana"},{"Code":"GI","Name":"Gibraltar"},{"Code":"GR","Name":"Greece"},{"Code":"GL","Name":"Greenland"},{"Code":"GD","Name":"Grenada"},{"Code":"GP","Name":"Guadeloupe"},{"Code":"GU","Name":"Guam"},{"Code":"GT","Name":"Guatemala"},{"Code":"GG","Name":"Guernsey"},{"Code":"GN","Name":"Guinea"},{"Code":"GW","Name":"Guinea-Bissau"},{"Code":"GY","Name":"Guyana"},{"Code":"HT","Name":"Haiti"},{"Code":"HM","Name":"Heard Island and McDonald Islands"},{"Code":"VA","Name":"Holy See (Vatican City State)"},{"Code":"HN","Name":"Honduras"},{"Code":"HK","Name":"Hong Kong"},{"Code":"HU","Name":"Hungary"},{"Code":"IS","Name":"Iceland"},{"Code":"IN","Name":"India"},{"Code":"ID","Name":"Indonesia"},{"Code":"IR","Name":"Iran, Islamic Republic of"},{"Code":"IQ","Name":"Iraq"},{"Code":"IE","Name":"Ireland"},{"Code":"IM","Name":"Isle of Man"},{"Code":"IL","Name":"Israel"},{"Code":"IT","Name":"Italy"},{"Code":"JM","Name":"Jamaica"},{"Code":"JP","Name":"Japan"},{"Code":"JE","Name":"Jersey"},{"Code":"JO","Name":"Jordan"},{"Code":"KZ","Name":"Kazakhstan"},{"Code":"KE","Name":"Kenya"},{"Code":"KI","Name":"Kiribati"},{"Code":"KP","Name":"Korea, Democratic People's Republic of"},{"Code":"KR","Name":"Korea, Republic of"},{"Code":"KW","Name":"Kuwait"},{"Code":"KG","Name":"Kyrgyzstan"},{"Code":"LA","Name":"Lao People's Democratic Republic"},{"Code":"LV","Name":"Latvia"},{"Code":"LB","Name":"Lebanon"},{"Code":"LS","Name":"Lesotho"},{"Code":"LR","Name":"Liberia"},{"Code":"LY","Name":"Libya"},{"Code":"LI","Name":"Liechtenstein"},{"Code":"LT","Name":"Lithuania"},{"Code":"LU","Name":"Luxembourg"},{"Code":"MO","Name":"Macao"},{"Code":"MK","Name":"Macedonia, the Former Yugoslav Republic of"},{"Code":"MG","Name":"Madagascar"},{"Code":"MW","Name":"Malawi"},{"Code":"MY","Name":"Malaysia"},{"Code":"MV","Name":"Maldives"},{"Code":"ML","Name":"Mali"},{"Code":"MT","Name":"Malta"},{"Code":"MH","Name":"Marshall Islands"},{"Code":"MQ","Name":"Martinique"},{"Code":"MR","Name":"Mauritania"},{"Code":"MU","Name":"Mauritius"},{"Code":"YT","Name":"Mayotte"},{"Code":"MX","Name":"Mexico"},{"Code":"FM","Name":"Micronesia, Federated States of"},{"Code":"MD","Name":"Moldova, Republic of"},{"Code":"MC","Name":"Monaco"},{"Code":"MN","Name":"Mongolia"},{"Code":"ME","Name":"Montenegro"},{"Code":"MS","Name":"Montserrat"},{"Code":"MA","Name":"Morocco"},{"Code":"MZ","Name":"Mozambique"},{"Code":"MM","Name":"Myanmar"},{"Code":"NA","Name":"Namibia"},{"Code":"NR","Name":"Nauru"},{"Code":"NP","Name":"Nepal"},{"Code":"NL","Name":"Netherlands"},{"Code":"NC","Name":"New Caledonia"},{"Code":"NZ","Name":"New Zealand"},{"Code":"NI","Name":"Nicaragua"},{"Code":"NE","Name":"Niger"},{"Code":"NG","Name":"Nigeria"},{"Code":"NU","Name":"Niue"},{"Code":"NF","Name":"Norfolk Island"},{"Code":"MP","Name":"Northern Mariana Islands"},{"Code":"NO","Name":"Norway"},{"Code":"OM","Name":"Oman"},{"Code":"PK","Name":"Pakistan"},{"Code":"PW","Name":"Palau"},{"Code":"PS","Name":"Palestine, State of"},{"Code":"PA","Name":"Panama"},{"Code":"PG","Name":"Papua New Guinea"},{"Code":"PY","Name":"Paraguay"},{"Code":"PE","Name":"Peru"},{"Code":"PH","Name":"Philippines"},{"Code":"PN","Name":"Pitcairn"},{"Code":"PL","Name":"Poland"},{"Code":"PT","Name":"Portugal"},{"Code":"PR","Name":"Puerto Rico"},{"Code":"QA","Name":"Qatar"},{"Code":"RE","Name":"Réunion"},{"Code":"RO","Name":"Romania"},{"Code":"RU","Name":"Russian Federation"},{"Code":"RW","Name":"Rwanda"},{"Code":"BL","Name":"Saint Barthélemy"},{"Code":"SH","Name":"Saint Helena, Ascension and Tristan da Cunha"},{"Code":"KN","Name":"Saint Kitts and Nevis"},{"Code":"LC","Name":"Saint Lucia"},{"Code":"MF","Name":"Saint Martin (French part)"},{"Code":"PM","Name":"Saint Pierre and Miquelon"},{"Code":"VC","Name":"Saint Vincent and the Grenadines"},{"Code":"WS","Name":"Samoa"},{"Code":"SM","Name":"San Marino"},{"Code":"ST","Name":"Sao Tome and Principe"},{"Code":"SA","Name":"Saudi Arabia"},{"Code":"SN","Name":"Senegal"},{"Code":"RS","Name":"Serbia"},{"Code":"SC","Name":"Seychelles"},{"Code":"SL","Name":"Sierra Leone"},{"Code":"SG","Name":"Singapore"},{"Code":"SX","Name":"Sint Maarten (Dutch part)"},{"Code":"SK","Name":"Slovakia"},{"Code":"SI","Name":"Slovenia"},{"Code":"SB","Name":"Solomon Islands"},{"Code":"SO","Name":"Somalia"},{"Code":"ZA","Name":"South Africa"},{"Code":"GS","Name":"South Georgia and the South Sandwich Islands"},{"Code":"SS","Name":"South Sudan"},{"Code":"ES","Name":"Spain"},{"Code":"LK","Name":"Sri Lanka"},{"Code":"SD","Name":"Sudan"},{"Code":"SR","Name":"Suriname"},{"Code":"SJ","Name":"Svalbard and Jan Mayen"},{"Code":"SZ","Name":"Swaziland"},{"Code":"SE","Name":"Sweden"},{"Code":"CH","Name":"Switzerland"},{"Code":"SY","Name":"Syrian Arab Republic"},{"Code":"TW","Name":"Taiwan, Province of China"},{"Code":"TJ","Name":"Tajikistan"},{"Code":"TZ","Name":"Tanzania, United Republic of"},{"Code":"TH","Name":"Thailand"},{"Code":"TL","Name":"Timor-Leste"},{"Code":"TG","Name":"Togo"},{"Code":"TK","Name":"Tokelau"},{"Code":"TO","Name":"Tonga"},{"Code":"TT","Name":"Trinidad and Tobago"},{"Code":"TN","Name":"Tunisia"},{"Code":"TR","Name":"Turkey"},{"Code":"TM","Name":"Turkmenistan"},{"Code":"TC","Name":"Turks and Caicos Islands"},{"Code":"TV","Name":"Tuvalu"},{"Code":"UG","Name":"Uganda"},{"Code":"UA","Name":"Ukraine"},{"Code":"AE","Name":"United Arab Emirates"},{"Code":"GB","Name":"United Kingdom"},{"Code":"US","Name":"United States"},{"Code":"UM","Name":"United States Minor Outlying Islands"},{"Code":"UY","Name":"Uruguay"},{"Code":"UZ","Name":"Uzbekistan"},{"Code":"VU","Name":"Vanuatu"},{"Code":"VE","Name":"Venezuela, Bolivarian Republic of"},{"Code":"VN","Name":"Viet Nam"},{"Code":"VG","Name":"Virgin Islands, British"},{"Code":"VI","Name":"Virgin Islands, U.S."},{"Code":"WF","Name":"Wallis and Futuna"},{"Code":"EH","Name":"Western Sahara"},{"Code":"YE","Name":"Yemen"},{"Code":"ZM","Name":"Zambia"},{"Code":"ZW","Name":"Zimbabwe"}]

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lazyload__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dataDriven__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_events__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_headquarters__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_partners__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_retention__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_landing_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_landing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__css_landing_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_util__ = __webpack_require__(2);













var MainRtbAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 229)); });
var Monetization = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 51)); });
var MarketResearch = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 52)); });
var UserAppAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 19)); });
var Landing = function () {
    var appContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__app__["a" /* AppContext */]);
    var setTopbarColor = appContext.setTopbarColor;
    var accentText = 'accent-text';
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('landing'), t = _a.t, i18n = _a.i18n;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["r" /* setTitleFont */])(i18n.language);
        var pdContainer = document.getElementById('pdContainer');
        var emContainer = document.getElementById('emContainer');
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting && entries[0].target === pdContainer) {
                setTopbarColor(__WEBPACK_IMPORTED_MODULE_11__util_util__["g" /* TOPBAR_COLOR_AQUA */]);
            }
            else if (entries[0].isIntersecting && entries[0].target === emContainer) {
                setTopbarColor(__WEBPACK_IMPORTED_MODULE_11__util_util__["h" /* TOPBAR_COLOR_RED */]);
            }
            else {
                setTopbarColor(__WEBPACK_IMPORTED_MODULE_11__util_util__["f" /* TOPBAR_COLOR_ACCENT */]);
            }
        }, { threshold: [0.5] });
        pdContainer && observer.observe(pdContainer);
        emContainer && observer.observe(emContainer);
        return function () {
            pdContainer && observer.unobserve(pdContainer);
            emContainer && observer.unobserve(emContainer);
        };
    }, []);
    var scrollToHandler = function () { return Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["m" /* goToElementId */])('pdContainer', true); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "landing" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "down-scroll not-tablet not-mobile", onClick: scrollToHandler },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "down-scroll-text" }, "SCROLL"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "down-scroll-animation down-scroll-animation-blue" }, " ")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "mlContainer" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-desktop not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('Machine Learning D'), accentText)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-c-b" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'tablet main-rtb' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-tablet" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('Machine Learning D'), accentText)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, t('Value first c')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('personaly creates'), accentText)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, t('we offer machine')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c trusted not-tablet not-mobile" }, t('Trusted by')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "not-tablet not-mobile", src: "https://static.persona.ly/images/clients.svg" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-main-rtb-container tablet" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MainRtbAnimation, null)))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c trusted not-desktop supported" }, t('Trusted by')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "not-desktop trusted-rtb-img", src: "https://static.persona.ly/images/clients.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "pdContainer" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('Parsing Data I'), 'aqua-text')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, t('Machine learning d')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('Personaly offers'), 'aqua-text fw700')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, t('While processing over')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p not-mobile not-tablet" }, t('Our Data-driven P')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_dataDriven__["a" /* default */], { className: "ddp-landing aqua-text not-mobile not-tablet", full: false }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */], { to: "rtb" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-aqua large" },
                            t('Learn More'),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_lazyload___default.a, { className: "lottie-user-app-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UserAppAnimation, null)))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "ddContainer" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-desktop not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('Data-Driven Sample P'), accentText)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-c-b" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'tablet market-research-lg' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-tablet" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('Data-Driven Sample P'), accentText)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, t('Quickly gain g')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('Personaly provides m'), 'accent-text fw700')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c not-mobile not-tablet" }, t('Using machine l')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sample-providers not-mobile not-tablet" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/02.svg" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('Feasibility & Cost'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/03.svg" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('Multi-Language S'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/group-16.svg" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('API Integration')))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */], { to: "market-research" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-blue large" },
                                t('Learn More'),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" })))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_lazyload___default.a, { className: "lottie-market-research-container tablet" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MarketResearch, null))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "emContainer" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "monetization-lg" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('Exceptional M'), 'red-text')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, t('Achieved by using a')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, Object(__WEBPACK_IMPORTED_MODULE_11__util_util__["t" /* tagger */])(t('Personaly provides a'), 'red-text fw700')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */], { to: "monetization" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-red large" },
                            t('Learn More'),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_lazyload___default.a, { className: "lottie-monetization-container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Monetization, null))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_lazyload___default.a, null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "partners-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_partners__["a" /* default */], null))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_lazyload___default.a, null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "blog-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_retention__["a" /* default */], null))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_lazyload___default.a, null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "event-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_events__["a" /* default */], null))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_lazyload___default.a, null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_headquarters__["a" /* default */], { showButton: true }))));
};
/* harmony default export */ __webpack_exports__["a"] = (Landing);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_events_css__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_events_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_events_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_i18next__ = __webpack_require__(1);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var Events = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_5_react_i18next__["b" /* useTranslation */])('landing').t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), events = _a[0], setEvents = _a[1];
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var eventsResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].events()];
                case 1:
                    eventsResult = _a.sent();
                    setEvents(eventsResult.results);
                    return [2 /*return*/];
            }
        });
    }); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () { loadData(); }, []);
    var renderEvent = function (event, index) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: event._id, className: "event" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "event-image", style: { backgroundImage: 'url(' + encodeURI(event.image) + ')' } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "event-description" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, event.name),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "event-location" },
                        event.dateString,
                        " - ",
                        event.location))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "event-dot" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/events/oval-copy-4.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "event-date not-tablet not-mobile", style: { backgroundImage: 'url(https://static.persona.ly/images/events/' + index + '.svg)' } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, event.dateString))));
    };
    var renderEventList = function () { return events.map(function (event, index) { return renderEvent(event, index + 1); }); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "events" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "muli" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Upcoming Events'), 'accent-text')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, renderEventList()),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */], { to: "about#contact" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-blue large" }, t('schedule a meeting')))));
};
/* harmony default export */ __webpack_exports__["a"] = (Events);


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_alice_carousel_lib_alice_carousel_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_alice_carousel_lib_alice_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_alice_carousel_lib_alice_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_partners_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_partners_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_partners_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_locales__ = __webpack_require__(6);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









var Partners = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('landing'), t = _a.t, i18n = _a.i18n;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), reviews = _b[0], setReviews = _b[1];
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var language, reviewsResult, reviews;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    language = (_a = __WEBPACK_IMPORTED_MODULE_6__util_util__["q" /* localeToInternalLang */].get(i18n.language)) === null || _a === void 0 ? void 0 : _a.apiLang;
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* api */].reviews(language || __WEBPACK_IMPORTED_MODULE_7__util_locales__["c" /* locales */].en)];
                case 1:
                    reviewsResult = _b.sent();
                    reviews = reviewsResult.results;
                    setReviews(reviews);
                    return [2 /*return*/];
            }
        });
    }); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        loadData();
    }, [i18n.language]);
    var handleOnDragStart = function (e) { return e.preventDefault(); };
    var renderReview = function (review) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: review._id, onDragStart: handleOnDragStart, className: "review-item" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "carousel-inline-img review-image", style: { backgroundImage: 'url(' + encodeURI(review.image) + ')' } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "user-photo" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: encodeURI(review.writerImage) })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "user-description" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "user-name accent-text" }, review.writerName),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "user-position" },
                    review.writerTitle,
                    " @ ",
                    review.writerCompanyName),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "user-review" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["s" /* spanirizerByString */])(review.text, 'Persona.ly', 'accent-text fw700')),
                review.writerCaseStudyUrl && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: review.writerCaseStudyUrl, target: "_blank", rel: "noopener noreferrer" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-review" }, t('read case'))))));
    };
    var renderReviewList = function () {
        return reviews
            .sort(function (a, b) { return a.priority - b.priority; })
            .map(function (review) { return renderReview(review); });
    };
    var carousel = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
    var handlePrevPageChange = function () {
        var _a, _b;
        (_b = (_a = carousel) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.slidePrev();
    };
    var handleNextPageChange = function () {
        var _a, _b;
        (_b = (_a = carousel) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.slideNext();
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "partners" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "muli" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Our Partners'), 'accent-text')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('here s what t')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "reviews carousel-inline" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: 'prev not-mobile not-tablet prev-h', src: "https://static.persona.ly/images/partners/path-2-copy-2.svg", onClick: handlePrevPageChange }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default.a, { mouseTrackingEnabled: true, buttonsDisabled: true, items: renderReviewList(), ref: carousel, responsive: {
                        0: {
                            items: 1,
                        },
                        1105: {
                            items: 2
                        }
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: 'next not-mobile not-tablet next-h', src: "https://static.persona.ly/images/partners/path-2-copy-2.svg", onClick: handleNextPageChange }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "partners-integrations" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                t('Attribution p'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/partners/group-19.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                t('Analytics i'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/partners/group-21.svg" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (Partners);


/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_retention_css__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_retention_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_retention_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_locales__ = __webpack_require__(6);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var Retention = function () {
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('landing').t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), posts = _a[0], setPosts = _a[1];
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var itemsNumber, blogResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    itemsNumber = window.innerWidth > 1104 ? 5 : 3;
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].blog(itemsNumber)];
                case 1:
                    blogResult = _a.sent();
                    setPosts(blogResult);
                    return [2 /*return*/];
            }
        });
    }); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        loadData();
    }, []);
    var renderPost = function (post, i) {
        var options = {
            hour12: false,
            timeZone: 'UTC',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: post.post_url, key: i, className: "post-item" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "post-image", src: post.preview_image_url }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "post-description" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "post-title" }, post.title),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "post-author" },
                    post.author.name,
                    " \u2022 ",
                    new Date(post.publish_date).toLocaleDateString(__WEBPACK_IMPORTED_MODULE_5__util_locales__["c" /* locales */].enUS, options)))));
    };
    var renderPostList = function () { return posts.map(function (post, i) { return renderPost(post, i); }); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "blog" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "muli" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The Weekly R'), 'accent-text')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('Get the latest i')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "posts" }, renderPostList()))));
};
/* harmony default export */ __webpack_exports__["a"] = (Retention);


/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_login_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_util__ = __webpack_require__(2);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var Login = function () {
    var loginRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('login').t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), email = _a[0], setEmail = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), pass = _b[0], setPass = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eEmail = _c[0], setEEmail = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), ePass = _d[0], setEPass = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eOther = _e[0], setEOther = _e[1];
    var updateErrors = function (email, pass, other) {
        setEEmail(email);
        setEPass(pass);
        setEOther(other);
    };
    var handleErrors = function (errors) {
        var parsed = Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["j" /* errorSwitcher */])(errors);
        updateErrors(parsed.email, parsed.pass, parsed.other);
    };
    var login = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateErrors([], [], []);
                    loginRef.current.classList.toggle('active');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* api */].login(email, pass)];
                case 2:
                    response = _a.sent();
                    if (response && response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    loginRef.current.classList.toggle('active');
                    handleErrors(e_1 ? e_1.errors : __WEBPACK_IMPORTED_MODULE_5__util_util__["i" /* UNKNOWN_SERVER_ERROR */]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container text-center login-page" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/logo_persona.svg" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('login to')),
        eOther && eOther.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : ''), type: "email", name: "email", placeholder: "\u00A0", onInput: function (e) { return setEmail(e.currentTarget.value); }, onKeyPress: function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["o" /* isEnter */])(e) && login(); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('email a'))),
        eEmail && eEmail.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (ePass.length > 0 ? ' error-input' : ''), type: "password", name: "pass", placeholder: "\u00A0", onInput: function (e) { return setPass(e.currentTarget.value); }, onKeyPress: function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["o" /* isEnter */])(e) && login(); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('pass'))),
        ePass && ePass.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-checkbox-c" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "remember-me-l" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "remember-me-s" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "remember-me-i", id: "remember", type: "checkbox", value: "" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "remember-me-s-inner" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, t('remember me'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { className: "forgot-pass", to: "forgot_password" }, t('forgot p'))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { ref: loginRef, className: "button-blue large animated button-login", onClick: login },
            t('login'),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "to-register" }, Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["t" /* tagger */])(t('dont have a'), 'accent-text fw500', 'sign_up'))));
};
/* harmony default export */ __webpack_exports__["a"] = (Login);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_carouselOutline__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_marketResearch_css__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_marketResearch_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_marketResearch_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_util__ = __webpack_require__(2);








var MarketResearchAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 52)); });
var DeviceAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 53)); });
var PhoneAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 230)); });
var PersonAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 231)); });
var WorldMap = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 232)); });
var continentToCounterMap = new Map([
    ['Africa', '360,000'],
    ['North America', '4,500,000'],
    ['Europe', '1,900,000'],
    ['Asia', '1,300,000'],
    ['Australia', '200,000'],
    ['South America', '600,000']
]);
var MarketResearch = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])('market-research'), t = _a.t, i18n = _a.i18n;
    var tC = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])('common').t;
    var tL = Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* useTranslation */])('landing').t;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        continent: undefined
    }), state = _b[0], setState = _b[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    var scrollToHandler = function () { return Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["m" /* goToElementId */])('reachGlobal', true); };
    var audienceListBlocks = [
        {
            title: t('Surveytime'),
            text: t('Surveytime is a global'),
            img: 'https://static.persona.ly/images/market_research_page/group-15.svg',
            audience: {
                demo: '18+',
                geoList: ['USA']
            }
        },
        {
            title: t('Offer Wall'),
            text: t('Offer Wall is integrated'),
            img: 'https://static.persona.ly/images/market_research_page/group-33.svg',
            audience: {
                demo: '18-35',
                geoList: ['USA', 'IN', 'RU', 'BR']
            }
        },
        {
            title: t('Gifthulk'),
            text: t('Founded in 2011'),
            img: 'https://static.persona.ly/images/market_research_page/group-34.svg',
            audience: {
                demo: '35+',
                geoList: ['USA']
            }
        }
    ];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "market-research" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "down-scroll not-tablet not-mobile", onClick: scrollToHandler },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "down-scroll-text" }, "SCROLL"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "down-scroll-animation down-scroll-animation-blue" }, " ")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_helmet__["a" /* Helmet */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Market Research - Gain consumer insights for your products or brand"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "title", content: "Market Research - Gain consumer insights for your products or brand" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Persona.ly provides market research sampling solutions, delivering quality data at scale from diverse audiences" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "keywords", content: "Market Research, Sample Providers, Market Research Panel, Consumer Insights, Surveytime, Gifthulk, Offer Wall, Survey Panel" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-desktop not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Data-Driven'), __WEBPACK_IMPORTED_MODULE_6__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "market-research-c" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'tablet market-research-mr' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-tablet" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Data-Driven'), __WEBPACK_IMPORTED_MODULE_6__util_util__["a" /* ACCENT_TEXT */])),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, t('Quickly gain global')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Personaly provides'), __WEBPACK_IMPORTED_MODULE_6__util_util__["a" /* ACCENT_TEXT */])),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "two-buttons" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */], { to: "mrcontact" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-blue large" },
                                    tC('Start Now'),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" }))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */], { to: "about#contact" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-grey large" }, tC('Contact Us')))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c trusted not-tablet not-mobile trusted-by" }, tL('Trusted by')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "not-tablet not-mobile", src: "https://static.persona.ly/images/partners/market-research-trusted.svg" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-market-research-container tablet" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MarketResearchAnimation, null)))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c supported not-desktop trusted-by" }, tL('Trusted by')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "not-desktop", src: "https://static.persona.ly/images/partners/market-research-trusted.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "reachGlobal", className: "full-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mid-block" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "blog muli" }, t('Reach Global')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Our multiple panels'), 'accent-text fw700')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { margin: '2.5% 0 1.5% 0' } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_carouselOutline__["a" /* default */], { blocks: audienceListBlocks })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { marginTop: 0 } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "full-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mid-block" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "blog muli" }, t('Global Reach At Scale')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Our panels reach'), __WEBPACK_IMPORTED_MODULE_6__util_util__["a" /* ACCENT_TEXT */])))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "registered-map", onMouseLeave: function () { return setState({ continent: undefined }); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WorldMap, { callback: function (e) { return setState({ continent: e.currentTarget.id }); } }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "registered-users" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "registered-users-count" }, state.continent ? continentToCounterMap.get(state.continent) : '9,000,000'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "registered-users-title" }, state.continent ? 'active panelists in ' + state.continent : t('Registered Users Worldwide'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "full-block where-technology" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mid-block" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "blog muli" }, t('Where Technology Meets')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('In less than 100 miliseconds'), 'accent-text fw700')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "part-after-title pat-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-left" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p not-mobile" }, t('Machine Learning')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c not-mobile" }, t('our algorithms title'))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-device-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DeviceAnimation, null))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p not-tablet not-desktop" }, t('Machine Learning')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c not-tablet not-desktop" }, t('our algorithms title'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-right" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, t('Additional Features')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-feature-container" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { minHeight: 100 } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "additional-features-icon", src: "https://static.persona.ly/images/group-16.svg" })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-text-container" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-title" }, t('API Integration')),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-text" }, t('Manage your survey'))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-feature-container" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { minHeight: 100 } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "additional-features-icon", src: "https://static.persona.ly/images/02.svg" })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-text-container" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-title" }, t('Feasibility & Cost')),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-text" }, t('Quick estimation of'))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-feature-container" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { minHeight: 100 } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "additional-features-icon", src: "https://static.persona.ly/images/03.svg" })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-text-container" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-title" }, t('Multi-Language Support')),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-features-text" }, t('Our algorithms match')))))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "full-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mid-block" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "blog muli" }, t('We Ensure Data Quality')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, t('By monitoring over')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "part-after-title pat-2" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-phone-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PhoneAnimation, null))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-text" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-title" }, t('Device Recognition')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-section" },
                                t('Email'),
                                " + ",
                                t('Mobile Verification')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-section" }, t('Device Fingerprinting')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-section" }, t('Device Reputation')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-section" },
                                t('Physical Address'),
                                " + ",
                                t('Proxy Detection'))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-person-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PersonAnimation, null))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-text" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-title" }, t('Human Recognition')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-section" }, t('Red Herring Question')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-text-details" }, t('An effective measure for')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-section" }, t('ReCaptcha')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-text-details" }, t('Real-time detection')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-section" }, t('Pattern Analysis')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-text-details" }, t('Automatic detection')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-section" }, t('LOI Comparisons')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quality-text-details" }, t('Monitors survey')))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (MarketResearch);


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_carouselOutline__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_simpleList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_steps__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_landing_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_landing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_landing_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_monetization_css__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_monetization_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__css_monetization_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_iconAppWall__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_iconNativeAds__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_iconOfferWall__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_iconPlayableAds__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_iconRewardedVideo__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_util__ = __webpack_require__(2);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

















var ReactImageMagnify = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 54)); });
var MonetizationAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 51)); });
var Format;
(function (Format) {
    Format["Iframe"] = "iframe";
    Format["Img"] = "img";
    Format["Video"] = "video";
})(Format || (Format = {}));
var Monetization = function () {
    var emptyScreenRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('monetization'), t = _a.t, i18n = _a.i18n;
    var tCommon = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('common').t;
    var controlImgList = [
        { small: 'https://static.persona.ly/images/monetization/monetization-1-small.webp', large: 'https://static.persona.ly/images/monetization/monetization-1.webp' },
        { small: 'https://static.persona.ly/images/monetization/monetization-2-small.webp', large: 'https://static.persona.ly/images/monetization/monetization-2.webp' },
        { small: 'https://static.persona.ly/images/monetization/monetization-3-small.webp', large: 'https://static.persona.ly/images/monetization/monetization-3.webp' }
    ];
    var customizeListBlocks = [
        {
            title: t('Control'),
            text: t('Define ad behavior 2'),
            img: 'https://static.persona.ly/images/monetization/group-25.svg'
        },
        {
            title: t('Measure'),
            text: t('Get in depth conversion'),
            img: 'https://static.persona.ly/images/monetization/group-26.svg'
        },
        {
            title: t('Optimize'),
            text: t('Get actionable insights'),
            img: 'https://static.persona.ly/images/monetization/group-29.svg'
        }
    ];
    var simpleListBlocks = [
        {
            title: t('Custom Campaigns'),
            textList: [t('Hand-picked')],
            img: 'https://static.persona.ly/images/monetization/image-custom.webp'
        },
        {
            title: t('Premium eCPM'),
            textList: [t('Unique market research')],
            img: 'https://static.persona.ly/images/monetization/image-premium.webp'
        },
        {
            title: t('High Engagement'),
            textList: [t('Provide your users with 1')],
            img: 'https://static.persona.ly/images/monetization/image-high.webp'
        }
    ];
    var stepsBlocks = [
        {
            title: t('Integrate'),
            textList: [t('Implement our'), 'SDK / APIs'],
            img: 'https://static.persona.ly/images/monetization/impression-level-features-ilu.svg'
        },
        {
            title: t('Customize & Control'),
            textList: [t('Choose your ad'), t('formats & when to'), t('display them')],
            img: 'https://static.persona.ly/images/monetization/user-centric-features-ilu.svg'
        },
        {
            title: t('Maximize'),
            textList: [t('Increase ARPU and'), t('scale your business')],
            img: 'https://static.persona.ly/images/monetization/engagement-analysis-ilu.svg'
        }
    ];
    var interactiveBlocks = [
        {
            title: t('Offer users bite'),
            points: [
                t('Up to x25 higher'),
                t('Over 30% of users'),
                t('Optimized by measuring'),
                t('HTML5, light weight')
            ],
            img: 'https://static.persona.ly/images/monetization/icon_app_wall_inactive.svg',
            preview: {
                format: Format.Iframe,
                src: 'https://static.persona.ly/images/monetization/cookie_jam.html'
            }
        },
        {
            title: t('Reward your users'),
            points: [
                t('Proven to be favored'),
                t('Ideal for monetizing'),
                t('High eCPM and'),
                t('Relevant videos')
            ],
            img: 'https://static.persona.ly/images/icon_native_ads_inactive.svg',
            preview: {
                format: Format.Video,
                src: 'https://static.persona.ly/images/monetization/rewarded_video.mp4'
            }
        },
        {
            title: t('Display ads that'),
            points: [
                t('25x Higher eCPM'),
                t('2x Higher click rate'),
                t('Avoid negative reactions'),
                t('Avoid ad blindness')
            ],
            img: 'https://static.persona.ly/images/monetization/icon_offer_wall_inactive.svg',
            preview: {
                format: Format.Img,
                src: 'https://static.persona.ly/images/monetization/nativeads.webp'
            }
        },
        {
            title: t('Offer your users'),
            points: [
                t('A great way to'),
                t('Offered applications'),
                t('User initiated'),
                t('Customized to your')
            ],
            img: 'https://static.persona.ly/images/monetization/icon_playable_ads_active.svg',
            preview: {
                format: Format.Img,
                src: 'https://static.persona.ly/images/monetization/appwall.webp'
            }
        },
        {
            title: t('Reward your users 2'),
            points: [
                t('Offer users multiple'),
                t('Significantly increase'),
                t('User initiated'),
                t('Contains unique')
            ],
            img: 'https://static.persona.ly/images/monetization/icon_rewarded_video_inactive.svg',
            preview: {
                format: Format.Img,
                src: 'https://static.persona.ly/images/monetization/offerwall.webp'
            }
        }
    ];
    var interactiveButtons = [
        {
            name: t('PLAYABLE ADS'),
            icon: __WEBPACK_IMPORTED_MODULE_13__svg_iconPlayableAds__["a" /* default */]
        },
        {
            name: t('REWARDED VIDEO'),
            icon: __WEBPACK_IMPORTED_MODULE_14__svg_iconRewardedVideo__["a" /* default */]
        },
        {
            name: t('NATIVE ADS'),
            icon: __WEBPACK_IMPORTED_MODULE_11__svg_iconNativeAds__["a" /* default */]
        },
        {
            name: t('APP WALL'),
            icon: __WEBPACK_IMPORTED_MODULE_10__svg_iconAppWall__["a" /* default */]
        },
        {
            name: t('OFFER WALL'),
            icon: __WEBPACK_IMPORTED_MODULE_12__svg_iconOfferWall__["a" /* default */]
        }
    ];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        innerWidth: window.innerWidth,
        interactiveButtonIndex: 0,
        interactivePreview: {
            format: Format.Iframe,
            src: 'https://static.persona.ly/images/monetization/cookie_jam.html'
        },
        iFrameHeight: 400
    }), state = _b[0], setState = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        height: 400
    }), iframe = _c[0], setIframe = _c[1];
    var calcFrameHeight = function () {
        if (emptyScreenRef.current) {
            var height = emptyScreenRef.current.height * 0.7;
            setIframe({ height: height });
        }
    };
    var scrollToHandler = function () { Object(__WEBPACK_IMPORTED_MODULE_15__util_util__["m" /* goToElementId */])('interactiveExp', true); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        window.addEventListener('resize', function () { return calcFrameHeight(); });
        Object(__WEBPACK_IMPORTED_MODULE_15__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    var renderInteractiveBlock = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p not-mobile" }, interactiveBlocks[state.interactiveButtonIndex].title),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "block-c short-li-mobile" }, interactiveBlocks[state.interactiveButtonIndex].points.map(function (point, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: 'ip-' + i }, point);
        })))); };
    var renderInteractiveButtons = function () { return interactiveButtons.map(function (button, i) {
        var isActive = state.interactiveButtonIndex == i;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: 'ib-' + i, className: "is-centered" },
            button.icon(isActive, 'not-mobile'),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: 'button-grey outline small ' + (isActive ? 'active' : ''), onClick: function () {
                    return setState(__assign(__assign({}, state), { interactiveButtonIndex: i, interactivePreview: interactiveBlocks[i].preview }));
                } }, button.name)));
    }); };
    var renderInteractivePreview = function () {
        switch (state.interactivePreview.format) {
            case Format.Iframe:
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("iframe", { src: state.interactivePreview.src, frameBorder: 0, style: { minHeight: iframe.height } });
            case Format.Img:
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: state.interactivePreview.src });
            case Format.Video:
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("video", { src: state.interactivePreview.src, autoPlay: true, loop: true, playsInline: true });
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "monetization" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "down-scroll not-tablet not-mobile", onClick: scrollToHandler },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "down-scroll-text" }, "SCROLL"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "down-scroll-animation down-scroll-animation-red" }, " ")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_helmet__["a" /* Helmet */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Monetize your applications with interactive ads and increase your ARPU"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "title", content: "Monetize your applications with interactive ads and increase your ARPU" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Persona.ly offers a programmatic & fully transparent service, from playable and dynamic creative generation, to driving scale and providing actionable marketing insights" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "keywords", content: "Mobile Monetization, Playable Ads, Interactive Ads, Dynamic Ads, Performance-based Campaigns, Native Ads,Rewarded Video, CPE Campaigns,CPI Traffic,CPI Offers" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-desktop not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_15__util_util__["t" /* tagger */])(t('exceptional'), 'red-text')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "monetization-c" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tablet monetization-description" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-tablet" }, Object(__WEBPACK_IMPORTED_MODULE_15__util_util__["t" /* tagger */])(t('exceptional'), 'red-text')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, t('Achieved by using')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, t('Provides a variety')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "m-two-buttons", style: { marginTop: '2rem' } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */], { to: "sign_up" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-red large m-button-mr" },
                                    tCommon('Integrate Now'),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/arrow.svg" }))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */], { to: "about#contact" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-grey large" }, tCommon('Contact Us')))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c not-tablet not-mobile", style: { marginTop: '4rem' } },
                            t('Supported platforms'),
                            ":"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", className: "not-tablet not-mobile", src: "https://static.persona.ly/images/group-64.svg", style: { marginTop: 8 } })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-monetization-container tablet" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MonetizationAnimation, null)))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c supported not-desktop", style: { marginTop: '4rem' } },
                    t('Supported platforms'),
                    ":"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", className: "not-desktop", src: "https://static.persona.ly/images/group-64.svg", style: { marginTop: 8 } })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "interactiveExp", className: "interactive-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli mt-t" }, Object(__WEBPACK_IMPORTED_MODULE_15__util_util__["t" /* tagger */])(t('interactive'), 'red-text')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, t('Maximized eCPM')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "button-block", style: { marginTop: '5%' } }, renderInteractiveButtons()),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-block" },
                        renderInteractiveBlock(),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-preview not-desktop" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { ref: emptyScreenRef, alt: "", src: "https://static.persona.ly/images/monetization/dynamic-ads-ilu.svg", onLoad: calcFrameHeight }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "loader-container" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "loader inside" })),
                            renderInteractivePreview())),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */], { to: "sign_up" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-red large is-block", style: { marginTop: '2rem' } },
                            tCommon('Integrate Now'),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/arrow.svg" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-preview not-mobile not-tablet" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/monetization/dynamic-ads-ilu.svg" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "loader-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "loader outside" })),
                    renderInteractivePreview())),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli mt-t is-tablet" },
                        t('Lightweight SDK'),
                        " / ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "red-text" }, t('Campaigns API'))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli mt-t not-tablet" },
                            t('Lightweight SDK'),
                            " / ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "red-text" }, t('Campaigns API'))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p mt-26" }, t('Monetize effectively')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c mt-26" }, t('Start monetizing your app')))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_steps__["a" /* default */], { blocks: stepsBlocks }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-block" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c supported" },
                    t('Supported platforms'),
                    ":"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/group-64.svg", style: { marginTop: 8, marginBottom: 32, width: '100%' } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_simpleList__["a" /* default */], { blocks: simpleListBlocks })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "additional-api" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/monetization/rtb-icon-01.svg" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, t('Gain access to')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */], { to: "sign_up" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-red large" },
                            tCommon('Integrate Now'),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/arrow.svg" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */], { to: "about#contact" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-grey large" }, tCommon('Contact Us')))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customize-optimize" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli mt-t" }, Object(__WEBPACK_IMPORTED_MODULE_15__util_util__["t" /* tagger */])(t('Customize & Maximize'), 'red-text')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p mt-26" }, t('Define ad behavior')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c mt-26" }, t('Our dashboard provides'))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customize-block" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-left" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_carouselOutline__["a" /* default */], { blocks: customizeListBlocks })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-right images-rounded" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default.a, { autoHeight: false, buttonsDisabled: true, infinite: false, mouseTrackingEnabled: true, items: controlImgList.map(function (img, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { key: i, fallback: "" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ReactImageMagnify, __assign({ onDragStart: function (e) { return e.preventDefault(); } }, {
                            smallImage: {
                                isFluidWidth: true,
                                src: img.small
                            },
                            largeImage: {
                                src: img.large,
                                width: 1200,
                                height: 800
                            },
                            style: { cursor: 'zoom-in' },
                            enlargedImagePosition: 'over',
                            isHintEnabled: true,
                            hintTextMouse: 'Hover to Zoom',
                            hintTextTouch: 'Long-Touch to Zoom'
                        })))); }) }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c mt-control" }, Object(__WEBPACK_IMPORTED_MODULE_15__util_util__["t" /* tagger */])(t('Control, measure'), 'red-text')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */], { to: "sign_up" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-red large" },
                        tCommon('Start Now'),
                        " ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/arrow.svg" }))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "offer-wall-block" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-left" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli mt-t" }, Object(__WEBPACK_IMPORTED_MODULE_15__util_util__["t" /* tagger */])(t('Offer Wall'), 'red-text')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p mt-26" }, t('Monetize loyal')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c mt-26" }, t('An offer wall is a great way')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, t('Provide your users with')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/group-14.svg" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */], { to: "sign_up" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-red large" },
                        tCommon('Integrate Now'),
                        " ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/arrow.svg" })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-right" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/monetization/big-offer-wall.webp" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (Monetization);


/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var IconAppwall = function (isActive, className) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", className: className ? className : '', width: "48", height: "70", viewBox: "0 0 48 70" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { fill: "none", fillRule: "evenodd", stroke: isActive ? '#ff6262' : '#4A4A83', strokeWidth: ".849" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M1 24.586l5.262-3.038 6.45 3.726v12.545l22.834 13.185v-6.469l5.262-3.037 6.45 3.725v20.948l-5.261 3.037L1 45.534z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M12.713 25.274l-5.32 3.075v12.549l5.32-3.076V25.274zM41.997 48.261l5.262-3.038" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M1 24.586l6.45 3.726v12.545L35.547 57.08V44.535l6.45 3.726v20.947L1 45.534z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M19.231 3.507L23.573 1l8.526 4.923v22.212l6.198 3.58-10.462 7.027-4.341 2.507-10.46-19.11 4.262-2.461 1.935 1.117z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M19.231 25.718V3.507l8.526 4.923v22.211l6.199 3.58-10.462 7.028-10.46-19.11z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M32.099 5.923l-4.342 2.513V30.43l4.342-2.513z" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (IconAppwall);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var IconNativeAds = function (isActive, className) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", className: className ? className : '', width: "37", height: "70", viewBox: "0 0 37 70" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { fill: "none", fillRule: "evenodd", stroke: isActive ? '#ff6262' : '#4A4A83', strokeWidth: ".66" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M34.025 17.262c0-1.073-.654-2.32-1.458-2.785L8.387.505C7.585.04 6.932.534 6.932 1.606v9.968c0 1.072.653 2.32 1.457 2.784l24.18 13.972c.803.465 1.457-.029 1.457-1.101v-9.967zM34.025 57.448c0-1.072-.654-2.32-1.458-2.785L8.387 40.692c-.803-.465-1.456.028-1.456 1.101v9.967c0 1.072.653 2.32 1.457 2.784l24.18 13.973c.803.464 1.457-.029 1.457-1.102v-9.967zM.919 19.724a65.513 65.513 0 0 1 2.25-1.3c.31-.161.708-.137 1.141.113L34.1 35.75c.99.572 1.794 2.11 1.794 3.43v12.28c0 .743-.254 1.26-.653 1.469-.31.162-1.76.995-2.12 1.224-.32.202-.743.193-1.207-.075L2.124 36.866c-.99-.572-1.794-2.11-1.794-3.43v-12.28c0-.702.227-1.203.589-1.432z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M33.708 40.443c0-1.321-.803-2.858-1.794-3.43L2.124 19.798c-.99-.573-1.794.036-1.794 1.357v12.28c0 1.32.804 2.858 1.794 3.43l29.79 17.213c.99.573 1.794-.036 1.794-1.357V40.443z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M12.316 30.376c0-.828-.503-1.791-1.124-2.15l-7.01-4.05c-.62-.358-1.124.023-1.124.85v7.694c0 .827.504 1.79 1.125 2.149l7.01 4.05c.62.359 1.123-.022 1.123-.85v-7.693zM16.566 34.867l11.915 6.88M16.566 38.488l5.958 3.44" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (IconNativeAds);


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var IconOfferWall = function (isActive, className) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", className: className ? className : '', width: "52", height: "70", viewBox: "0 0 52 70" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { fill: "none", fillRule: "evenodd", stroke: isActive ? '#ff6262' : '#4A4A83', strokeWidth: ".782" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M47.184 23.943c.751 1.705 1.201 3.57 1.201 5.314v30.938c0 2.093-.646 3.611-1.687 4.365-1.009.731-7.757 4.49-7.797 4.515-.996.65-2.328.629-3.789-.216L6.593 52.365C3.507 50.579 1 45.785 1 41.665V10.727c0-2.178.7-3.734 1.815-4.454.996-.641 6.615-3.822 7.8-4.506.98-.567 2.26-.513 3.658.296l16.68 9.648" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M40.705 33.69c0-4.119-2.506-8.913-5.593-10.699L6.593 6.497C3.507 4.71 1 6.607 1 10.727v30.938c0 4.12 2.507 8.914 5.593 10.7l28.519 16.494c3.087 1.786 5.593-.11 5.593-4.23V33.69zM5.248 32.589l6.351 3.666M8.423 38.088v-7.333" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M13.123 33.774l2.952-3.099v12.369M29.287 38.303c1.884 1.088 3.413 4.745 3.413 8.162 0 3.417-1.53 5.308-3.413 4.219-1.884-1.088-3.413-4.746-3.413-8.163 0-3.416 1.529-5.306 3.413-4.218zM23.37 34.946l-4.156-2.399s-.035 3.34 0 4.743c.464-.12 1.011-.027 1.597.311 1.676.968 3.037 3.59 3.037 5.85s-1.36 3.307-3.037 2.34c-.925-.534-1.754-1.571-2.31-2.772M51.266 11.81v10.513l-3.39 1.956-16.922-9.76.028-11.561L34.372 1l3.673 7.46 1.568-1.62 3.196-1.712 4.235 9.121z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M43.655 16.206l4.222-2.438V24.28l-16.923-9.76V4.009l4.226 7.315 4.24-4.238 4.235 9.12z" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (IconOfferWall);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var IconPlayableAds = function (isActive, className) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", className: className ? className : '', width: "69", height: "69", viewBox: "0 0 69 69" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { fill: "none", fillRule: "evenodd", stroke: isActive ? '#ff6262' : '#4A4A83', strokeWidth: ".961" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M50.846 48.972l-16.788-9.7v19.39l16.788 9.699V48.97zM50.864 48.97l16.789-9.698V58.66l-16.789 9.7z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M34.076 19.905l16.788-9.7v19.39l-16.788 9.699z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M50.84 29.583l16.792 9.694-16.794 9.69-16.79-9.695zM34.077.48l16.79 9.695-16.793 9.69-16.791-9.695zM17.275 10.197l-.004 19.385-16.79-9.695z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M34.058 39.28l-16.789-9.7v19.389l16.789 9.7zM34.058 19.883l-16.789-9.698v19.389l16.789 9.698z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M17.27 29.586l-16.79-9.7v19.39l16.79 9.7z" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (IconPlayableAds);


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var IconRewardedVideo = function (isActive, className) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", className: className ? className : '', width: "70", height: "69", viewBox: "0 0 70 69" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { fill: "none", fillRule: "evenodd", stroke: isActive ? '#ff6262' : '#4A4A83', strokeWidth: ".714" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M17.512 37.495V9.604c0-.854.26-1.477.68-1.795.42-.317 2.867-1.61 3.31-1.917.417-.288.98-.287 1.6.07l36.121 20.873M65.066 43.277v21.35c0 .934-.31 1.593-.802 1.876l-3.27 1.888c-.406.234-.937.213-1.516-.122l-33.74-19.496" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M25.737 48.773l33.74 19.496c1.28.74 2.319-.047 2.319-1.754V43.178M56.006 28.754L19.831 7.85c-1.28-.74-2.319.046-2.319 1.753V37.49" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M25.737 42.244L.357 27.586v15.071l25.38 14.658z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M13.047 37.77c2.236 1.293 4.052 4.439 4.052 7.022s-1.816 3.63-4.052 2.338c-2.236-1.292-4.052-4.438-4.052-7.02 0-2.584 1.816-3.632 4.052-2.34zM56.359 28.44c.513-.387 1.877-1.118 2.343-1.378 1.096-.61 2.599-.51 4.255.446 3.353 1.934 6.075 6.649 6.077 10.519 0 1.867-.633 3.2-1.665 3.86-.476.306-1.607.904-2.008 1.16-1.106.71-2.672.646-4.406-.355-3.352-1.935-6.074-6.649-6.076-10.519 0-1.754.558-3.035 1.48-3.732z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M60.95 28.666c3.352 1.936 6.074 6.65 6.076 10.52.001 3.87-2.72 5.442-6.071 3.506-3.352-1.935-6.074-6.649-6.076-10.519-.001-3.87 2.72-5.441 6.07-3.507z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M62.481 38.525c-.415.221-.98.18-1.602-.18-1.275-.736-2.313-2.53-2.313-4.004 0-1.473 1.035-2.071 2.311-1.335.518.3.998.774 1.383 1.33M60.85 31.768v1.223M60.85 38.329v1.224M3.32 37.259l2.52 1.457M20.248 47.034l2.522 1.456M12.763 4.935c-2.449-4.725-5.68-2.86-4.089.44 1.535 3.182 4.091 4.103 4.905 7.726.922 4.1-3.6 3.752-6.09-.914M10.595.357v2.017M10.595 15.49v2.017M33.085 24.813l2.177-1.257 14.22 20.05-2.177 1.257-14.22 3.64v-23.69z" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M47.305 44.863l-14.22 3.64v-23.69z" }))));
};
/* harmony default export */ __webpack_exports__["a"] = (IconRewardedVideo);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_statusModal__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_contact_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_contact_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_contact_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_util__ = __webpack_require__(2);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};








var DeviceAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 53)); });
var MRContact = function () {
    var utmParameters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* AppContext */]).utmParameters;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('contact'), t = _a.t, i18n = _a.i18n;
    var tAbout = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('about').t;
    var tCommon = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('common').t;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    var statusModalData = {
        title: 'Message Sent',
        text: 'Your message has been recorded. We will reply as soon as possible.'
    };
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        placement: 'market_research_form',
        name: '',
        email: '',
        phone: '',
        message: '',
        utm: utmParameters || {}
    }), form = _b[0], setForm = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eName = _c[0], setEName = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eEmail = _d[0], setEEmail = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eMessage = _e[0], setEMessage = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), statusModal = _f[0], setStatusModal = _f[1];
    var toggleStatusModal = function () { return setStatusModal(!statusModal); };
    var updateErrors = function (name, email, message) {
        setEName(name);
        setEEmail(email);
        setEMessage(message);
    };
    var sendFormData = function () {
        updateErrors([], [], []);
        if (form.name && form.email && form.message) {
            __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].postContactFormData(JSON.stringify(form))
                .then(function () {
                setForm(__assign(__assign({}, form), { name: '', email: '', phone: '', message: '' }));
                toggleStatusModal();
            });
        }
        else {
            updateErrors(form.name ? [] : [tCommon('required field')], form.email ? [] : [tCommon('required field')], form.message ? [] : [tCommon('required field')]);
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container contact" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_statusModal__["a" /* default */], { data: statusModalData, show: statusModal, toggle: toggleStatusModal }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-left" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-desktop not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Get in Touch'), __WEBPACK_IMPORTED_MODULE_6__util_util__["a" /* ACCENT_TEXT */])),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "get-in-t-l" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-tablet" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Get in Touch'), __WEBPACK_IMPORTED_MODULE_6__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" },
                    Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Lets grow your userbase MR'), __WEBPACK_IMPORTED_MODULE_6__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", { className: "not-desktop not-mobile" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", { className: "not-desktop not-mobile" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "get-in-tablet-span" }, t('were looking forward')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-device-container get-in-t-r" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DeviceAnimation, null)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-right" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text mt-10 mb-35 not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_6__util_util__["t" /* tagger */])(t('Fill in the form'), __WEBPACK_IMPORTED_MODULE_6__util_util__["b" /* ACCENT_TEXT_FW500 */])),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eName.length > 0 ? ' error-input' : ''), type: "input", name: "name", placeholder: "\u00A0", value: form.name, onChange: function (e) { return setForm(__assign(__assign({}, form), { name: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tAbout('Full name'))),
            eName && eName.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : ''), type: "email", name: "email", placeholder: "\u00A0", value: form.email, onChange: function (e) { return setForm(__assign(__assign({}, form), { email: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tAbout('Email address'))),
            eEmail && eEmail.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "contact-input small-text", type: "input", name: "phone", placeholder: "\u00A0", value: form.phone, onChange: function (e) { return setForm(__assign(__assign({}, form), { phone: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tAbout('Phone number'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-area-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", { className: 'contact-input contact-textarea small-text' + (eMessage.length > 0 ? ' error-input' : ''), name: "contactMessage", placeholder: "\u00A0", value: form.message, onChange: function (e) { return setForm(__assign(__assign({}, form), { message: e.currentTarget.value })); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Message'))),
            eMessage && eMessage.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-blue large", onClick: sendFormData }, tCommon('Send')))));
};
/* harmony default export */ __webpack_exports__["a"] = (MRContact);


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_gdpr_css__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_gdpr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_gdpr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__(2);






var PrivacyDsp = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('privacyDsp'), t = _a.t, i18n = _a.i18n;
    var activator = function (e) { return e.currentTarget.parentElement.lastChild.classList.toggle('active'); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('personaly dsp'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, "[Last Revised: April 26, 2018]"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('op vision ltd'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" },
            Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('personaly recognizes p1'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "/" }, "www.Persona.ly"),
            Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('personaly recognizes p2'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text", style: { border: '1px solid #00d4f8', padding: '8px' } }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('acceptance of the terms'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('this policy c'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-decimal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('types of i')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('data collected f')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('data we c')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('use of your i')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('how we c')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('data collection b')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('third party c')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('sharing your i')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('your choices and c')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('targeted ad')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('children p')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('data security')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('data r')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('transfer of d')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('do not track')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('data protection o')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('modifications and u')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('contact us'))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('types of inf')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('the first type o'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('the second type o'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('please note that we'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('data collected'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-disc" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('registration d'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('identifiers c'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('payment a'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('technical w'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('newsletter subscription'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('data we collect'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('when using a p')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-disc" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('approximate g')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('carrier, isps')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('device properties s')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('user clickstream')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('internet browser')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('certain identifiers'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('use of your i')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('personaly uses t'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-disc" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('enhance your ex')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('to operate, pr')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('to optimize the c')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('perform research')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('to respond to y')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('protect our or t')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('to audit and t'))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('how we collect i')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('depending on the nature'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-upper-latin" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('automatically, inc')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('when you voluntarily'))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('data collection b')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('when you access or')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('the cookies and s')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('for more inf')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-disc" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://support.google.com/chrome/answer/95647?hl=en;" }, "https://support.google.com/chrome/answer/95647?hl=en (Chrome);")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences" }, "https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences (Firefox);")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "http://www.opera.com/help/tutorials/security/cookies/" }, "http://www.opera.com/help/tutorials/security/cookies/ (Opera);")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies" }, "https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies (Internet Explorer);")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://support.apple.com/kb/PH21411" }, "https://support.apple.com/kb/PH21411 (Safari);"),
                        " ",
                        t('and')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy" }, "https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy (Edge)."))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('most browsers will')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('third parties')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('third party c')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('the service may'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('sharing your i')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('personaly will not'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-lower-latin" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('authorized disclosures'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('compelled disclosures'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('service providers'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('business transfers'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('non-personal information'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('your choices and c')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('your principal rights')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-lower-latin" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to access')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to rectification')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to erasure')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to restrict')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to object')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to data')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to complain')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to withdraw'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('we provide you with'), '', 'mailto:support@persona.ly')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" },
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('if you would like ad'), '', 'mailto:support@persona.ly'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "mailto:victor@persona.ly" }, "victor@persona.ly"),
                    "."))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('targeted ad')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('even after providing')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('options to opt out')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-disc" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('learn how to opt-out from android'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('learn how to opt-out from ios'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('you may control how your'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('you may opt out of certain'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('if you wish to opt out of interest'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('our Publishers may also'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('in the event, that')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('you may also contact'), '', 'mailto:support@persona.ly')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('children p')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('you represent and warrant'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('data security')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" },
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('your privacy is very'), '', '/security'),
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('in addition, some of'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('furthermore, some of the'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('personaly also protects'), '', 'mailto:support@persona.ly')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('further, in the event')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('data r')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('we retain the non-personal')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('transfer of d')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('as a part of an international')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('do not track')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('the service does not respond'), '', 'http://www.allaboutdnt.com/')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('data protection o')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('if you have any requests'), '', 'mailto:victor@persona.ly')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('please be sure to include')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('modifications and u')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('we reserve the right')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('contact us')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('if you have any questions')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "accent-text" }, "O.P Vision LTD dba Persona.ly"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    "Meir Weissgal Rd. 2, Rehovot",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('you can also contact'), '', 'mailto:support@persona.ly'))))));
};
/* harmony default export */ __webpack_exports__["a"] = (PrivacyDsp);


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_gdpr_css__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_gdpr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_gdpr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__(2);





var PrivacyPolicy = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('privacy-policy'), t = _a.t, i18n = _a.i18n;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container text-center" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, t('privacy policies')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('click here 1'), '', 'privacy_dsp')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('click here 2'), '', 'privacy_sdk')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, t('information security')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('click here 3'), '', 'security')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('click here 4'), '', 'gdpr'))));
};
/* harmony default export */ __webpack_exports__["a"] = (PrivacyPolicy);


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_landing_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_landing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_landing_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_monetization_css__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_monetization_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_monetization_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__(2);






var PrivacySdk = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('privacySdk'), t = _a.t, i18n = _a.i18n;
    var activator = function (e) { return e.currentTarget.parentElement.lastChild.classList.toggle('active'); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container privacy" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Personaly SDK Privacy Policy'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, "[Last Revised: June 6, 2018]"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('OP Vision LTD dba'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Our technology enables us'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, t('Personaly recognizes the importance')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('This Policy describes Personaly'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, t('We have included below information')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-decimal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Where you sign up for')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('If we have a legitimate interest')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('We will also process'))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion", style: { marginTop: '2rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Types of information we collect')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The first type of information'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The Non-Personal Information'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The second type of information'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Please note that we may collect'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The third type of information'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Information we collect from business partners')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('If you are one of our')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-disc" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Registration'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Payment'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Technical'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Newsletter Subscription'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Information we collect from users')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('SDK, which is integrated')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Personaly collects')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Further, as detailed above'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Use of your information by personaly')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Personaly uses the information')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-disc" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Operate, manage, enhance and improve')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Respond to your inquiries')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Protect the rights')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Detect and report fraudulent')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Ensure eligibility to take')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Deliver targeted advertisements'))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('How we collect information')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Depending on the nature of')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('For additional information regarding')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('How we collect information')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Depending on the nature of')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('For additional information regarding')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Data collection by third parties')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('When you access or use the Service')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('The cookies and similar technologies')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('may also use cookies'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Third party content')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The Service may link to third party content'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Sharing your information with other companies')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Personaly will not share')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('We may disclose your Personal Information'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Your choices and controls')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Your principal rights under')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-lower-latin" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to access')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to rectification')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to erasure')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to restrict processing')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to object to processing')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to data portability')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to complain')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('the right to withdraw consent'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('We provide you with the ability'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('If you would like additional information'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Targeted advertising opt out option')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Even after providing your consent')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Options to opt out')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-disc" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Learn how to opt-out from Android'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                        " - ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://support.google.com/ads/answer/2662922" }, "https://support.google.com/ads/answer/2662922")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Learn how to opt-out from iOS'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                        " - ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://support.apple.com/en-il/HT205223" }, "https://support.apple.com/en-il/HT205223")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('You may control how your browser')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('You may opt out of certain advertisers'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('If you wish to opt out')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Our App Developers may also provide'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('In the event, that you have')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('You may also Contact Us'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Childrens privacy')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('You represent and warrant that'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Data security and integrity')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" },
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Your privacy is very important'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://www.digitalocean.com/security/ " }, "https://www.digitalocean.com/security/ ")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Personaly also protects your privacy'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Further, in the event of a data breach')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Data retention')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('We retain the Non-Personal Information')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Transfer of data')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('As a part of an international group')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Do not track disclosure')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('The Service does not respond')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Data protection officer')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('If you have any requests'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Please be sure to include')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Modifications and updates')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('WE RESERVE THE RIGHT TO')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Market research')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Personaly may share your personal information'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "ul-decimal" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Identifying client survey opportunities')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Disclosing such data elements')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Appending such data elements')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, t('Other uses as set'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('If you are eligible for'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Contact Us')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('If you have any questions')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "accent-text" }, "O.P Vision LTD dba Persona.ly"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    "Meir Weissgal Rd. 2, Rehovot",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('You can also contact us'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]))))));
};
/* harmony default export */ __webpack_exports__["a"] = (PrivacySdk);


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_login_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_util__ = __webpack_require__(2);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var Register = function (props) {
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('register').t;
    var registerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), name = _a[0], setName = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), skype = _b[0], setSkype = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), company = _c[0], setCompany = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), email = _d[0], setEmail = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), password = _e[0], setPassword = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eName = _f[0], setEName = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eSkype = _g[0], setESkype = _g[1];
    var _h = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eCompany = _h[0], setECompany = _h[1];
    var _j = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eEmail = _j[0], setEEmail = _j[1];
    var _k = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), ePass = _k[0], setEPass = _k[1];
    var _l = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eOther = _l[0], setEOther = _l[1];
    var utmParameters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* AppContext */]).utmParameters;
    var updateErrors = function (name, skype, company, email, pass, other) {
        setEName(name);
        setESkype(skype);
        setECompany(company);
        setEEmail(email);
        setEPass(pass);
        setEOther(other);
    };
    var handleErrors = function (errors) {
        var parsed = Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["j" /* errorSwitcher */])(errors);
        updateErrors(parsed.name, parsed.skype, parsed.company, parsed.email, parsed.pass, parsed.other);
    };
    var register = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateErrors([], [], [], [], [], []);
                    registerRef.current.classList.toggle('active');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].register({ name: name, skype: skype, companyName: company, email: email, password: password, utm: utmParameters || {} })];
                case 2:
                    response = _a.sent();
                    if (response && response.userId) {
                        window.dataLayer.push({ 'event': 'form-completed', 'location': 'Signup' });
                        props.history.push('welcome?id=' + response.userId);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    registerRef.current.classList.toggle('active');
                    handleErrors(e_1 ? e_1.errors : __WEBPACK_IMPORTED_MODULE_5__util_util__["i" /* UNKNOWN_SERVER_ERROR */]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container text-center login-page" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/logo_persona.svg" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('register y')),
        eOther && eOther.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eName.length > 0 ? ' error-input' : ''), type: "text", name: "name", placeholder: "\u00A0", onInput: function (e) { return setName(e.currentTarget.value); }, onKeyPress: function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["o" /* isEnter */])(e) && register(); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('name'))),
        eName && eName.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eSkype.length > 0 ? ' error-input' : ''), type: "text", name: "skype", placeholder: "\u00A0", onInput: function (e) { return setSkype(e.currentTarget.value); }, onKeyPress: function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["o" /* isEnter */])(e) && register(); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('skype'))),
        eSkype && eSkype.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eCompany.length > 0 ? ' error-input' : ''), type: "text", name: "companyName", placeholder: "\u00A0", onInput: function (e) { return setCompany(e.currentTarget.value); }, onKeyPress: function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["o" /* isEnter */])(e) && register(); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('company n'))),
        eCompany && eCompany.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : ''), type: "email", name: "email", placeholder: "\u00A0", onInput: function (e) { return setEmail(e.currentTarget.value); }, onKeyPress: function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["o" /* isEnter */])(e) && register(); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('email ad'))),
        eEmail && eEmail.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (ePass.length > 0 ? ' error-input' : ''), type: "password", name: "pass", placeholder: "\u00A0", onInput: function (e) { return setPassword(e.currentTarget.value); }, onKeyPress: function (e) { return Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["o" /* isEnter */])(e) && register(); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('password'))),
        ePass && ePass.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { ref: registerRef, className: "button-blue large animated", onClick: register },
            t('get started'),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "to-register" }, Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["t" /* tagger */])(t('already sig'), 'fw500', 'login'))));
};
/* harmony default export */ __webpack_exports__["a"] = (Register);


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_statusModal__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_restored_css__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_restored_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_restored_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_locales__ = __webpack_require__(6);





var Restored = function (props) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true), showModal = _a[0], setShowModal = _a[1];
    var toggleShowModal = function () {
        setShowModal(!showModal);
        props.history.push('/' + Object(__WEBPACK_IMPORTED_MODULE_3__util_locales__["b" /* getCurrentLocale */])());
    };
    var modalData = {
        title: 'Restore Successful',
        text: 'Please check your inbox for an e-mail with additional instructions to restore your password.'
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "restored" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_statusModal__["a" /* default */], { data: modalData, show: showModal, toggle: toggleShowModal })));
};
/* harmony default export */ __webpack_exports__["a"] = (Restored);


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dataDriven__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_simpleList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_steps__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_rtb_css__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_rtb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_rtb_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_caseStudies__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_lazyload__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_lazyload__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};













var ReactImageMagnify = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 54)); });
var Experiences = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 233)); });
var ReEngagement = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 234)); });
var Fraud = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 235)); });
var UserAppAnimation = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 19)); });
var RTB = function (props) {
    var tC = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('common').t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('rtb'), t = _a.t, i18n = _a.i18n;
    var tL = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('landing').t;
    var aquaText = 'aqua-text';
    var handleOnDragStart = function (e) { return e.preventDefault(); };
    var scrollToHandler = function () { Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["m" /* goToElementId */])('rtb-container', true); };
    // let [state, setState] = useState({
    //     currentControlPage: 0
    // })
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () { return Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["n" /* goToHash */])(props); }, [props.location.hash]);
    var controlImgList = [
        { small: 'https://static.persona.ly/images/rtb/rtb-1-small.webp', large: 'https://static.persona.ly/images/rtb/rtb-1.webp' },
        { small: 'https://static.persona.ly/images/rtb/rtb-2-small.webp', large: 'https://static.persona.ly/images/rtb/rtb-2.webp' },
        { small: 'https://static.persona.ly/images/rtb/rtb-3-small.webp', large: 'https://static.persona.ly/images/rtb/rtb-3.webp' }
    ];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rtb" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "down-scroll not-tablet not-mobile", onClick: scrollToHandler },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "down-scroll-text" }, "SCROLL"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "down-scroll-animation down-scroll-animation-green" }, " ")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_helmet__["a" /* Helmet */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Machine learning driven mobile user acquisition & re-targeting"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "title", content: "Machine learning driven mobile user acquisition & re-targeting" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Persona.ly offers a programmatic & fully transparent service, from playable and dynamic creative generation, to driving scale and providing actionable marketing insights" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "keywords", content: "User Acquisition, Programmatic User Acquisition, Mobile UA, Retargeting, Re-engagement, Playable Ads, Interactive Ads, Dynamic Ads, Performance-based Campaigns" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-desktop not-mobile" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(tL('Parsing Data I'), aquaText)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rtb-c-b" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tablet rtb-parsing-data" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli not-tablet" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(tL('Parsing Data I'), aquaText)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-p" }, tL('Machine learning d')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(tL('Personaly offers'), 'aqua-text fw700')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */], { to: "contact" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-aqua large" },
                                tC('Start Now'),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c trusted-rtb not-tablet not-mobile" }, tL('Trusted by')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "not-tablet not-mobile", src: "https://static.persona.ly/images/clients.svg" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-user-app-container tablet" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UserAppAnimation, null)))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c trusted-rtb not-desktop supported" }, tL('Trusted by')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "not-desktop trusted-rtb-img", src: "https://static.persona.ly/images/clients.svg" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "rtb-container", className: "rtb-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-t muli" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('Identifying Your U'), aquaText)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c rtb-description" }, t('Our algorithms a')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_steps__["a" /* default */], { blocks: [
                        {
                            title: t('Impression Level F'), textList: [
                                t('placement in app'),
                                t('day n time'),
                                t('creative type'),
                                t('rtb exchange'),
                                t('historical p')
                            ], img: 'https://static.persona.ly/images/rtb/impression-level-features-ilu.svg'
                        },
                        {
                            title: t('User-Centric Features'), textList: [
                                t('category retention'),
                                t('geo location'),
                                t('installed apps'),
                                t('usage hours'),
                                t('perceived persona'),
                                t('session depth')
                            ], img: 'https://static.persona.ly/images/rtb/user-centric-features-ilu.svg'
                        },
                        {
                            title: t('Engagement Analysis'), textList: [
                                t('click tendency'),
                                t('in-ad behavoir'),
                                t('click depth'),
                                t('viewability')
                            ], img: 'https://static.persona.ly/images/rtb/engagement-analysis-ilu.svg'
                        },
                    ] })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-t muli" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('Our Data-Driven Process'), aquaText)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c rtb-description" }, t('While similarities b')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_dataDriven__["a" /* default */], { className: "ddp-rtb aqua-text", full: true })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_lazyload___default.a, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "ad-creatives" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-t muli" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('Immersive and P'), aquaText)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c rtb-description" }, t('The mobile apps industry')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c rtb-description" }, t('To have the r')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rtb-animation-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rtb-ads-1" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-block" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-preview" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { alt: "", src: "https://static.persona.ly/images/monetization/dynamic-ads-ilu.svg" }),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("iframe", { src: "https://static.persona.ly/images/monetization/cookie_jam.html", frameBorder: 0 }))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "aqua-text" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('Playable & Intera'), ''))),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, t('Interactive ads offer t')),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, t('Playable ads are')))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rtb-ads-2" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-experiences-container" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Experiences, null))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "aqua-text" }, t('Dynamic Ads'))),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, t('Dynamic ads are c')),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, t('Dynamic ads are all'))))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_lazyload___default.a, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "retargeting" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-t muli" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('Turn Inactive U'), aquaText)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c rtb-description" }, t('Reaching out to d')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rtb-re-engaged" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-re-engaged-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ReEngagement, null))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "fw700" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "aqua-text" }, t('detecting inactive users'))),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('in the bidstream'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "fw700" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('Creating an incentivized ad'), aquaText)),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('based on aggreggated b'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "fw700" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('Displaying the ad'), aquaText)),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('the dormant'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, t('Rewarding the user')))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_lazyload___default.a, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-t muli" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('Affirmed Quality Users'), aquaText)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c rtb-description" }, t('Our customized machine')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rtb-fraud" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_simpleList__["a" /* default */], { blocks: [
                                {
                                    title: t('Inventory'),
                                    textList: [t('Our proprietary')],
                                    img: 'https://static.persona.ly/images/rtb/inventory.svg'
                                }, {
                                    title: t('Fraud Prevention'),
                                    textList: [t('Using a scheme of rules')],
                                    img: 'https://static.persona.ly/images/rtb/fraud-prevention.svg'
                                }, {
                                    title: t('Exclusively In-App'),
                                    textList: [t('All of our impressions')],
                                    img: 'https://static.persona.ly/images/rtb/group-15.svg'
                                }, {
                                    title: t('members of caaf'),
                                    textList: [t('proud members of'), Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('read more'), 'a-white fw700', 'https://www.adjust.com/blog/spotlight-on-caaf-three-new-members/', true)],
                                    img: 'https://static.persona.ly/images/rtb/group-25.svg'
                                }
                            ] }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lottie-fraud-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: "" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Fraud, null)))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_lazyload___default.a, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "transparency" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "headquarters-t muli" }, Object(__WEBPACK_IMPORTED_MODULE_9__util_util__["t" /* tagger */])(t('Transparent & Actionable'), aquaText)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c rtb-description" }, t('Analyzing decisions made by')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "block-c rtb-description" }, t('Our dashboard provides')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rtb-performance" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "images-rounded" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default.a, { mouseTrackingEnabled: true, buttonsDisabled: true, infinite: false, items: controlImgList.map(function (img, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { key: i, fallback: "" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ReactImageMagnify, __assign({ onDragStart: handleOnDragStart }, {
                                        smallImage: {
                                            isFluidWidth: true,
                                            src: img.small
                                        },
                                        largeImage: {
                                            src: img.large,
                                            width: 1440,
                                            height: 900
                                        },
                                        style: { cursor: 'zoom-in' },
                                        enlargedImagePosition: 'over',
                                        isHintEnabled: true,
                                        hintTextMouse: 'Hover to Zoom',
                                        hintTextTouch: 'Long-Touch to Zoom'
                                    })))); }) })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_simpleList__["a" /* default */], { blocks: [
                                {
                                    title: t('Creative Analysis'),
                                    textList: [t('Easily view and analyze')],
                                    img: 'https://static.persona.ly/images/rtb/creative-analysis.svg'
                                }, {
                                    title: t('Performance Reports'),
                                    textList: [t('Get a full overview o')],
                                    img: 'https://static.persona.ly/images/rtb/group-22-2.svg'
                                }, {
                                    title: t('Demographic Insights'),
                                    textList: [t('Gain insights regarding')],
                                    img: 'https://static.persona.ly/images/rtb/demographic-insights.svg'
                                }
                            ] })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "case-studies-wrapper" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_caseStudies__["a" /* default */], null)))));
};
/* harmony default export */ __webpack_exports__["a"] = (RTB);


/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_alice_carousel_lib_alice_carousel_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_alice_carousel_lib_alice_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_alice_carousel_lib_alice_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_caseStudies_css__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_caseStudies_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_caseStudies_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_util__ = __webpack_require__(2);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





// import {api} from '../api/api'


function generateId() {
    var i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                i = 0;
                _a.label = 1;
            case 1:
                if (false) return [3 /*break*/, 3];
                return [4 /*yield*/, i++];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/, i];
        }
    });
}
var idGenerator = generateId();
var allCases = [
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/rapido.webp',
        title: 'Rapido',
        description: 'Learn how we outperformed Rapido Bike-Taxi App’s CPA KPI by 45% while scaling up the campaign x13',
        results: {
            first: {
                percents: '45%',
                description: 'lower CPA than the KPI',
                isArrowDown: true
            },
            second: {
                percents: 'x13',
                description: 'campaign scaling within 4 months'
            }
        },
        readMore: 'https://persona.ly/blog/2022/07/programmatic-user-acquisition-case-study-rapido/',
        download: 'https://content.cdn.personaly.bid/case_studies/Rapido%20Programmatic%20User%20Acquisition%20Case%20Study%20-%20Persona.ly.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/coinswitch.webp',
        title: 'CoinSwitch Kuber',
        description: 'Learn how we managed to target users with a high probability of conversion based on four deep-funnel KPIs representing user flow at different stages of the user funnel for CoinSwitch cryptocurrency exchange platform.',
        results: {
            first: {
                percents: 'x3.1',
                description: 'FTD CVR higher than KPI'
            },
            second: {
                percents: 'x3.7',
                description: 'KYC to FTD ratio higher than KPI'
            }
        },
        readMore: 'https://persona.ly/blog/2022/06/programmatic-ua-coinswitch/',
        download: 'https://content.cdn.personaly.bid/case_studies/CoinSwitch%20Programmatic%20UA%20case%20study.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/waitr.webp',
        title: 'Waitr',
        description: 'Learn how we collaborated with Pipar\\TBWA to re-engage Waitr’s users in US and exceeded CPA KPI',
        results: {
            first: {
                percents: '19%',
                description: 'lower D7 FTD Cost',
                isArrowDown: true
            }
        },
        readMore: 'https://persona.ly/blog/2022/05/programmatic-re-egagement-waitr/',
        download: 'https://content.cdn.personaly.bid/case_studies/Waitr%20-Programmatic%20Re-engagement%20Case%20Study%20-%20Persona.ly.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/rummycircle.webp',
        title: 'RummyCircle',
        description: 'Learn how we Achieved D7 FTD Cost 53% Below KPI for Games24x7’s RummyCircle',
        results: {
            first: {
                percents: '53%',
                description: 'lower D7 FTD Cost'
            },
            second: {
                percents: '15x',
                description: 'installs growth in two months'
            }
        },
        readMore: 'https://persona.ly/blog/2022/03/how-we-achieved-d7-ftd-cost-53-below-kpi-for-games24x7s-rummycircle/',
        download: 'https://content.cdn.personaly.bid/case_studies/RummyCircle_UA%20Strategy%20Case%20Study.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/oktafx.webp',
        title: 'OctaFX',
        description: 'Learn how we reached 83% Deep Funnel Conversion and increased account generation conversion by 50% within a month of starting campaigns for OctaFX.',
        results: {
            first: {
                percents: '83%',
                description: 'Deep Funnel Conversion'
            },
            second: {
                percents: '50%',
                description: 'increase in 30D Cost Recoup'
            }
        },
        readMore: 'https://persona.ly/blog/2022/03/how-we-outperformed-octafx-kpi-reaching-83-deep-funnel-conversion/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/OctaFX_Case_Study_032022.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/yurufuwa.webp',
        title: 'Yurufuwa',
        description: 'Learn how we helped launch and scale KYOTOMA Inc.\'s Yurufuwa, reaching CPI 25% cheaper than the target while boosting organic install volume x40.',
        results: {
            first: {
                percents: '25%',
                description: 'below CPI Goal'
            },
            second: {
                percents: '4100%',
                description: 'organic volume increase'
            }
        },
        readMore: 'https://persona.ly/blog/2022/02/how-we-helped-launch-and-scale-kyotoma-inc-s-yurufuwa-while-boosting-organic-install-volume-x40/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/Persona.ly_Yurufuwa_0222_English.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/wondersquad.webp',
        title: '33RD: Random Defense',
        description: 'Learn how we beat other paid and organic in retention and exceeded the D7 KPI by 40%, as well as reaching 45% D7 ROAS within several weeks of learning.',
        results: {
            first: {
                percents: '40%',
                description: 'D7 Retetion above KPI'
            },
            second: {
                percents: '97%',
                description: 'higher D7 retention than others'
            }
        },
        readMore: 'https://persona.ly/blog/2022/01/how-we-reached-45-d7-roas-for-33rd-random-defense/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/33RD%20CS_150P_EN.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/fish_idle.webp',
        title: 'Fish Idle',
        description: 'Learn how we were able to reach D7 retention 5x higher than organic and beat ROAS goals several weeks for Fish Idle in the US by targeting look-a-like audiences generated based around the combination of both fishing and idle mechanics.',
        results: {
            first: {
                percents: '37%',
                description: 'lifetime ROAS Lift (week 4)'
            },
            second: {
                percents: '500%',
                description: 'higher D7 retention'
            }
        },
        readMore: 'https://persona.ly/blog/2021/07/persona-lys-achieves-d7-retention-5x-higher-than-organic-for-mamboo-games-fish-idle/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_mamboo_case_study_editable_en_1a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/solitaire.webp',
        title: 'Solitaire Cash',
        description: 'Learn how we beat the ROAS KPI as well as the organic conversion towards purchases by targeting luser’s whose behavior indicated they are losing interest in a similar alternative app, allowing us to show them an ad for Solitaire Cash, a better alternative with more content and active users.',
        results: {
            first: {
                percents: '90%',
                description: 'D7 ROAS lift (week 4)'
            },
            second: {
                percents: '130%',
                description: 'higher FTD CVR (week 4)'
            }
        },
        readMore: 'https://persona.ly/blog/2021/06/persona-lys-exceeds-papaya-gamings-roas-kpis-by-90/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_solitaire_cash_case_study_digital_en_1a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/coindcx.webp',
        title: 'CoinDCX Go',
        description: 'Read how we beat CPA and engagement KPIs by targeting lookalike audiences that showed interest in crypto or trading in general and gradually modeling towards each step in their extremely effective onboarding funnel.',
        results: {
            first: {
                percents: '20%',
                description: 'lower CPA',
                isArrowDown: true
            },
            second: {
                percents: '18%',
                description: 'higher signup rate'
            }
        },
        readMore: 'https://persona.ly/blog/2021/05/persona-lys-programmatic-bidder-exceeds-coindcx-kpis/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_coindcx_case_study_digital_en_3a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/ubisoft.webp',
        title: 'Ubisoft\'s Howrse',
        description: 'By modeling towards in-game progression events we\'ve managed to outperfom paid social campaigns and bring in more installs, higher retention, higher ROAS, and do so for a lower eCPI.',
        results: {
            first: {
                percents: '55%',
                description: 'more installs'
            },
            second: {
                percents: '200%',
                description: 'higher D7 retention'
            }
        },
        readMore: 'https://persona.ly/blog/2021/03/persona-ly-outperforms-paid-social-ua-for-ubisofts-howrse/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_ubisoft_howrse_case_study_digital_en_1a_upload.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/winjoy.webp',
        title: 'Zempot\'s WinJoy Poker',
        description: 'We integrated with Singular and received unattributed data which expedited our models\' learning curve and powered look-a-like audience generation. Over time, we were able to improve our prediction models and target the most engaged users, out of the payer population.',
        results: {
            first: {
                percents: '40%',
                description: 'D7 ROAS lift (month 1)'
            },
            second: {
                percents: '65%',
                description: 'D7 ROAS lift  (month 2)'
            }
        },
        readMore: 'https://persona.ly/blog/2021/02/case-study-zempots-winjoy-poker-ua-campaign-beats-roas-kpis/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_winjoy_poker_case_study_editable_en_1a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/boxingstar.webp',
        title: '4:33\'s Boxing Star',
        description: 'By combining our intent-based targeting with time-related dimensions, we were able to reach valuable users, who are likely to make a purchase, at the most oprrotune time to convert them. We then implemented cross-learning techinques to expetied the process in our campaign in Korea',
        results: {
            first: {
                percents: '142%',
                description: 'D7 ROAS lift (US)'
            },
            second: {
                percents: '130%',
                description: 'D7 ROAS lift (KR)'
            }
        },
        readMore: 'https://persona.ly/blog/2021/02/how-we-exceeded-433-kpi-goals-for-their-leading-title-boxing-star/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_433_case_study_digital_en_1c.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/kingsthrone.webp',
        title: 'GOAT Games\' King\'s Throne',
        description: 'Combining intent-based targeting with engaged video and playable ads we were able to increase the install-to-purchase % for GOAT Games\' "King\'s Throne: Game of Lust"',
        results: {
            first: {
                percents: '144%',
                description: 'FTD CVR (Week 1)'
            },
            second: {
                percents: '209%',
                description: 'FTD CVR (Week 5)'
            }
        },
        readMore: 'https://persona.ly/blog/2020/11/case-study-goat-games-kings-throne/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_goatgames_case_study_digital_en_2a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/lastdayonearth.webp',
        title: 'Kefir\'s Last Day on Earth',
        description: 'We integreted with Apssflyer\'s Audience feature and used their pre-defined segmentations to exptide our exploration. It allowed us to quickly beat both CPA and ROAS KPIs.',
        results: {
            first: {
                percents: '50%',
                description: 'Below CPA goal',
                isArrowDown: true
            },
            second: {
                percents: '250%',
                description: 'Above ROAS goal'
            }
        },
        readMore: 'https://persona.ly/blog/2020/09/kefirs-last-day-on-earth-retargeting-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_kefirgames_case_study_digital_en_2a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/catgame.webp',
        title: 'Tilting Point\'s Cat Game',
        description: 'Running a LAT campaign for Tilting Point\'s "Cat Game", we used contextual targeting to reach users who showed interest in similar genres and delivered higher RR and 4x higher insall-to-purchase than organic traffic',
        results: {
            first: {
                percents: '20%',
                description: 'higher D3 RR'
            },
            second: {
                percents: '4x',
                description: 'higher FTD CVR'
            }
        },
        readMore: 'https://persona.ly/blog/2020/09/tilting-point-runs-contextually-driven-lat-ua-campaigns-with-persona-ly-ftds-increase/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_tiltingpoint_case_study_editable_en_1f.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/animoca.webp',
        title: 'Animoca\'s Crazy Defense Heroes',
        description: 'Using our proprietery machine-learning models, we were able to target the most engaged users, leading to our campaigns exceeding Animoca Brand\'s ROAS KPIs.',
        results: {
            first: {
                percents: '34%',
                description: 'D1 ROAS KPI'
            },
            second: {
                percents: '70%',
                description: 'D7 ROAS KPI'
            }
        },
        readMore: 'https://persona.ly/blog/2020/08/animoca-brands-crazy-defense-heroes-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_animoca_case_study_digital_en_1b.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/gamepoint.webp',
        title: 'GamePoint Bingo',
        description: 'By using our intent-based targeting and incorporating our proprietary age and gender prediction algorithms we were able to lower "GamePoint Bingo" eCPI costs and improve their ROAS over time.',
        results: {
            first: {
                percents: '23%',
                description: 'lower eCPI',
                isArrowDown: true
            }
        },
        readMore: 'https://persona.ly/blog/2020/06/gamepoint-bingo-programmatic-ua-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_gamepoint_case_study_digital_en_1b.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/ulu.webp',
        title: 'U.LU Games\' Reach Rich',
        description: 'Using ML-based algorithms, we were able not only to improve D1 retention, but also exceed U.LU Games\' ROAS KPIs for their leading title "Reach Rich"',
        results: {
            first: {
                percents: '107%',
                description: 'D30 ROAS lift'
            },
            second: {
                percents: '15%',
                description: 'D7 RR lift'
            }
        },
        readMore: 'https://persona.ly/blog/2020/04/u-lu-games-reach-rich-%eb%a6%ac%ec%b9%98%eb%a6%ac%ec%b9%98-programmatic-ua-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_ulu_case_study_digital_en_1b.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/bingo.webp',
        title: 'Clipwire Games’ Bingo Story™',
        description: 'Using intent-based targeting, we\'ve reached ROAS lifts for Clipwire Games’ leading title “Bingo Story™”',
        results: {
            first: {
                percents: '11%',
                description: 'D1 ROAS Lift'
            },
            second: {
                percents: '14.7%',
                description: 'D7 ROAS Lift'
            }
        },
        readMore: 'https://persona.ly/blog/2019/12/clipwire-games-bingo-story-programmatic-ua-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_clipwire_case_study_print_1a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/bubble.webp',
        title: 'Ilyon’s Bubble Shooter™',
        description: 'By deploying our install probability feature, we were able to target engaged users and reach Ilyon\'s retention KPIs for their leading title "Bubble Shooter™"',
        results: {
            first: {
                percents: '18%',
                description: 'D1 RR Increase'
            },
            second: {
                percents: '32%',
                description: 'D7 RR Increase'
            }
        },
        readMore: 'https://persona.ly/blog/2019/09/ilyons-bubble-shooter-programmatic-ua-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/marketing/ply_ilyon_case_study_digital_3c.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/51.webp',
        title: 'Device Data Enrichment for UA',
        description: 'By adding 51Degrees’ Device Detection to their algorithms, some interesting device traits and fraud indicators were uncovered which were used to increase overall performance by 15%.',
        readMore: 'https://persona.ly/blog/2019/03/51degrees-device-detection-boosts-persona-lys-performance-by-15/'
    }
];
var CaseStudies = function () {
    // scrolling into view after all images loaded
    // required because some of safari versions don't handle hash links in right way
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (location.hash !== '#case-studies') {
            return;
        }
        var images = Array.from(document.querySelectorAll('img'));
        var imageReadyPromises = images.map(function (image) { return new Promise(function (resolve) {
            if (image.complete) {
                resolve(image);
            }
            image.addEventListener('load', function () {
                var interval = setInterval(function () {
                    if (image.naturalWidth > 0 && image.naturalHeight > 0) {
                        clearInterval(interval);
                        resolve(image);
                    }
                }, 20);
            });
            image.addEventListener('error', function () {
                resolve(image);
            });
        }); });
        Promise.all(imageReadyPromises).then(function () {
            var _a;
            var caseStudiesAnchor = document.body.querySelector('#case-studies');
            (_a = caseStudiesAnchor) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        });
    }, []);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('rtb'), t = _a.t, i18n = _a.i18n;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), cases = _b[0], setCases = _b[1];
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setCases(allCases);
            return [2 /*return*/];
        });
    }); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        loadData();
    }, [i18n.language]);
    var handleOnDragStart = function (e) { return e.preventDefault(); };
    var addLineBreak = function (text) {
        if (!text.includes('('))
            return text;
        var bracketIndex = text.indexOf('(');
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            text.slice(0, bracketIndex),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            text.slice(bracketIndex));
    };
    var renderCase = function (item) {
        var _a, _b;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: item.id, className: "case-item-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onDragStart: handleOnDragStart, className: "case-item" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "carousel-inline-img case-image", style: { backgroundImage: 'url(' + item.image + ')' }, href: item.readMore, target: "_blank", rel: "noopener noreferrer" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "case-content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "user-name" }, item.title),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "case-descr" }, item.description),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "case-bottom-block" },
                        item.results &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "case-b-results" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "case-b-t" }, "Results"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "case-b-n aqua-text" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/rtb/arrow-right-" + (item.results.first.isArrowDown ? 'down' : 'up') + "-line.svg" }),
                                                item.results.first.percents),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "case-b-n aqua-text" },
                                                item.results.second &&
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/rtb/arrow-right-" + (item.results.second.isArrowDown ? 'down' : 'up') + "-line.svg" }), (_a = item.results.second) === null || _a === void 0 ? void 0 :
                                                _a.percents)),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "case-b-d" }, addLineBreak(item.results.first.description)),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "case-b-d" }, addLineBreak(((_b = item.results.second) === null || _b === void 0 ? void 0 : _b.description) || '')))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: item.readMore, target: "_blank", rel: "noopener noreferrer" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-review" }, "Read More")),
                            item.download &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: item.download, target: "_blank", rel: "noopener noreferrer" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "button-review button-aqua button-download" }, "Download"))))))));
    };
    var renderCaseList = function () {
        return cases
            .map(function (review) { return renderCase(review); });
    };
    var memoizedList = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](renderCaseList, [cases]);
    var carousel = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0), currentSlide = _c[0], setCurrentSlide = _c[1];
    var handlePrevPageChange = function () {
        var _a, _b;
        var nextSlide = currentSlide - (currentSlide % 3 || 3);
        if (nextSlide < 0) {
            nextSlide = cases.length - (cases.length % 3 || 3);
        }
        (_b = (_a = carousel) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.slideTo(nextSlide);
    };
    var handleNextPageChange = function () {
        var _a, _b;
        var nextSlide = currentSlide - currentSlide % 3 + 3;
        if (nextSlide >= cases.length) {
            nextSlide = 0;
        }
        (_b = (_a = carousel) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.slideTo(nextSlide);
    };
    var responsiveSettings = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () { return ({
        0: {
            items: 1,
        },
        1105: {
            items: 3
        }
    }); }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "case-studies" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { id: "case-studies", className: "case-studies-anchor" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "muli" }, Object(__WEBPACK_IMPORTED_MODULE_5__util_util__["t" /* tagger */])(t('Our case studies'), 'aqua-text')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cases carousel-inline" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: 'prev not-mobile not-tablet prev-h', src: "https://static.persona.ly/images/partners/path-2-copy-2.svg", onClick: handlePrevPageChange }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_alice_carousel___default.a, { mouseTrackingEnabled: true, buttonsDisabled: true, onSlideChanged: function (e) { return setCurrentSlide(e.item); }, items: memoizedList, ref: carousel, responsive: responsiveSettings, infinite: false }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: 'next not-mobile not-tablet next-h', src: "https://static.persona.ly/images/partners/path-2-copy-2.svg", onClick: handleNextPageChange })))));
};
/* harmony default export */ __webpack_exports__["a"] = (CaseStudies);


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_landing_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_landing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_landing_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_monetization_css__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_monetization_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_monetization_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__(2);






var Security = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('security'), t = _a.t, i18n = _a.i18n;
    var activator = function (e) { return e.currentTarget.parentElement.lastChild.classList.toggle('active'); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container privacy" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Personaly Information Security'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, "[Last Updated: 8 May, 2018]"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('is fully committed to provide'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('This information security policy'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, t('technical and organizational safeguards')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion", style: { marginTop: '2rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Physical Access Control')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" },
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Personaly ensures the protection'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://aws.amazon.com/security/" }, "https://aws.amazon.com/security/"),
                    "."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" },
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Furthermore, some of the'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https:/www.digitalocean.com/security/" }, "https:/www.digitalocean.com/security/"),
                    "."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Further, Persona.ly secures'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('System Access Control')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The access to Persona'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The systems are protected'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Data Access Control')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Personaly restricts the access'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The user password'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('In addition, all of the'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Further Personaly is'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Organizational and Operational Security')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Personaly is investing'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Transfer Control')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The Company does not transfer'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Data Retention')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Personal Data and raw')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Job Control')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('All of Personaly employees'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('In the event of a breach'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('Furthermore the destruction')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Availability Control')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('The Company has a backup'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('Updates')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('This Information Security Policy'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */]))))));
};
/* harmony default export */ __webpack_exports__["a"] = (Security);


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_gdpr_css__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_gdpr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_gdpr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__(2);





var TermsUse = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('termsUse'), t = _a.t, i18n = _a.i18n;
    var activator = function (e) { return e.currentTarget.parentElement.lastChild.classList.toggle('active'); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli text-center" }, t('terms of use')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('binding effect')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('this is a b')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('you agree that')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('virtual currency')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('the virtual curr')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('grant of license')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('you are granted')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('privacy policy')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('personaly respects'), '', '/privacy_policy')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('fees')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('some products')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('your right to')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('it is your r')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('alleged violations')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('company reserves the')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('no warranties')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('company hereby d')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('limitation of liability')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('each and every')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('the liability and')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('personaly does n')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('the user hereby r')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('however it is h')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('affiliated sites')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('company has no')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('prohibited uses')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('company imposes c')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('indemnity')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('you agree to i')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('copyright')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('all contents of')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('severability waiver')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('if for whatever reason')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('no license')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('nothing contained o')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('modifications')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('company may in i')))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-button", onClick: activator },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text" }, t('acknowledgements')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/dropdown-arrow.svg" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "accordion-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "text" }, t('by using the service'))))));
};
/* harmony default export */ __webpack_exports__["a"] = (TermsUse);


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_platform_css__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_platform_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_platform_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__(2);





var Welcome = function (props) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isBack = _a[0], setIsBack = _a[1];
    var tC = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('common').t;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('welcome'), t = _b.t, i18n = _b.i18n;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setIsBack(props.location.pathname.includes('/welcomeBack'));
        Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["r" /* setTitleFont */])(i18n.language);
    }, []);
    var platformBlocks = [
        {
            show: true,
            title: t('Im a Developer'),
            text: t('Use our SDK/API'),
            button: tC('Integrate Now'),
            image: 'https://static.persona.ly/images/platform/rtb-icon-01.svg',
            termsText: t('By clicking the Integrate Now'),
            policyText: t('and SDK Privacy Policy'),
            policyLink: 'privacy_sdk',
            welcomeUrl: 'https://sdk.persona.ly/cms/api/user/signUp/sdk/',
            finishUrl: 'https://sdk.persona.ly/cms/api/user/urlPart/sdk/'
        },
        {
            show: !isBack,
            title: t('Im an Advertiser'),
            text: t('Grow your audience'),
            button: tC('Contact Us'),
            image: 'https://static.persona.ly/images/platform/ch-01.svg',
            termsText: t('By clicking the Contact Us'),
            policyText: t('and Privacy Policy'),
            policyLink: 'privacy_policy',
            welcomeUrl: 'getInTouch?id=',
            finishUrl: undefined
        },
        {
            show: true,
            title: t('Im a Publisher'),
            text: t('Gain access to'),
            button: tC('Start Now'),
            image: 'https://static.persona.ly/images/platform/group-15.svg',
            termsText: t('By clicking the Start Now'),
            policyText: t('and DSP Privacy Policy'),
            policyLink: 'privacy_dsp',
            welcomeUrl: 'https://sdk.persona.ly/cms/api/user/signUp/dsp/',
            finishUrl: 'https://sdk.persona.ly/cms/api/user/urlPart/dsp/'
        },
        {
            show: !isBack,
            title: t('Im a Website Owner'),
            text: t('Implement our offer wall'),
            button: tC('Integrate Now'),
            image: 'https://static.persona.ly/images/platform/group-16.svg',
            termsText: t('By clicking the Integrate Now'),
            policyText: t('and SDK Privacy Policy'),
            policyLink: 'privacy_sdk',
            welcomeUrl: 'https://sdk.persona.ly/cms/api/user/signUp/sdk/',
            finishUrl: undefined
        }
    ];
    var signUpRedirect = function (block) {
        var search = props.location.search;
        var params = new URLSearchParams(search);
        if (isBack) {
            var token = params.get('token');
            var type = params.get('type');
            if (token && type) {
                var urlPart = void 0;
                switch (type) {
                    case 'signin':
                        urlPart = 'signInFinish';
                        break;
                    case 'forgot':
                        urlPart = 'forgotPasswordFinish';
                        break;
                }
                window.location.href = block.finishUrl.replace('urlPart', urlPart) + token;
            }
        }
        else {
            var userId = params.get('id');
            if (userId) {
                window.location.href = block.welcomeUrl + userId;
            }
        }
    };
    var renderPlatformBlock = function (block, i) { return block.show && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: i, className: "platform-block" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "platform-image" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "platform-image", src: block.image })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(block.title, 'accent-text')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(block.text, 'accent-text')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { onClick: function () { return signUpRedirect(block); }, className: "button-blue large button" },
            block.button,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "platform-policy" },
            Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(block.termsText, __WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* ACCENT_TEXT_FW500 */], 'terms_use'),
            " ",
            Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(block.policyText, __WEBPACK_IMPORTED_MODULE_3__util_util__["b" /* ACCENT_TEXT_FW500 */], block.policyLink)))); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "common-pages-container", style: { padding: '14% 0 0 0', textAlign: 'center' } },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "title muli" }, isBack ? t('welcome back') : Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["t" /* tagger */])(t('welcome to'), 'accent-text')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text" }, t(isBack ? 'to start please 2' : 'to start please 1')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "platform-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "platform-container" }, platformBlocks.slice(0, 2).map(renderPlatformBlock)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "platform-container" }, platformBlocks.slice(2, 4).map(renderPlatformBlock)))));
};
/* harmony default export */ __webpack_exports__["a"] = (Welcome);


/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hooks_useDebounce__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_clusterCarousel__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_appsTable__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dotLoader__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_hiveLoader__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_contactModal__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_contextDistanceCalculator_css__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_contextDistanceCalculator_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__css_contextDistanceCalculator_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app__ = __webpack_require__(7);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};















var WordVectors = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 237)); });
var defaultTop20Data = [
    { 'name': 'Billion Cash Slots-Casino Game', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/86/2d/87/862d87f8-aeed-75c9-9d03-130d33f0077a/source/512x512bb.jpg', 'category': 'Casual', 'averageUserRating': 4.84503, 'confidence': 1, 'isDefault': true },
    { 'name': 'Eon Slots Casino Vegas Game', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple113/v4/d5/09/de/d509de61-e28c-20c2-1367-bb3f10049dbc/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.58436, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Cash Tornado Slots - Casino', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/bd/78/16/bd7816ac-2a36-06ce-76bb-9dfa6876d4aa/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.90338, 'confidence': 0.5, 'isDefault': true },
    { 'name': 'Super Vegas Slots Casino Games', 'iconUrl': 'https://is5-ssl.mzstatic.com/image/thumb/Purple114/v4/c3/c7/83/c3c7831b-5c6a-9460-ee79-41c327ffffcc/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.67804, 'confidence': 0.44, 'isDefault': true },
    { 'name': 'Vegas Nights Slots', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/7f/9a/07/7f9a0791-40e8-56a2-cafc-85fb9553849c/source/512x512bb.jpg', 'category': 'Card', 'averageUserRating': 4.70319, 'confidence': 0.4, 'isDefault': true },
    { 'name': 'Tycoon Casino - Vegas Slots', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple114/v4/7e/34/06/7e34063e-89fb-fc8b-403c-5f65dae4baa9/source/512x512bb.jpg', 'category': 'Card', 'averageUserRating': 4.82416, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Winning Slots Las Vegas Casino', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/bf/e6/47/bfe64725-9c5a-3ba3-32fd-5d5dcd09e3f5/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.65444, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Cash Frenzy - Slots Casino', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/22/e8/0d/22e80df6-d861-9351-251a-d44f54766fc6/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.70422, 'confidence': 0.6, 'isDefault': true },
    { 'name': 'Vegas Slots - 7Heart Casino', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/e0/42/10/e0421050-83ec-0f32-2fe5-307cced54abe/source/512x512bb.jpg', 'category': 'Card', 'averageUserRating': 4.86918, 'confidence': 0.1, 'isDefault': true },
    { 'name': 'Slots Casino - Vegas Slot Machine Games', 'iconUrl': 'https://is3-ssl.mzstatic.com/image/thumb/Purple111/v4/e1/4b/cf/e14bcf59-f889-a44d-1ba8-2c9ef0887f08/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.71264, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Epic Vegas Slots - Casino Game', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/10/e2/5c/10e25c37-c478-4e20-5e63-56bf95571d93/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.85238, 'confidence': 0.4, 'isDefault': true },
    { 'name': 'Slots of Vegas', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/e8/53/68/e85368c4-66db-0dd6-a3d1-7f55a8af8bc3/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.77894, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Slots: Vegas Casino Slot Games', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/fc/6b/a8/fc6ba843-b9f9-8e03-7590-5f36d5723523/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.73383, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Vegas Casino & Slots: Slottist', 'iconUrl': 'https://is3-ssl.mzstatic.com/image/thumb/Purple124/v4/e4/89/e7/e489e76d-fcc3-f35c-55d7-62adb9bccbee/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.3375, 'confidence': 0.88, 'isDefault': true },
    { 'name': 'LuckyBomb Casino Slots', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/a4/48/e7/a448e796-c502-efce-48f8-6ce518079d95/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.03488, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Slots Mega Win Casino Game', 'iconUrl': 'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/b8/ce/17/b8ce17ae-f120-f6c4-0627-6d2e88904c21/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.42544, 'confidence': 0.75, 'isDefault': true },
    { 'name': 'High 5 Casino: Home of Slots', 'iconUrl': 'https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/5c/44/4a/5c444a8d-fdb7-2a76-f856-3ce9cfd2725a/source/512x512bb.jpg', 'category': 'Card', 'averageUserRating': 4.62333, 'confidence': 0.9, 'isDefault': true },
    { 'name': 'Winner Slots Casino Games', 'iconUrl': 'https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/0c/0d/66/0c0d66fa-3c9f-91e5-7272-684c145b1c58/source/512x512bb.jpg', 'category': 'Casino', 'averageUserRating': 4.60511, 'confidence': 0.2, 'isDefault': true },
    { 'name': 'Cash Tap Casino: Slot Machines', 'iconUrl': 'https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/ef/f0/47/eff04747-b777-2073-f637-c1fb0d8da877/source/512x512bb.jpg', 'category': 'Entertainment', 'averageUserRating': 4.62446, 'confidence': 0.9, 'isDefault': true }
];
var ContextDistanceCalculator = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), searchQuery = _a[0], setSearchQuery = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), errorsSearchQuery = _b[0], setErrorsSearchQuery = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isSearching = _c[0], setIsSearching = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0), nextSearchNumber = _d[0], setNextSearchNumber = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isCalculating = _e[0], setIsCalculating = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isListReady = _f[0], setIsListReady = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), showModal = _g[0], setShowModal = _g[1];
    var _h = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), appNotFound = _h[0], setAppNotFound = _h[1];
    var _j = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), firstCalcDone = _j[0], setFirstCalcDone = _j[1];
    var _k = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}), app = _k[0], setApp = _k[1];
    var _l = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), fakeData = _l[0], setFakeData = _l[1];
    var _m = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('contextDistanceCalculator'), t = _m.t, i18n = _m.i18n;
    var tCommon = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('common').t;
    var location = Object(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["b" /* useLocation */])();
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["r" /* setTitleFont */])(i18n.language);
        setFakeData(defaultTop20Data);
        var bundle = new URLSearchParams(location.search).get('bundle');
        if (bundle)
            setSearchQuery(bundle);
    }, []);
    var scrollToApps = function () { return Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["m" /* goToElementId */])('apps', true); };
    var scrollToMethodology = function () { return Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["m" /* goToElementId */])('word2vec', true); };
    var scrollToTop = function () { return Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["m" /* goToElementId */])('context-distance-calculator', true); };
    var updateErrors = function (err) {
        setErrorsSearchQuery(err);
    };
    var utmParameters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_13__app__["a" /* AppContext */]).utmParameters;
    var getCalculatorSearchParams = function () {
        var result = {};
        if (utmParameters.utm_campaign) {
            result.utmCampaign = utmParameters.utm_campaign;
        }
        if (utmParameters.utm_source) {
            result.utmSource = utmParameters.utm_source;
        }
        if (utmParameters.utm_medium) {
            result.utmMedium = utmParameters.utm_medium;
        }
        if (utmParameters.url) {
            result.url = utmParameters.url;
        }
        return result;
    };
    var startCalculating = function () { return __awaiter(void 0, void 0, void 0, function () {
        var top20AppsList, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsListReady(false);
                    if (!searchQuery) {
                        updateErrors([tCommon('required field')]);
                    }
                    if (!app.name || appNotFound) {
                        return [2 /*return*/];
                    }
                    scrollToApps();
                    setIsCalculating(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__api_api__["a" /* api */].runCalculating(searchQuery, getCalculatorSearchParams())];
                case 2:
                    top20AppsList = _a.sent();
                    if (!top20AppsList.length) {
                        setIsCalculating(false);
                        return [2 /*return*/];
                    }
                    setFakeData(top20AppsList);
                    setFirstCalcDone(true);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setAppNotFound(true);
                    return [3 /*break*/, 4];
                case 4:
                    setIsCalculating(false);
                    setIsListReady(true);
                    return [2 /*return*/];
            }
        });
    }); };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (firstCalcDone)
            return;
        var bundle = new URLSearchParams(location.search).get('bundle');
        if (bundle === searchQuery)
            startCalculating();
    }, [app]);
    // used in search() to get last state of nextSearchNumber
    // search() can't get last state by itself because of closure
    var getNextSearchNumber = function () {
        var currentNextSearchNumber;
        setNextSearchNumber(function (a) {
            currentNextSearchNumber = a;
            return a;
        });
        return currentNextSearchNumber;
    };
    var search = function () { return __awaiter(void 0, void 0, void 0, function () {
        var thisSearchNumber, foundApp, nextSearchNumber_1, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    thisSearchNumber = nextSearchNumber;
                    setNextSearchNumber(thisSearchNumber + 1);
                    setAppNotFound(false);
                    updateErrors([]);
                    setIsSearching(true);
                    setApp({});
                    if (!searchQuery) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_10__api_api__["a" /* api */].appStoreApp(searchQuery, getCalculatorSearchParams())
                        // searches are asynchronous, so they can run in parallel
                        // we check that it is the last search to set last searched app
                    ];
                case 2:
                    foundApp = _a.sent();
                    nextSearchNumber_1 = getNextSearchNumber();
                    if (thisSearchNumber < nextSearchNumber_1 - 1) {
                        return [2 /*return*/];
                    }
                    if (foundApp && foundApp.name) {
                        setApp(foundApp);
                    }
                    else {
                        setAppNotFound(true);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    setAppNotFound(true);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    updateErrors([tCommon('required field')]);
                    _a.label = 6;
                case 6:
                    setIsSearching(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var debouncedSearchQuery = Object(__WEBPACK_IMPORTED_MODULE_1__hooks_useDebounce__["a" /* useDebounce */])(searchQuery, 500);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (debouncedSearchQuery)
            search();
    }, [debouncedSearchQuery]);
    var toggleModal = function () { return setShowModal(!showModal); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "context-distance-calculator", id: "context-distance-calculator" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_contactModal__["a" /* ContactModal */], { show: showModal, toggle: toggleModal }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_helmet__["a" /* Helmet */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Context Distance Calculator"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "title", content: "" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "keywords", content: "" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { property: "og:image", content: "https://static.persona.ly/images/context_distance_calculator/open-graph.webp" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "context-distance-calculator__content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "title muli" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Context Calculator'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "context-distance-calculator-header" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "context-distance-calculator-header__description" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('With the upcoming'), __WEBPACK_IMPORTED_MODULE_4__util_util__["c" /* ACCENT_TEXT_FW700 */], 'https://persona.ly/glossary/attribution/user-acquisition-and-retargeting-in-ios-14')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('To gain information'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('To highlight'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */]))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "context-distance-calculator-header__search-box" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "context-distance-calculator__section-title" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Find Contextually'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { value: searchQuery, className: 'contact-input small-text' + (errorsSearchQuery.length > 0 ? ' error-input' : ''), type: "text", name: "searchQuery", placeholder: t('Enter a bundle'), onChange: function (e) { return setSearchQuery(e.currentTarget.value); }, onKeyPress: function (e) { return Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["o" /* isEnter */])(e) && search(); } })),
                    errorsSearchQuery && errorsSearchQuery.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "context-distance-calculator-header__app" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "context-distance-calculator-header__app-image-placeholder" }, isSearching ?
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_dotLoader__["a" /* DotLoader */], null) :
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: app.iconUrl ? 'app-image' : '', src: app.iconUrl || 'https://static.persona.ly/images/context_distance_calculator/app-store-line.svg' })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "context-distance-calculator-header__app-info" }, !appNotFound ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "context-distance-calculator-header__app-main-text context-distance-calculator-header__app-name" }, app.name || t('App name')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "context-distance-calculator-header__app-category" }, app.categories && app.categories.slice(0, 3).join(', ') || t('Category')))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "context-distance-calculator-header__app-main-text context-distance-calculator-header__app-not-found" }, t('Enter Valid ID'))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { onClick: function () { return startCalculating(); }, className: "button-blue large" }, t('Calculate')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { id: "apps", className: "apps-list" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "context-distance-calculator__section-title" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Top apps'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-list__content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-list__tables apps-list__tables--gradient " + (isListReady ? '' : 'apps-list__tables--blur') },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-list__table apps-list__table--left" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_appsTable__["a" /* AppsTable */], { addToIndex: 1, data: fakeData.slice(0, 10) })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-list__table apps-list__table--right" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_appsTable__["a" /* AppsTable */], { addToIndex: 11, data: fakeData.slice(10, 20) }))),
                    isCalculating ?
                        (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "results-box--loading results-box" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_hiveLoader__["a" /* HiveLoader */], null),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "results-box__header" }, t('Calculating Cosine'))))) :
                        ((isListReady && !appNotFound) || firstCalcDone ?
                            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "results-box results-box--cta" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "results-box__header" }, t('Ready to start?')),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "results-box__text" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Run effective'), __WEBPACK_IMPORTED_MODULE_4__util_util__["b" /* ACCENT_TEXT_FW500 */])),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "results-box__buttons" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { onClick: scrollToMethodology, className: "button-grey large" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Our methodology'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { onClick: toggleModal, className: "button-blue large" },
                                            tCommon('Start Now'),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" })))))) :
                            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "results-box" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "results-box__header" }, appNotFound ? Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('No App Found Title'), 'no-wrap') : t('Bundle results')),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "results-box__text" }, appNotFound ? t('No App Found Description') : t('Enter a bundle id and calculate')))))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "word2vec", id: "word2vec" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "word2vec__description" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Why Word2Vec'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('When engineered'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Notions rendered'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Considering the production'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('After the Word2Vec'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */]))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "word2vec__clusters" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "word2vec__clusters-description" }, t('An example of')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_clusterCarousel__["a" /* ClusterCarousel */], null))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "vectors" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WordVectors, null)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "vectors__description" }, t('A depiction of'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { id: "representation", className: "representation" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Bundle vector'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('After generating'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('This step'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('After extensive testing'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Eventually our bundle'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */]))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { id: "ready-to-start", className: "ready-to-start" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "footer-t muli" }, t('Ready to start?')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "footer-d" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Run effective'), __WEBPACK_IMPORTED_MODULE_4__util_util__["c" /* ACCENT_TEXT_FW700 */])),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "results-box__buttons" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { onClick: scrollToTop, className: "button-grey large" }, Object(__WEBPACK_IMPORTED_MODULE_4__util_util__["t" /* tagger */])(t('Calculate context'), __WEBPACK_IMPORTED_MODULE_4__util_util__["a" /* ACCENT_TEXT */])),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { onClick: toggleModal, className: "button-blue large" },
                        tCommon('Start Now'),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: "https://static.persona.ly/images/arrow.svg" })))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ContextDistanceCalculator);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDebounce; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useDebounce = function (value, delay) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        return function () {
            clearTimeout(handler);
        };
    }, [value]);
    return debouncedValue;
};


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClusterCarousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_clusterCarousel_css__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_clusterCarousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_clusterCarousel_css__);



var Clusters = __WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function () { return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 236)); });
var ClusterCarousel = function () {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1), selectedOption = _a[0], setSelectedOption = _a[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var interval = setInterval(function () {
            setSelectedOption(selectedOption === 3 ? 1 : selectedOption + 1);
        }, 4000);
        return function () { return clearInterval(interval); };
    }, [selectedOption]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cluster-carousel" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"], { fallback: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Clusters, { clusterNumber: selectedOption })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cluster-carousel__options" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onClick: function () { return setSelectedOption(1); }, className: "cluster-carousel__option cluster-carousel__option-1 " + (selectedOption !== 1 ? 'cluster-carousel__option--disabled' : '') },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Cluster 1")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onClick: function () { return setSelectedOption(2); }, className: "cluster-carousel__option cluster-carousel__option-2 " + (selectedOption !== 2 ? 'cluster-carousel__option--disabled' : '') },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Cluster 2")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onClick: function () { return setSelectedOption(3); }, className: "cluster-carousel__option cluster-carousel__option-3 " + (selectedOption !== 3 ? 'cluster-carousel__option--disabled' : '') },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Cluster 3")))));
};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppsTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_appsTable_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_appsTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_appsTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_appsTableConfidence_css__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_appsTableConfidence_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_appsTableConfidence_css__);




var createdKeyframes = {};
var AppsTable = function (props) {
    var t = Object(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* useTranslation */])('appsTable').t;
    function getStatusMessage(percents) {
        if (percents <= 35)
            return t('Low Confidence');
        if (percents <= 60)
            return t('Moderate Confidence');
        if (percents <= 80)
            return t('Moderate-High Confidence');
        return t('High Confidence');
    }
    function createKeyframes(animationName, confidencePercents) {
        if (createdKeyframes[confidencePercents])
            return;
        var filledBarKeyframes = "@keyframes " + animationName + " {\n            from {width: 0%}\n            to {width: " + (confidencePercents + '%') + "}\n          }";
        var style = document.createElement('style');
        style.innerHTML = filledBarKeyframes;
        document.head.appendChild(style);
        createdKeyframes[confidencePercents] = true;
    }
    var renderConfidence = function (confidence, isDefault) {
        var confidencePercents = Math.floor(confidence * 100);
        var filledDotsCount = Math.floor(confidencePercents / 25) + 1;
        var animationName = "filled-bar-" + confidencePercents;
        createKeyframes(animationName, confidencePercents);
        var filledBarStyles = {
            animationName: animationName,
            animationTimingFunction: 'linear',
            animationDuration: isDefault ? '0s' : confidence + 's',
            animationDelay: '0.0s',
            animationIterationCount: 1,
            animationFillMode: 'forwards'
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table-confidence__progressbar" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table-confidence__bar" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table-confidence__filled-bar", style: filledBarStyles }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "apps-table-confidence__dot " + (filledDotsCount >= 1 ? 'apps-table-confidence__dot_filled' : '') }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "apps-table-confidence__dot " + (filledDotsCount >= 2 ? 'apps-table-confidence__dot_filled' : '') }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "apps-table-confidence__dot " + (filledDotsCount >= 3 ? 'apps-table-confidence__dot_filled' : '') }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "apps-table-confidence__dot " + (filledDotsCount >= 4 ? 'apps-table-confidence__dot_filled' : '') }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "apps-table-confidence__dot " + (filledDotsCount >= 5 ? 'apps-table-confidence__dot_filled' : '') })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "apps-table-confidence__percents" },
                confidencePercents,
                "%"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "apps-table-confidence__info-hover" }, "i"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table-confidence__info-box" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table-conficence__triangle" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "apps-table-confidence__info-title" }, t('Confidence Level')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "apps-table-confidence__info-status" },
                    confidencePercents,
                    "% - ",
                    getStatusMessage(confidencePercents)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "apps-table-confidence__info-paragraph" }, t('As context')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, t('Confidence is effected')))));
    };
    var renderApps = function (isMobile) {
        if (isMobile === void 0) { isMobile = false; }
        return props.data.map(function (app, index) {
            var appNumber = index + (props.addToIndex ? props.addToIndex : 1);
            return isMobile ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table__item", key: 'app-' + appNumber + app.iconUrl },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table__item-number" }, appNumber + '.'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table__item-main" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table__item-main-content" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: app.iconUrl }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "apps-table__title" }, app.name)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table__item-other apps-table-confidence" }, renderConfidence(app.confidence, app.isDefault))))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", { key: 'app-' + appNumber + app.iconUrl },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null, appNumber + '.'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: app.iconUrl }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "apps-table__title" }, app.name)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "apps-table-confidence", style: { width: '40%', textOverflow: 'clip' } }, renderConfidence(app.confidence, app.isDefault))));
        });
    };
    var isDefault = props.data[0] && props.data[0].isDefault;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", { className: "apps-table apps-table--desktop " + (isDefault ? 'apps-table--default' : '') },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, t('Number')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, t('App name')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", null, t('Confidence')))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null, renderApps())),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "apps-table apps-table--mobile " + (isDefault ? 'apps-table--default' : '') }, renderApps(true))));
};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DotLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_dotLoader_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_dotLoader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_dotLoader_css__);


var DotLoader = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dot-loader__container" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ball" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ball" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ball" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ball" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ball" })));
};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HiveLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_hiveLoader_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_hiveLoader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_hiveLoader_css__);


var HiveLoader = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "socket" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel center-gel" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c1 r1" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c2 r1" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c3 r1" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c4 r1" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c5 r1" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c6 r1" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c7 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c8 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c9 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c10 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c11 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c12 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c13 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c14 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c15 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c16 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c17 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c18 r2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c19 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c20 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c21 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c22 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c23 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c24 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c25 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c26 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c28 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c29 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c30 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c31 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c32 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c33 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c34 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c35 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c36 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gel c37 r3" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h1" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h2" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "hex-brick h3" }))));
};


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContactModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_modal_css__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_contactModal_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_contactModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_contactModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app__ = __webpack_require__(7);








var ContactModal = function (props) {
    var tCommon = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('common').t;
    var tContext = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('contextDistanceCalculator').t;
    var tAbout = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('about').t;
    var t = Object(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* useTranslation */])('contact').t;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), name = _a[0], setName = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), email = _b[0], setEmail = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), phone = _c[0], setPhone = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''), message = _d[0], setMessage = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eName = _e[0], setEName = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eEmail = _f[0], setEEmail = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), eMessage = _g[0], setEMessage = _g[1];
    var _h = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isSuccess = _h[0], setIsSuccess = _h[1];
    var _j = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isError = _j[0], setIsError = _j[1];
    var utmParameters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__app__["a" /* AppContext */]).utmParameters;
    var handleCloseModal = function () {
        props.toggle();
        setIsSuccess(false);
        setIsError(false);
    };
    var updateErrors = function (name, email, message) {
        setEName(name);
        setEEmail(email);
        setEMessage(message);
    };
    var sendContactForm = function () {
        updateErrors([], [], []);
        if (name && email && message) {
            var placement = 'context_distance_calculator';
            __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].postContactFormData(JSON.stringify({ name: name, email: email, phone: phone, message: message, placement: placement, utm: utmParameters || {} }))
                .then(function () {
                setName('');
                setEmail('');
                setPhone('');
                setMessage('');
                setIsSuccess(true);
                window.dataLayer.push({ 'event': 'form-completed', 'location': 'Calculator' });
            })
                .catch(function () {
                setIsError(true);
            });
        }
        else {
            updateErrors(name ? [] : [tCommon('required field')], email ? [] : [tCommon('required field')], message ? [] : [tCommon('required field')]);
        }
    };
    var renderError = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-upper-block contact-modal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "contact-modal__error-title" }, tContext('An error occurred')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "contact-modal__error-description" }, tContext('Something went wrong'))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-footer" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn-modal-continue", onClick: handleCloseModal }, tCommon('OK'))))); };
    var renderSuccess = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-upper-block contact-modal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "contact-modal__success-title" }, tContext('Message Sent')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "contact-modal__success-description" }, tContext('Thank you for submitting'))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-footer" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn-modal-continue", onClick: handleCloseModal }, tCommon('OK'))))); };
    var renderContactForm = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-upper-block contact-modal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "contact-modal__description" }, Object(__WEBPACK_IMPORTED_MODULE_1__util_util__["t" /* tagger */])(tContext('Fill in the form'), __WEBPACK_IMPORTED_MODULE_1__util_util__["a" /* ACCENT_TEXT */])),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container contact-modal__input" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eName.length > 0 ? ' error-input' : ''), type: "input", name: "name", placeholder: "\u00A0", value: name, onChange: function (e) { return setName(e.currentTarget.value); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tAbout('Full name'))),
            eName && eName.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container contact-modal__input" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: 'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : ''), type: "email", name: "email", placeholder: "\u00A0", value: email, onChange: function (e) { return setEmail(e.currentTarget.value); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tAbout('Email address'))),
            eEmail && eEmail.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-container contact-modal__input" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "contact-input small-text", type: "input", name: "phone", placeholder: "\u00A0", value: phone, onChange: function (e) { return setPhone(e.currentTarget.value); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, tAbout('Phone number'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "contact-input-area-container contact-modal__input" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", { className: 'contact-input contact-textarea small-text' + (eMessage.length > 0 ? ' error-input' : ''), name: "contactMessage", placeholder: "\u00A0", value: message, onChange: function (e) { return setMessage(e.currentTarget.value); } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "contact-input-label" }, t('Message'))),
            eMessage && eMessage.map(function (err) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-small", key: err }, err); })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-footer" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn-modal-continue", onClick: sendContactForm }, tCommon('Send'))))); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'modal' + (props.show ? ' modal-show' : ' modal-hide') },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "modal-card" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "close-modal-btn", onClick: handleCloseModal }),
            isError ? renderError() : isSuccess ? renderSuccess() : renderContactForm())));
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18next__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18next_browser_languagedetector__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18next_xhr_backend__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(1);




__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */]
    .use(__WEBPACK_IMPORTED_MODULE_2_i18next_xhr_backend__["a" /* default */])
    .use(__WEBPACK_IMPORTED_MODULE_1_i18next_browser_languagedetector__["a" /* default */])
    .use(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["a" /* initReactI18next */])
    .init({
    whitelist: ['en', 'ru', 'ja', 'ko', 'zh', 'id'],
    fallbackLng: 'en',
    load: 'languageOnly',
    ns: 'landing',
    // debug: true,
    interpolation: {
        escapeValue: false,
    },
    backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    detection: {
        order: ['path', 'navigator'],
        lookupFromPathIndex: 0,
        checkWhitelist: true
    }
});
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */]);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(220);











var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(args));
  }
};

var Logger =
/*#__PURE__*/
function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Logger);

    this.init(concreteLogger, options);
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, EventEmitter);

    this.observers = {};
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

// http://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */

  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  } // Fallback to default values


  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }

  return target;
}
function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/* eslint-disable */

var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

var ResourceStore =
/*#__PURE__*/
function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ResourceStore);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ResourceStore).call(this));
    EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // <=IE10 fix (unable to call parent constructor)

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      /* eslint no-restricted-syntax: 0 */
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS; // COMPATIBILITY: remove extend in v2.1.0

      if (this.options.compatibilityAPI === 'v1') return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator =
/*#__PURE__*/
function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Translator);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Translator).call(this));
    EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // <=IE10 fix (unable to call parent constructor)

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator || this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options) {
      var _this2 = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        /* eslint prefer-rest-params: 0 */
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {}; // non valid keys handling

      if (keys === undefined || keys === null
      /* || keys === ''*/
      ) return '';
      if (!Array.isArray(keys)) keys = [String(keys)]; // separators

      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator; // get namespace(s)

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1]; // return key on CIMode

      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      } // resolve from store


      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays; // object

      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        } // if we got a separator we loop over children - else we just return object as is
        // as having it set to false means no hierarchy so no lookup for nested values


        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy$$1 = resTypeIsArray ? [] : {}; // apply child translation on a copy

          /* eslint no-restricted-syntax: 0 */

          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy$$1[m] = this.translate(deepKey, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy$$1[m] === deepKey) copy$$1[m] = res[m]; // if nothing found use orginal value as fallback
            }
          }

          res = copy$$1;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        // array special treatment
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options);
      } else {
        // string, empty or null
        var usedDefault = false;
        var usedKey = false; // fallback value

        if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
          usedDefault = true;

          if (options.count !== undefined) {
            var suffix = this.pluralResolver.getSuffix(lng, options.count);
            res = options["defaultValue".concat(suffix)];
          }

          if (!res) res = options.defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        } // save missing


        var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (l) {
                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

                plurals.forEach(function (p) {
                  return send([l], p);
                });
              });
            } else {
              send(lngs, key);
            }
          }
        } // extend


        res = this.extendTranslation(res, keys, options, resolved); // append namespace if still key

        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key); // parseMissingKeyHandler

        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      } // return


      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        // i18next.parsing
        if (options.interpolation) this.interpolator.init(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
          interpolation: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.options.interpolation, options.interpolation)
        })); // interpolate

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options); // nesting

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          return _this3.translate.apply(_this3, arguments);
        }, options);
        if (options.interpolation) this.interpolator.reset();
      } // post process


      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey; // plain key

      var exactUsedKey; // key with context / plural

      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys]; // forEach possible key

      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for namespace \"").concat(usedNS, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace was not yet loaded"), 'This means something IS WRONG in your application setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count); // fallback for plural if context not found

              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix); // get key for context if needed

              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context)); // get key for plural if needed

              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            } // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only


            var possibleKey;
            /* eslint no-cond-assign: 0 */

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil =
/*#__PURE__*/
function () {
  function LanguageUtil(options) {
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.whitelist || false;
    this.logger = baseLogger.create('languageUtils');
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      // http://www.iana.org/assignments/language-tags/language-tags.xhtml
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase(); // if lenght 2 guess it's a country

          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || []; // asume we have an object defining fallbacks

      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this.isWhitelisted(c)) {
          codes.push(c);
        } else {
          _this.logger.warn("rejecting non-whitelisted language code: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

/* eslint-disable */

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver =
/*#__PURE__*/
function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var _this = this;

      var ret = [];
      var rule = this.getRule(code);
      if (!rule) return ret;
      rule.numbers.forEach(function (n) {
        var suffix = _this.getSuffix(code, n);

        ret.push("".concat(key).concat(suffix));
      });
      return ret;
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        // if (rule.numbers.length === 1) return ''; // only singular
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx]; // special treatment for lngs only having singular and plural

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        }; // COMPATIBILITY JSON
        // v1


        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (
        /* v2 */
        this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (
        /* v3 - gettext index */
        this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator =
/*#__PURE__*/
function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }
  /* eslint no-param-reassign: 0 */


  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000; // the regexp

      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      // the regexp
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          return getPathWithDefaults(data, defaultData, key);
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      replaces = 0; // unescape if has unescapePrefix/Suffix

      /* eslint no-cond-assign: 0 */

      while (match = this.regexpUnescape.exec(str)) {
        value = handleFormat(match[1].trim());

        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            var temp = missingInterpolationHandler(str, match, options);
            value = typeof temp === 'string' ? temp : '';
          } else {
            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }

        str = str.replace(match[0], regexSafe(value));
        this.regexpUnescape.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      replaces = 0; // regular escape on demand

      while (match = this.regexp.exec(str)) {
        value = handleFormat(match[1].trim());

        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            var _temp = missingInterpolationHandler(str, match, options);

            value = typeof _temp === 'string' ? _temp : '';
          } else {
            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }

        value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options);

      clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

      delete clonedOptions.defaultValue; // assert we do not get a endless loop on interpolating defaultValue again and again
      // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"

      function handleHasOptions(key, inheritedOptions) {
        if (key.indexOf(',') < 0) return key;
        var p = key.split(',');
        key = p.shift();
        var optionsString = p.join(',');
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.error("failed parsing options string in nesting for key ".concat(key), e);
        } // assert we do not get a endless loop on interpolating defaultValue again and again


        delete clonedOptions.defaultValue;
        return key;
      } // regular escape on demand


      while (match = this.nestingRegexp.exec(str)) {
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions); // is only the nesting key (key1 = '$(key2)') return the value without stringify

        if (value && match[0] === str && typeof value !== 'string') return value; // no string to include or empty

        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        } // Nested keys should not be escaped by default #854
        // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);


        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector =
/*#__PURE__*/
function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Connector);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Connector).call(this));
    EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // <=IE10 fix (unable to call parent constructor)

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      // find what needs to be loaded
      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2; // loaded
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1; // pending

            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var _name$split = name.split('|'),
          _name$split2 = Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_name$split, 2),
          lng = _name$split2[0],
          ns = _name$split2[1];

      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      } // set loaded


      this.state[name] = err ? -1 : 2; // consolidated loading done in this run - only emit once for a loaded namespace

      var loaded = {}; // callback if ready

      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          // only do once per loaded -> this.emit('loaded', q.loaded);
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          /* eslint no-param-reassign: 0 */

          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      }); // emit consolidated loaded event

      this.emit('loaded', loaded); // remove done load requests

      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {}); // noting to load

      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data
        /* = retryFlag */
        && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now

        return null; // pendings will trigger callback
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var _name$split3 = name.split('|'),
          _name$split4 = Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_name$split3, 2),
          lng = _name$split4[0],
          ns = _name$split4[1];

      this.read(lng, ns, 'read', null, null, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" for namespace \"").concat(namespace, "\" as the namespace was not yet loaded"), 'This means something IS WRONG in your application setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      } // ignore non valid keys


      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null
        /* unused callback */
        , Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, options, {
          isUpdate: isUpdate
        }));
      } // write to store to avoid resending


      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    // string or array of namespaces
    whitelist: false,
    // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all',
    // | currentOnly | languageOnly
    preload: false,
    // array with preload languages
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    // allow bundling certain languages that are not remotely fetched
    saveMissing: false,
    // enable to send missing values
    updateMissing: false,
    // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback',
    // 'current' || 'all'
    saveMissingPlurals: true,
    // will save all forms not only singular key
    missingKeyHandler: false,
    // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false,
    // function(str, match)
    postProcess: false,
    // string or array of postProcessor names
    postProcessPassResolved: false,
    // pass resolved object into 'options.i18nResolved' for postprocessor
    returnNull: true,
    // allows null value as valid translation
    returnEmptyString: true,
    // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false,
    // or string to join array
    returnedObjectHandler: false,
    // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false,
    // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[2]) === 'object' || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop

    }
  };
}
/* eslint no-param-reassign: 0 */

function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS]; // extend whitelist with cimode

  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n =
/*#__PURE__*/
function (_EventEmitter) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, I18n);

    _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(I18n).call(this));
    EventEmitter.call(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // <=IE10 fix (unable to call parent constructor)

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(_this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      this.options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      } // init services


      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options); // pipe events from backendConnector

        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options); // pipe events from translator

        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      } // append api


      var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var deferred = defer();

      var load = function load() {
        _this2.changeLanguage(_this2.options.lng, function (err, t) {
          _this2.isInitialized = true;

          _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t); // not rejecting on err (as err is only a loading translation failed warning)

          callback(err, t);
        });
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback(); // avoid loading resources for cimode

        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          // at least load fallbacks in this case
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve(); // not rejecting on err (as err is only a loading translation failed warning)

        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(l) {
        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1]; // we're in cimode so this shall pass

      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      }; // loaded -> SUCCESS


      if (this.hasResourceBundle(lng, ns)) return true; // were not loading at all -> SEMI SUCCESS

      if (!this.services.backendConnector.backend) return true; // failed loading ns - but at least fallback is not pending -> SEMI SUCCESS

      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      }); // Exit early if all given languages are already preloaded

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
    /* eslint class-methods-use-this: 0 */

  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options; // sync options

      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

/* harmony default export */ __webpack_exports__["a"] = (i18next);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__(48);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(Object(source));

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(49);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(215);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(219);



function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(223);



function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(36);



var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

var cookie = {
  create: function create(name, value, minutes, domain) {
    var expires;

    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    } else expires = '';

    domain = domain ? 'domain=' + domain + ';' : '';
    document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
  },
  read: function read(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  },
  remove: function remove(name) {
    this.create(name, '', -1);
  }
};
var cookie$1 = {
  name: 'cookie',
  lookup: function lookup(options) {
    var found;

    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
    }
  }
};

var querystring = {
  name: 'querystring',
  lookup: function lookup(options) {
    var found;

    if (typeof window !== 'undefined') {
      var query = window.location.search.substring(1);
      var params = query.split('&');

      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');

        if (pos > 0) {
          var key = params[i].substring(0, pos);

          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }

    return found;
  }
};

var hasLocalStorageSupport;

try {
  hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
  var testKey = 'i18next.translate.boo';
  window.localStorage.setItem(testKey, 'foo');
  window.localStorage.removeItem(testKey);
} catch (e) {
  hasLocalStorageSupport = false;
}

var localStorage = {
  name: 'localStorage',
  lookup: function lookup(options) {
    var found;

    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

var navigator$1 = {
  name: 'navigator',
  lookup: function lookup(options) {
    var found = [];

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }

      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }

      if (navigator.language) {
        found.push(navigator.language);
      }
    }

    return found.length > 0 ? found : undefined;
  }
};

var htmlTag = {
  name: 'htmlTag',
  lookup: function lookup(options) {
    var found;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }

    return found;
  }
};

var path = {
  name: 'path',
  lookup: function lookup(options) {
    var found;

    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);

      if (language instanceof Array) {
        if (typeof options.lookupFromPathIndex === 'number') {
          if (typeof language[options.lookupFromPathIndex] !== 'string') {
            return undefined;
          }

          found = language[options.lookupFromPathIndex].replace('/', '');
        } else {
          found = language[0].replace('/', '');
        }
      }
    }

    return found;
  }
};

var subdomain = {
  name: 'subdomain',
  lookup: function lookup(options) {
    var found;

    if (typeof window !== 'undefined') {
      var language = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);

      if (language instanceof Array) {
        if (typeof options.lookupFromSubdomainIndex === 'number') {
          found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
        } else {
          found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
        }
      }
    }

    return found;
  }
};

function getDefaults() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'],
    //cookieMinutes: 10,
    //cookieDomain: 'myDomain'
    checkWhitelist: true
  };
}

var Browser =
/*#__PURE__*/
function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Browser);

    this.type = 'languageDetector';
    this.detectors = {};
    this.init(services, options);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Browser, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults()); // backwards compatibility

      if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
      this.i18nOptions = i18nOptions;
      this.addDetector(cookie$1);
      this.addDetector(querystring);
      this.addDetector(localStorage);
      this.addDetector(navigator$1);
      this.addDetector(htmlTag);
      this.addDetector(path);
      this.addDetector(subdomain);
    }
  }, {
    key: "addDetector",
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: "detect",
    value: function detect(detectionOrder) {
      var _this = this;

      if (!detectionOrder) detectionOrder = this.options.order;
      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);

          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });
      var found;
      detected.forEach(function (lng) {
        if (found) return;

        var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);

        if (!_this.options.checkWhitelist || _this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
      });

      if (!found) {
        var fallbacks = this.i18nOptions.fallbackLng;
        if (typeof fallbacks === 'string') fallbacks = [fallbacks];
        if (!fallbacks) fallbacks = [];

        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') {
          found = fallbacks[0];
        } else {
          found = fallbacks[0] || fallbacks["default"] && fallbacks["default"][0];
        }
      }

      return found;
    }
  }, {
    key: "cacheUserLanguage",
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;

      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);

  return Browser;
}();

Browser.type = 'languageDetector';

/* harmony default export */ __webpack_exports__["a"] = (Browser);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(34);





var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function addQueryString(url, params) {
  if (params && Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(params) === 'object') {
    var queryString = '',
        e = encodeURIComponent; // Must encode data

    for (var paramName in params) {
      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
    }

    if (!queryString) {
      return url;
    }

    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }

  return url;
} // https://gist.github.com/Xeoncross/7663273


function ajax(url, options, callback, data, cache) {
  if (data && Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(data) === 'object') {
    if (!cache) {
      data['_t'] = new Date();
    } // URL encoded form data must be in querystring format


    data = addQueryString('', data).slice(1);
  }

  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }

  try {
    var x;

    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
    }

    x.open(data ? 'POST' : 'GET', url, 1);

    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }

    x.withCredentials = !!options.withCredentials;

    if (data) {
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }

    if (x.overrideMimeType) {
      x.overrideMimeType("application/json");
    }

    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;

    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }

    x.onreadystatechange = function () {
      x.readyState > 3 && callback && callback(x.responseText, x);
    };

    x.send(data);
  } catch (e) {
    console && console.log(e);
  }
}

function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: JSON.parse,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, key, fallbackValue || '');
    },
    crossDomain: false,
    ajax: ajax
  };
}

var Backend =
/*#__PURE__*/
function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Backend);

    this.init(services, options);
    this.type = 'backend';
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Backend, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults());
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.options.loadPath;

      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }

      var url = this.services.interpolator.interpolate(loadPath, {
        lng: languages.join('+'),
        ns: namespaces.join('+')
      });
      this.loadUrl(url, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var loadPath = this.options.loadPath;

      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath([language], [namespace]);
      }

      var url = this.services.interpolator.interpolate(loadPath, {
        lng: language,
        ns: namespace
      });
      this.loadUrl(url, callback);
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback) {
      var _this = this;

      this.options.ajax(url, this.options, function (data, xhr) {
        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true
        /* retry */
        );
        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false
        /* no retry */
        );
        var ret, err;

        try {
          ret = _this.options.parse(data, url);
        } catch (e) {
          err = 'failed parsing ' + url + ' to json';
        }

        if (err) return callback(err, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue) {
      var _this2 = this;

      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      languages.forEach(function (lng) {
        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, {
          lng: lng,
          ns: namespace
        });

        _this2.options.ajax(url, _this2.options, function (data, xhr) {//const statusCode = xhr.status.toString();
          // TODO: if statusCode === 4xx do log
        }, payload);
      });
    }
  }]);

  return Backend;
}();

Backend.type = 'backend';

/* harmony default export */ __webpack_exports__["a"] = (Backend);


/***/ }),
/* 226 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(107);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.387a9d10.js